import { $ as InvalidCryptoStoreError, $n as content_helpers_exports, $r as deepCopy, $t as CallEvent, A as UNSTABLE_MSC4133_EXTENDED_PROFILES, An as parseErrorResponse, Ar as RelationType, At as HistoryVisibility, B as validateAuthMetadataAndKeys, Bn as Method, Br as UNSTABLE_MSC3089_BRANCH, Bt as AutoDiscoveryAction, C as MatrixClient, Cn as ServerCapabilities, Cr as EVENT_VISIBILITY_CHANGE_TYPE, Ct as M_BEACON, D as UNSTABLE_MSC2666_QUERY_MUTUAL_ROOMS, Dn as MediaPrefix, Dr as MsgType, Dt as MediaHandlerEvent, E as UNSTABLE_MSC2666_MUTUAL_ROOMS, En as IdentityPrefix, Er as MSC3912_RELATION_BASED_REDACTIONS_PROP, Et as SlidingSyncEvent, F as threadIdForReceipt, Fn as HTTPError, Fr as UNSIGNED_THREAD_ID_FIELD, Ft as UpdateDelayedEventAction, G as generateScope, Gn as M_POLL_KIND_DISCLOSED, Gr as require_events, Gt as ConditionKind, H as generateAuthorizationParams, Hn as PollEvent, Hr as UNSTABLE_MSC3089_TREE_SUBTYPE, Ht as MAXIMUM_MATRIX_VERSION, I as OidcTokenRefresher, In as MatrixError, Ir as UNSTABLE_ELEMENT_FUNCTIONAL_USERS, It as isSendDelayedEventRequestOpts, J as validateBearerTokenResponse, Jn as M_POLL_START, Jr as logger, Jt as PushRuleActionName, K as decodeIdToken, Kn as M_POLL_KIND_UNDISCLOSED, Kr as DebugLogger, Kt as ConditionOperator, L as DEVICE_CODE_SCOPE, Ln as TokenRefreshError, Lr as UNSTABLE_MSC2716_MARKER, Lt as SearchResult, M as UNSTABLE_MSC4354_STICKY_EVENTS, Mn as timeoutSignal, Mr as RoomType, Mt as Preset, N as fixNotificationCountOnDecryption, Nn as HttpApiEvent, Nr as ToDeviceMessageId, Nt as RestrictedAllowType, O as UNSTABLE_MSC2666_SHARED_ROOMS, On as anySignal, Or as PUSHER_DEVICE_ID, Ot as SearchOrderBy, P as inMainTimelineForReceipt, Pn as ConnectionError, Pr as UNSIGNED_MEMBERSHIP_FIELD, Pt as Visibility, Q as ClientStoppedError, Qn as isTimestampInDuration, Qr as MapWithDefault, Qt as isDmMemberCountCondition, R as registerOidcClient, Rn as TokenRefreshLogoutError, Rr as UNSTABLE_MSC3088_ENABLED, Rt as SERVICE_TYPES, S as GET_LOGIN_TOKEN_CAPABILITY, Sn as RoomVersionStability, Sr as KnownMembership, St as MatrixScheduler, T as STABLE_MSC4133_EXTENDED_PROFILES, Tn as ClientPrefix, Tr as LOCAL_NOTIFICATION_SETTINGS_PREFIX, Tt as SlidingSyncSdk, U as generateAuthorizationUrl, Un as isPollEvent, Ur as EventEmitterEvents, Ut as MINIMUM_MATRIX_VERSION, V as completeAuthorizationCodeGrant, Vn as Poll, Vr as UNSTABLE_MSC3089_LEAF, Vt as AutoDiscoveryError, W as generateOidcAuthorizationUrl, Wn as M_POLL_END, Wr as TypedEventEmitter, Wt as SUPPORTED_MATRIX_VERSIONS, X as validateStoredUserState, Xn as BeaconEvent, Xr as MemoryCryptoStore, Xt as RuleId, Y as validateIdToken, Yn as Beacon, Yr as getHttpUriForMxc, Yt as PushRuleKind, Z as OidcError, Zn as getBeaconInfoIdentifier, Zt as TweakName, _ as ThreadEvent, _i as __toESM, _n as KNOWN_SAFE_ROOM_VERSION, _r as User, a as DeviceVerification, an as GroupCallStatsReportEvent, ar as isEventTypeSame, at as secret_storage_exports, b as threadFilterTypeToFilter, bn as RoomEvent, br as RoomMember, c as MAX_STICKY_DURATION_MS, ci as LocationAssetType, cn as CallFeedEvent, di as M_TIMESTAMP, dn as encodeBase64, dr as DuplicateStrategy, en as createNewMatrixCall, er as M_TOPIC, et as InvalidCryptoStoreState, f as FILTER_RELATED_BY_REL_TYPES, fi as UnstableValue, fn as encodeUnpaddedBase64, fr as EventTimelineSet, g as Thread, gi as __export, gn as SyncState, gr as EventTimeline, h as THREAD_RELATION_TYPE, hi as __commonJSMin, hn as SyncApi, hr as Direction, i as Device, ii as recursiveMapToObject, in as GroupCallState, ir as REFERENCE_RELATION, j as UNSTABLE_MSC4140_DELAYED_EVENTS, jn as retryNetworkOperation, jr as RoomCreateTypeField, jt as JoinRule, k as UNSTABLE_MSC3852_LAST_SEEN_UA, kn as calculateRetryBackoff, kr as PUSHER_ENABLED, kt as GuestAccess, l as MatrixEvent, li as M_ASSET, lr as RoomSummary, m as FeatureSupport, mi as _asyncToGenerator, mn as SetPresence, mr as RelationsEvent, n as LocalStorageCryptoStore, nn as GroupCallEvent, nr as M_MESSAGE, nt as UnsupportedDelayedEventsEndpointError, o as RoomState, oi as MAIN_ROOM_TIMELINE, on as GroupCallType, or as Filter, p as FILTER_RELATED_BY_SENDERS, pi as _defineProperty, pn as encodeUnpaddedBase64Url, pr as Relations, q as validateAuthMetadata, qn as M_POLL_RESPONSE, qt as DMMemberCountCondition, r as exists, ri as promiseTry, rn as GroupCallIntent, rr as M_TEXT, rt as UnsupportedStickyEventsEndpointError, s as RoomStateEvent, si as ReceiptType, sn as StatsReport, sr as UNREAD_THREAD_NOTIFICATIONS, t as IndexedDBCryptoStore, ti as isSupportedReceiptType, tn as GroupCall, tr as M_HTML, tt as KeySignatureUploadError, u as MatrixEventEvent, ui as M_LOCATION, un as decodeBase64, ur as EventStatus, v as ThreadFilterType, vn as NotificationCountType, vr as UserEvent, w as PendingEventOrdering, wn as MatrixHttpApi, wr as EventType, wt as M_BEACON_INFO, x as ClientEvent, xn as RoomNameType, xr as RoomMemberEvent, y as determineFeatureSupport, yn as Room, yr as MXID_PATTERN, z as discoverAndValidateOIDCIssuerWellKnown, zn as safeGetRetryAfterMs, zr as UNSTABLE_MSC3088_PURPOSE, zt as AutoDiscovery } from "./indexeddb-crypto-store-B5yWDofq.js";
import { createContext, useContext } from "react";
function isValidFilterId(e) {
	return typeof e == "string" && !!e && e !== "undefined" && e !== "null" || typeof e == "number";
}
var MemoryStore = class {
	constructor() {
		var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
		_defineProperty(this, "rooms", {}), _defineProperty(this, "users", {}), _defineProperty(this, "syncToken", null), _defineProperty(this, "filters", new MapWithDefault(() => /* @__PURE__ */ new Map())), _defineProperty(this, "accountData", /* @__PURE__ */ new Map()), _defineProperty(this, "localStorage", void 0), _defineProperty(this, "oobMembers", /* @__PURE__ */ new Map()), _defineProperty(this, "pendingEvents", {}), _defineProperty(this, "clientOptions", void 0), _defineProperty(this, "pendingToDeviceBatches", []), _defineProperty(this, "nextToDeviceBatchId", 0), _defineProperty(this, "createUser", void 0), _defineProperty(this, "onRoomMember", (e, p, m) => {
			if (m.membership !== KnownMembership.Invite) {
				var h = this.users[m.userId] || this.createUser?.call(this, m.userId);
				m.name && (h.setDisplayName(m.name), m.events.member && h.setRawDisplayName(m.events.member.getDirectionalContent().displayname)), m.events.member && m.events.member.getContent().avatar_url && h.setAvatarUrl(m.events.member.getContent().avatar_url), this.users[h.userId] = h;
			}
		}), this.localStorage = e.localStorage;
	}
	getSyncToken() {
		return this.syncToken;
	}
	isNewlyCreated() {
		return Promise.resolve(!0);
	}
	setSyncToken(e) {
		this.syncToken = e;
	}
	storeRoom(e) {
		this.rooms[e.roomId] = e, e.currentState.on(RoomStateEvent.Members, this.onRoomMember), e.currentState.getMembers().forEach((p) => {
			this.onRoomMember(null, e.currentState, p);
		});
	}
	setUserCreator(e) {
		this.createUser = e;
	}
	getRoom(e) {
		return this.rooms[e] || null;
	}
	getRooms() {
		return Object.values(this.rooms);
	}
	removeRoom(e) {
		this.rooms[e] && this.rooms[e].currentState.removeListener(RoomStateEvent.Members, this.onRoomMember), delete this.rooms[e];
	}
	getRoomSummaries() {
		return Object.values(this.rooms).map(function(e) {
			return e.summary;
		});
	}
	storeUser(e) {
		this.users[e.userId] = e;
	}
	getUser(e) {
		return this.users[e] || null;
	}
	getUsers() {
		return Object.values(this.users);
	}
	scrollback(e, p) {
		return [];
	}
	storeEvents(e, p, m, h) {}
	storeFilter(e) {
		!(e != null && e.userId) || !(e != null && e.filterId) || this.filters.getOrCreate(e.userId).set(e.filterId, e);
	}
	getFilter(e, p) {
		return this.filters.get(e)?.get(p) || null;
	}
	getFilterIdByName(e) {
		if (!this.localStorage) return null;
		var p = "mxjssdk_memory_filter_" + e;
		try {
			var m = this.localStorage.getItem(p);
			if (isValidFilterId(m)) return m;
		} catch {}
		return null;
	}
	setFilterIdByName(e, p) {
		if (this.localStorage) {
			var m = "mxjssdk_memory_filter_" + e;
			try {
				isValidFilterId(p) ? this.localStorage.setItem(m, p) : this.localStorage.removeItem(m);
			} catch {}
		}
	}
	storeAccountDataEvents(e) {
		e.forEach((e) => {
			Object.keys(e.getContent()).length ? this.accountData.set(e.getType(), e) : this.accountData.delete(e.getType());
		});
	}
	getAccountData(e) {
		return this.accountData.get(e);
	}
	setSyncData(e) {
		return Promise.resolve();
	}
	wantsSave() {
		return !1;
	}
	save(e) {
		return Promise.resolve();
	}
	startup() {
		return Promise.resolve();
	}
	getSavedSync() {
		return Promise.resolve(null);
	}
	getSavedSyncToken() {
		return Promise.resolve(null);
	}
	deleteAllData() {
		return this.rooms = {}, this.users = {}, this.syncToken = null, this.filters = new MapWithDefault(() => /* @__PURE__ */ new Map()), this.accountData = /* @__PURE__ */ new Map(), Promise.resolve();
	}
	getOutOfBandMembers(e) {
		return Promise.resolve(this.oobMembers.get(e) || null);
	}
	setOutOfBandMembers(e, p) {
		return this.oobMembers.set(e, p), Promise.resolve();
	}
	clearOutOfBandMembers(e) {
		return this.oobMembers.delete(e), Promise.resolve();
	}
	getClientOptions() {
		return Promise.resolve(this.clientOptions);
	}
	storeClientOptions(e) {
		return this.clientOptions = Object.assign({}, e), Promise.resolve();
	}
	getPendingEvents(e) {
		var p = this;
		return _asyncToGenerator(function* () {
			return p.pendingEvents[e] ?? [];
		})();
	}
	setPendingEvents(e, p) {
		var m = this;
		return _asyncToGenerator(function* () {
			m.pendingEvents[e] = p;
		})();
	}
	saveToDeviceBatches(e) {
		for (var p of e) this.pendingToDeviceBatches.push({
			id: this.nextToDeviceBatchId++,
			eventType: p.eventType,
			txnId: p.txnId,
			batch: p.batch
		});
		return Promise.resolve();
	}
	getOldestToDeviceBatch() {
		var e = this;
		return _asyncToGenerator(function* () {
			return e.pendingToDeviceBatches.length === 0 ? null : e.pendingToDeviceBatches[0];
		})();
	}
	removeToDeviceBatch(e) {
		return this.pendingToDeviceBatches = this.pendingToDeviceBatches.filter((p) => p.id !== e), Promise.resolve();
	}
	destroy() {
		return _asyncToGenerator(function* () {})();
	}
}, require_WidgetApiDirection = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.invertedDirection = m;
	var p = /* @__PURE__ */ function(e) {
		return e.ToWidget = "toWidget", e.FromWidget = "fromWidget", e;
	}({});
	e.WidgetApiDirection = p;
	function m(e) {
		if (e === p.ToWidget) return p.FromWidget;
		if (e === p.FromWidget) return p.ToWidget;
		throw Error("Invalid direction");
	}
})), require_ApiVersion = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var p = /* @__PURE__ */ function(e) {
		return e.Prerelease1 = "0.0.1", e.Prerelease2 = "0.0.2", e;
	}({});
	e.MatrixApiVersion = p;
	var m = /* @__PURE__ */ function(e) {
		return e.MSC2762 = "org.matrix.msc2762", e.MSC2762_UPDATE_STATE = "org.matrix.msc2762_update_state", e.MSC2871 = "org.matrix.msc2871", e.MSC2873 = "org.matrix.msc2873", e.MSC2931 = "org.matrix.msc2931", e.MSC2974 = "org.matrix.msc2974", e.MSC2876 = "org.matrix.msc2876", e.MSC3819 = "org.matrix.msc3819", e.MSC3846 = "town.robin.msc3846", e.MSC3869 = "org.matrix.msc3869", e.MSC3973 = "org.matrix.msc3973", e.MSC4039 = "org.matrix.msc4039", e;
	}({});
	e.UnstableApiVersion = m, e.CurrentApiVersions = [
		p.Prerelease1,
		p.Prerelease2,
		m.MSC2762,
		m.MSC2762_UPDATE_STATE,
		m.MSC2871,
		m.MSC2873,
		m.MSC2931,
		m.MSC2974,
		m.MSC2876,
		m.MSC3819,
		m.MSC3846,
		m.MSC3869,
		m.MSC3973,
		m.MSC4039
	];
})), require_PostmessageTransport = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var p = require_events(), m = require_lib(), h = ["message"];
	function g(e) {
		"@babel/helpers - typeof";
		return g = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
			return typeof e;
		} : function(e) {
			return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
		}, g(e);
	}
	function _(e, p) {
		if (e == null) return {};
		var m = v(e, p), h, g;
		if (Object.getOwnPropertySymbols) {
			var _ = Object.getOwnPropertySymbols(e);
			for (g = 0; g < _.length; g++) h = _[g], !(p.indexOf(h) >= 0) && Object.prototype.propertyIsEnumerable.call(e, h) && (m[h] = e[h]);
		}
		return m;
	}
	function v(e, p) {
		if (e == null) return {};
		var m = {}, h = Object.keys(e), g, _;
		for (_ = 0; _ < h.length; _++) g = h[_], !(p.indexOf(g) >= 0) && (m[g] = e[g]);
		return m;
	}
	function y(e, p) {
		var m = Object.keys(e);
		if (Object.getOwnPropertySymbols) {
			var h = Object.getOwnPropertySymbols(e);
			p && (h = h.filter(function(p) {
				return Object.getOwnPropertyDescriptor(e, p).enumerable;
			})), m.push.apply(m, h);
		}
		return m;
	}
	function b(e) {
		for (var p = 1; p < arguments.length; p++) {
			var m = arguments[p] == null ? {} : arguments[p];
			p % 2 ? y(Object(m), !0).forEach(function(p) {
				j(e, p, m[p]);
			}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(m)) : y(Object(m)).forEach(function(p) {
				Object.defineProperty(e, p, Object.getOwnPropertyDescriptor(m, p));
			});
		}
		return e;
	}
	function x(e, p) {
		if (!(e instanceof p)) throw TypeError("Cannot call a class as a function");
	}
	function S(e, p) {
		for (var m = 0; m < p.length; m++) {
			var h = p[m];
			h.enumerable = h.enumerable || !1, h.configurable = !0, "value" in h && (h.writable = !0), Object.defineProperty(e, M(h.key), h);
		}
	}
	function C(e, p, m) {
		return p && S(e.prototype, p), m && S(e, m), Object.defineProperty(e, "prototype", { writable: !1 }), e;
	}
	function w(e, p) {
		if (typeof p != "function" && p !== null) throw TypeError("Super expression must either be null or a function");
		e.prototype = Object.create(p && p.prototype, { constructor: {
			value: e,
			writable: !0,
			configurable: !0
		} }), Object.defineProperty(e, "prototype", { writable: !1 }), p && T(e, p);
	}
	function T(e, p) {
		return T = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, p) {
			return e.__proto__ = p, e;
		}, T(e, p);
	}
	function E(e) {
		var p = k();
		return function() {
			var m = A(e), h;
			if (p) {
				var g = A(this).constructor;
				h = Reflect.construct(m, arguments, g);
			} else h = m.apply(this, arguments);
			return D(this, h);
		};
	}
	function D(e, p) {
		if (p && (g(p) === "object" || typeof p == "function")) return p;
		if (p !== void 0) throw TypeError("Derived constructors may only return object or undefined");
		return O(e);
	}
	function O(e) {
		if (e === void 0) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
		return e;
	}
	function k() {
		if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
		if (typeof Proxy == "function") return !0;
		try {
			return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
		} catch {
			return !1;
		}
	}
	function A(e) {
		return A = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
			return e.__proto__ || Object.getPrototypeOf(e);
		}, A(e);
	}
	function j(e, p, m) {
		return p = M(p), p in e ? Object.defineProperty(e, p, {
			value: m,
			enumerable: !0,
			configurable: !0,
			writable: !0
		}) : e[p] = m, e;
	}
	function M(e) {
		var p = N(e, "string");
		return g(p) === "symbol" ? p : String(p);
	}
	function N(e, p) {
		if (g(e) !== "object" || e === null) return e;
		var m = e[Symbol.toPrimitive];
		if (m !== void 0) {
			var h = m.call(e, p || "default");
			if (g(h) !== "object") return h;
			throw TypeError("@@toPrimitive must return a primitive value.");
		}
		return (p === "string" ? String : Number)(e);
	}
	e.PostmessageTransport = /* @__PURE__ */ function(e) {
		w(g, e);
		var p = E(g);
		function g(e, h, _, v) {
			var y;
			return x(this, g), y = p.call(this), y.sendDirection = e, y.transportWindow = _, y.inboundWindow = v, j(O(y), "strictOriginCheck", !1), j(O(y), "targetOrigin", "*"), j(O(y), "timeoutSeconds", 10), j(O(y), "_ready", !1), j(O(y), "_widgetId", void 0), j(O(y), "outboundRequests", /* @__PURE__ */ new Map()), j(O(y), "stopController", new AbortController()), j(O(y), "handleMessage", function(e) {
				if (!y.stopController.signal.aborted && e.data && !(y.strictOriginCheck && e.origin !== globalThis.origin)) {
					var p = e.data;
					if (!(!p.action || !p.requestId || !p.widgetId)) if (p.response) {
						if (p.api !== y.sendDirection) return;
						y.handleResponse(p);
					} else {
						var h = p;
						if (h.api !== (0, m.invertedDirection)(y.sendDirection)) return;
						y.handleRequest(h);
					}
				}
			}), y._widgetId = h, y;
		}
		return C(g, [
			{
				key: "ready",
				get: function() {
					return this._ready;
				}
			},
			{
				key: "widgetId",
				get: function() {
					return this._widgetId || null;
				}
			},
			{
				key: "nextRequestId",
				get: function() {
					for (var e = `widgetapi-${Date.now()}`, p = 0, m = e; this.outboundRequests.has(m);) m = `${e}-${p++}`;
					return this.outboundRequests.set(m, null), m;
				}
			},
			{
				key: "sendInternal",
				value: function(e) {
					console.log(`[PostmessageTransport] Sending object to ${this.targetOrigin}: `, e), this.transportWindow.postMessage(e, this.targetOrigin);
				}
			},
			{
				key: "reply",
				value: function(e, p) {
					return this.sendInternal(b(b({}, e), {}, { response: p }));
				}
			},
			{
				key: "send",
				value: function(e, p) {
					return this.sendComplete(e, p).then(function(e) {
						return e.response;
					});
				}
			},
			{
				key: "sendComplete",
				value: function(e, p) {
					var h = this;
					if (!this.ready || !this.widgetId) return Promise.reject(/* @__PURE__ */ Error("Not ready or unknown widget ID"));
					var g = {
						api: this.sendDirection,
						widgetId: this.widgetId,
						requestId: this.nextRequestId,
						action: e,
						data: p
					};
					return e === m.WidgetApiToWidgetAction.UpdateVisibility && (g.visible = p.visible), new Promise(function(e, p) {
						var m = function(p) {
							b(), e(p);
						}, _ = function(e) {
							b(), p(e);
						}, v = setTimeout(function() {
							return _(/* @__PURE__ */ Error("Request timed out"));
						}, (h.timeoutSeconds || 1) * 1e3), y = function() {
							return _(/* @__PURE__ */ Error("Transport stopped"));
						};
						h.stopController.signal.addEventListener("abort", y);
						var b = function() {
							h.outboundRequests.delete(g.requestId), clearTimeout(v), h.stopController.signal.removeEventListener("abort", y);
						};
						h.outboundRequests.set(g.requestId, {
							request: g,
							resolve: m,
							reject: _
						}), h.sendInternal(g);
					});
				}
			},
			{
				key: "start",
				value: function() {
					this.inboundWindow.addEventListener("message", this.handleMessage), this._ready = !0;
				}
			},
			{
				key: "stop",
				value: function() {
					this._ready = !1, this.stopController.abort(), this.inboundWindow.removeEventListener("message", this.handleMessage);
				}
			},
			{
				key: "handleRequest",
				value: function(e) {
					if (this.widgetId) {
						if (this.widgetId !== e.widgetId) return;
					} else this._widgetId = e.widgetId;
					this.emit("message", new CustomEvent("message", { detail: e }));
				}
			},
			{
				key: "handleResponse",
				value: function(e) {
					if (e.widgetId === this.widgetId) {
						var p = this.outboundRequests.get(e.requestId);
						if (p) if ((0, m.isErrorResponse)(e.response)) {
							var g = e.response.error, v = g.message, y = _(g, h);
							p.reject(new m.WidgetApiResponseError(v, y));
						} else p.resolve(e);
					}
				}
			}
		]), g;
	}(p.EventEmitter);
})), require_WidgetApiAction = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.WidgetApiToWidgetAction = /* @__PURE__ */ function(e) {
		return e.SupportedApiVersions = "supported_api_versions", e.Capabilities = "capabilities", e.NotifyCapabilities = "notify_capabilities", e.ThemeChange = "theme_change", e.LanguageChange = "language_change", e.TakeScreenshot = "screenshot", e.UpdateVisibility = "visibility", e.OpenIDCredentials = "openid_credentials", e.WidgetConfig = "widget_config", e.CloseModalWidget = "close_modal", e.ButtonClicked = "button_clicked", e.SendEvent = "send_event", e.SendToDevice = "send_to_device", e.UpdateState = "update_state", e.UpdateTurnServers = "update_turn_servers", e;
	}({}), e.WidgetApiFromWidgetAction = /* @__PURE__ */ function(e) {
		return e.SupportedApiVersions = "supported_api_versions", e.ContentLoaded = "content_loaded", e.SendSticker = "m.sticker", e.UpdateAlwaysOnScreen = "set_always_on_screen", e.GetOpenIDCredentials = "get_openid", e.CloseModalWidget = "close_modal", e.OpenModalWidget = "open_modal", e.SetModalButtonEnabled = "set_button_enabled", e.SendEvent = "send_event", e.SendToDevice = "send_to_device", e.WatchTurnServers = "watch_turn_servers", e.UnwatchTurnServers = "unwatch_turn_servers", e.BeeperReadRoomAccountData = "com.beeper.read_room_account_data", e.MSC2876ReadEvents = "org.matrix.msc2876.read_events", e.MSC2931Navigate = "org.matrix.msc2931.navigate", e.MSC2974RenegotiateCapabilities = "org.matrix.msc2974.request_capabilities", e.MSC3869ReadRelations = "org.matrix.msc3869.read_relations", e.MSC3973UserDirectorySearch = "org.matrix.msc3973.user_directory_search", e.MSC4039GetMediaConfigAction = "org.matrix.msc4039.get_media_config", e.MSC4039UploadFileAction = "org.matrix.msc4039.upload_file", e.MSC4039DownloadFileAction = "org.matrix.msc4039.download_file", e.MSC4157UpdateDelayedEvent = "org.matrix.msc4157.update_delayed_event", e;
	}({});
})), require_GetOpenIDAction = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.OpenIDRequestState = /* @__PURE__ */ function(e) {
		return e.Allowed = "allowed", e.Blocked = "blocked", e.PendingUserConfirmation = "request", e;
	}({});
})), require_WidgetType = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.MatrixWidgetType = /* @__PURE__ */ function(e) {
		return e.Custom = "m.custom", e.JitsiMeet = "m.jitsi", e.Stickerpicker = "m.stickerpicker", e;
	}({});
})), require_ModalWidgetActions = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.BuiltInModalButtonID = /* @__PURE__ */ function(e) {
		return e.Close = "m.close", e;
	}({});
})), require_WidgetEventCapability = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	function p(e) {
		"@babel/helpers - typeof";
		return p = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
			return typeof e;
		} : function(e) {
			return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
		}, p(e);
	}
	function m(e, p) {
		var m = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
		if (!m) {
			if (Array.isArray(e) || (m = h(e)) || p && e && typeof e.length == "number") {
				m && (e = m);
				var g = 0, _ = function() {};
				return {
					s: _,
					n: function() {
						return g >= e.length ? { done: !0 } : {
							done: !1,
							value: e[g++]
						};
					},
					e: function(e) {
						throw e;
					},
					f: _
				};
			}
			throw TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
		}
		var v = !0, y = !1, b;
		return {
			s: function() {
				m = m.call(e);
			},
			n: function() {
				var e = m.next();
				return v = e.done, e;
			},
			e: function(e) {
				y = !0, b = e;
			},
			f: function() {
				try {
					!v && m.return != null && m.return();
				} finally {
					if (y) throw b;
				}
			}
		};
	}
	function h(e, p) {
		if (e) {
			if (typeof e == "string") return g(e, p);
			var m = Object.prototype.toString.call(e).slice(8, -1);
			if (m === "Object" && e.constructor && (m = e.constructor.name), m === "Map" || m === "Set") return Array.from(e);
			if (m === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(m)) return g(e, p);
		}
	}
	function g(e, p) {
		(p == null || p > e.length) && (p = e.length);
		for (var m = 0, h = Array(p); m < p; m++) h[m] = e[m];
		return h;
	}
	function _(e, p) {
		if (!(e instanceof p)) throw TypeError("Cannot call a class as a function");
	}
	function v(e, p) {
		for (var m = 0; m < p.length; m++) {
			var h = p[m];
			h.enumerable = h.enumerable || !1, h.configurable = !0, "value" in h && (h.writable = !0), Object.defineProperty(e, b(h.key), h);
		}
	}
	function y(e, p, m) {
		return p && v(e.prototype, p), m && v(e, m), Object.defineProperty(e, "prototype", { writable: !1 }), e;
	}
	function b(e) {
		var m = x(e, "string");
		return p(m) === "symbol" ? m : String(m);
	}
	function x(e, m) {
		if (p(e) !== "object" || e === null) return e;
		var h = e[Symbol.toPrimitive];
		if (h !== void 0) {
			var g = h.call(e, m || "default");
			if (p(g) !== "object") return g;
			throw TypeError("@@toPrimitive must return a primitive value.");
		}
		return (m === "string" ? String : Number)(e);
	}
	var S = /* @__PURE__ */ function(e) {
		return e.Event = "event", e.State = "state_event", e.ToDevice = "to_device", e.RoomAccount = "room_account", e;
	}({});
	e.EventKind = S;
	var C = /* @__PURE__ */ function(e) {
		return e.Send = "send", e.Receive = "receive", e;
	}({});
	e.EventDirection = C, e.WidgetEventCapability = /* @__PURE__ */ function() {
		function e(p, m, h, g, v) {
			_(this, e), this.direction = p, this.eventType = m, this.kind = h, this.keyStr = g, this.raw = v;
		}
		return y(e, [
			{
				key: "matchesAsStateEvent",
				value: function(e, p, m) {
					return this.kind !== S.State || this.direction !== e || this.eventType !== p ? !1 : this.keyStr === null || this.keyStr === m;
				}
			},
			{
				key: "matchesAsToDeviceEvent",
				value: function(e, p) {
					return !(this.kind !== S.ToDevice || this.direction !== e || this.eventType !== p);
				}
			},
			{
				key: "matchesAsRoomEvent",
				value: function(e, p) {
					var m = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
					if (this.kind !== S.Event || this.direction !== e || this.eventType !== p) return !1;
					if (this.eventType === "m.room.message") {
						if (this.keyStr === null || this.keyStr === m) return !0;
					} else return !0;
					return !1;
				}
			},
			{
				key: "matchesAsRoomAccountData",
				value: function(e, p) {
					return !(this.kind !== S.RoomAccount || this.direction !== e || this.eventType !== p);
				}
			}
		], [
			{
				key: "forStateEvent",
				value: function(p, m, h) {
					m = m.replace(/#/g, "\\#"), h = h == null ? "" : `#${h}`;
					var g = `org.matrix.msc2762.${p}.state_event:${m}${h}`;
					return e.findEventCapabilities([g])[0];
				}
			},
			{
				key: "forToDeviceEvent",
				value: function(p, m) {
					var h = `org.matrix.msc3819.${p}.to_device:${m}`;
					return e.findEventCapabilities([h])[0];
				}
			},
			{
				key: "forRoomEvent",
				value: function(p, m) {
					var h = `org.matrix.msc2762.${p}.event:${m}`;
					return e.findEventCapabilities([h])[0];
				}
			},
			{
				key: "forRoomMessageEvent",
				value: function(p, m) {
					m ??= "";
					var h = `org.matrix.msc2762.${p}.event:m.room.message#${m}`;
					return e.findEventCapabilities([h])[0];
				}
			},
			{
				key: "forRoomAccountData",
				value: function(p, m) {
					var h = `com.beeper.capabilities.${p}.room_account_data:${m}`;
					return e.findEventCapabilities([h])[0];
				}
			},
			{
				key: "findEventCapabilities",
				value: function(p) {
					var h = [], g = m(p), _;
					try {
						for (g.s(); !(_ = g.n()).done;) {
							var v = _.value, y = null, b = void 0, x = null;
							if (v.startsWith("org.matrix.msc2762.send.event:") ? (y = C.Send, x = S.Event, b = v.substring(30)) : v.startsWith("org.matrix.msc2762.send.state_event:") ? (y = C.Send, x = S.State, b = v.substring(36)) : v.startsWith("org.matrix.msc3819.send.to_device:") ? (y = C.Send, x = S.ToDevice, b = v.substring(34)) : v.startsWith("org.matrix.msc2762.receive.event:") ? (y = C.Receive, x = S.Event, b = v.substring(33)) : v.startsWith("org.matrix.msc2762.receive.state_event:") ? (y = C.Receive, x = S.State, b = v.substring(39)) : v.startsWith("org.matrix.msc3819.receive.to_device:") ? (y = C.Receive, x = S.ToDevice, b = v.substring(37)) : v.startsWith("com.beeper.capabilities.receive.room_account_data:") && (y = C.Receive, x = S.RoomAccount, b = v.substring(50)), !(y === null || x === null || b === void 0)) {
								var w = b.startsWith("m.room.message#") || x === S.State, T = null;
								if (b.includes("#") && w) {
									var E = b.split("#"), D = E.findIndex(function(e) {
										return !e.endsWith("\\");
									});
									b = E.slice(0, D + 1).map(function(e) {
										return e.endsWith("\\") ? e.substring(0, e.length - 1) : e;
									}).join("#"), T = E.slice(D + 1).join("#");
								}
								h.push(new e(y, b, x, T, v));
							}
						}
					} catch (e) {
						g.e(e);
					} finally {
						g.f();
					}
					return h;
				}
			}
		]), e;
	}();
})), require_Symbols = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.Symbols = /* @__PURE__ */ function(e) {
		return e.AnyRoom = "*", e;
	}({});
})), require_UpdateDelayedEventAction = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.UpdateDelayedEventAction = /* @__PURE__ */ function(e) {
		return e.Cancel = "cancel", e.Restart = "restart", e.Send = "send", e;
	}({});
})), require_WidgetApi = /* @__PURE__ */ __commonJSMin(((e) => {
	function p(e) {
		"@babel/helpers - typeof";
		return p = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
			return typeof e;
		} : function(e) {
			return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
		}, p(e);
	}
	Object.defineProperty(e, "__esModule", { value: !0 });
	var m = require_events(), h = require_WidgetApiDirection(), g = require_ApiVersion(), _ = require_PostmessageTransport(), v = require_WidgetApiAction(), y = require_GetOpenIDAction(), b = require_WidgetType(), x = require_ModalWidgetActions(), S = require_WidgetEventCapability(), C = require_Symbols(), w = require_UpdateDelayedEventAction();
	function T() {
		/*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ T = function() {
			return e;
		};
		var e = {}, m = Object.prototype, h = m.hasOwnProperty, g = Object.defineProperty || function(e, p, m) {
			e[p] = m.value;
		}, _ = typeof Symbol == "function" ? Symbol : {}, v = _.iterator || "@@iterator", y = _.asyncIterator || "@@asyncIterator", b = _.toStringTag || "@@toStringTag";
		function x(e, p, m) {
			return Object.defineProperty(e, p, {
				value: m,
				enumerable: !0,
				configurable: !0,
				writable: !0
			}), e[p];
		}
		try {
			x({}, "");
		} catch {
			x = function(e, p, m) {
				return e[p] = m;
			};
		}
		function S(e, p, m, h) {
			var _ = p && p.prototype instanceof E ? p : E, v = Object.create(_.prototype), y = new z(h || []);
			return g(v, "_invoke", { value: F(e, m, y) }), v;
		}
		function C(e, p, m) {
			try {
				return {
					type: "normal",
					arg: e.call(p, m)
				};
			} catch (e) {
				return {
					type: "throw",
					arg: e
				};
			}
		}
		e.wrap = S;
		var w = {};
		function E() {}
		function D() {}
		function O() {}
		var k = {};
		x(k, v, function() {
			return this;
		});
		var A = Object.getPrototypeOf, j = A && A(A(B([])));
		j && j !== m && h.call(j, v) && (k = j);
		var M = O.prototype = E.prototype = Object.create(k);
		function N(e) {
			[
				"next",
				"throw",
				"return"
			].forEach(function(p) {
				x(e, p, function(e) {
					return this._invoke(p, e);
				});
			});
		}
		function P(e, m) {
			function _(g, v, y, b) {
				var x = C(e[g], e, v);
				if (x.type !== "throw") {
					var S = x.arg, w = S.value;
					return w && p(w) == "object" && h.call(w, "__await") ? m.resolve(w.__await).then(function(e) {
						_("next", e, y, b);
					}, function(e) {
						_("throw", e, y, b);
					}) : m.resolve(w).then(function(e) {
						S.value = e, y(S);
					}, function(e) {
						return _("throw", e, y, b);
					});
				}
				b(x.arg);
			}
			var v;
			g(this, "_invoke", { value: function(e, p) {
				function h() {
					return new m(function(m, h) {
						_(e, p, m, h);
					});
				}
				return v = v ? v.then(h, h) : h();
			} });
		}
		function F(e, p, m) {
			var h = "suspendedStart";
			return function(g, _) {
				if (h === "executing") throw Error("Generator is already running");
				if (h === "completed") {
					if (g === "throw") throw _;
					return V();
				}
				for (m.method = g, m.arg = _;;) {
					var v = m.delegate;
					if (v) {
						var y = I(v, m);
						if (y) {
							if (y === w) continue;
							return y;
						}
					}
					if (m.method === "next") m.sent = m._sent = m.arg;
					else if (m.method === "throw") {
						if (h === "suspendedStart") throw h = "completed", m.arg;
						m.dispatchException(m.arg);
					} else m.method === "return" && m.abrupt("return", m.arg);
					h = "executing";
					var b = C(e, p, m);
					if (b.type === "normal") {
						if (h = m.done ? "completed" : "suspendedYield", b.arg === w) continue;
						return {
							value: b.arg,
							done: m.done
						};
					}
					b.type === "throw" && (h = "completed", m.method = "throw", m.arg = b.arg);
				}
			};
		}
		function I(e, p) {
			var m = p.method, h = e.iterator[m];
			if (h === void 0) return p.delegate = null, m === "throw" && e.iterator.return && (p.method = "return", p.arg = void 0, I(e, p), p.method === "throw") || m !== "return" && (p.method = "throw", p.arg = /* @__PURE__ */ TypeError("The iterator does not provide a '" + m + "' method")), w;
			var g = C(h, e.iterator, p.arg);
			if (g.type === "throw") return p.method = "throw", p.arg = g.arg, p.delegate = null, w;
			var _ = g.arg;
			return _ ? _.done ? (p[e.resultName] = _.value, p.next = e.nextLoc, p.method !== "return" && (p.method = "next", p.arg = void 0), p.delegate = null, w) : _ : (p.method = "throw", p.arg = /* @__PURE__ */ TypeError("iterator result is not an object"), p.delegate = null, w);
		}
		function L(e) {
			var p = { tryLoc: e[0] };
			1 in e && (p.catchLoc = e[1]), 2 in e && (p.finallyLoc = e[2], p.afterLoc = e[3]), this.tryEntries.push(p);
		}
		function R(e) {
			var p = e.completion || {};
			p.type = "normal", delete p.arg, e.completion = p;
		}
		function z(e) {
			this.tryEntries = [{ tryLoc: "root" }], e.forEach(L, this), this.reset(!0);
		}
		function B(e) {
			if (e) {
				var p = e[v];
				if (p) return p.call(e);
				if (typeof e.next == "function") return e;
				if (!isNaN(e.length)) {
					var m = -1, g = function p() {
						for (; ++m < e.length;) if (h.call(e, m)) return p.value = e[m], p.done = !1, p;
						return p.value = void 0, p.done = !0, p;
					};
					return g.next = g;
				}
			}
			return { next: V };
		}
		function V() {
			return {
				value: void 0,
				done: !0
			};
		}
		return D.prototype = O, g(M, "constructor", {
			value: O,
			configurable: !0
		}), g(O, "constructor", {
			value: D,
			configurable: !0
		}), D.displayName = x(O, b, "GeneratorFunction"), e.isGeneratorFunction = function(e) {
			var p = typeof e == "function" && e.constructor;
			return !!p && (p === D || (p.displayName || p.name) === "GeneratorFunction");
		}, e.mark = function(e) {
			return Object.setPrototypeOf ? Object.setPrototypeOf(e, O) : (e.__proto__ = O, x(e, b, "GeneratorFunction")), e.prototype = Object.create(M), e;
		}, e.awrap = function(e) {
			return { __await: e };
		}, N(P.prototype), x(P.prototype, y, function() {
			return this;
		}), e.AsyncIterator = P, e.async = function(p, m, h, g, _) {
			_ === void 0 && (_ = Promise);
			var v = new P(S(p, m, h, g), _);
			return e.isGeneratorFunction(m) ? v : v.next().then(function(e) {
				return e.done ? e.value : v.next();
			});
		}, N(M), x(M, b, "Generator"), x(M, v, function() {
			return this;
		}), x(M, "toString", function() {
			return "[object Generator]";
		}), e.keys = function(e) {
			var p = Object(e), m = [];
			for (var h in p) m.push(h);
			return m.reverse(), function e() {
				for (; m.length;) {
					var h = m.pop();
					if (h in p) return e.value = h, e.done = !1, e;
				}
				return e.done = !0, e;
			};
		}, e.values = B, z.prototype = {
			constructor: z,
			reset: function(e) {
				if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(R), !e) for (var p in this) p.charAt(0) === "t" && h.call(this, p) && !isNaN(+p.slice(1)) && (this[p] = void 0);
			},
			stop: function() {
				this.done = !0;
				var e = this.tryEntries[0].completion;
				if (e.type === "throw") throw e.arg;
				return this.rval;
			},
			dispatchException: function(e) {
				if (this.done) throw e;
				var p = this;
				function m(m, h) {
					return v.type = "throw", v.arg = e, p.next = m, h && (p.method = "next", p.arg = void 0), !!h;
				}
				for (var g = this.tryEntries.length - 1; g >= 0; --g) {
					var _ = this.tryEntries[g], v = _.completion;
					if (_.tryLoc === "root") return m("end");
					if (_.tryLoc <= this.prev) {
						var y = h.call(_, "catchLoc"), b = h.call(_, "finallyLoc");
						if (y && b) {
							if (this.prev < _.catchLoc) return m(_.catchLoc, !0);
							if (this.prev < _.finallyLoc) return m(_.finallyLoc);
						} else if (y) {
							if (this.prev < _.catchLoc) return m(_.catchLoc, !0);
						} else {
							if (!b) throw Error("try statement without catch or finally");
							if (this.prev < _.finallyLoc) return m(_.finallyLoc);
						}
					}
				}
			},
			abrupt: function(e, p) {
				for (var m = this.tryEntries.length - 1; m >= 0; --m) {
					var g = this.tryEntries[m];
					if (g.tryLoc <= this.prev && h.call(g, "finallyLoc") && this.prev < g.finallyLoc) {
						var _ = g;
						break;
					}
				}
				_ && (e === "break" || e === "continue") && _.tryLoc <= p && p <= _.finallyLoc && (_ = null);
				var v = _ ? _.completion : {};
				return v.type = e, v.arg = p, _ ? (this.method = "next", this.next = _.finallyLoc, w) : this.complete(v);
			},
			complete: function(e, p) {
				if (e.type === "throw") throw e.arg;
				return e.type === "break" || e.type === "continue" ? this.next = e.arg : e.type === "return" ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : e.type === "normal" && p && (this.next = p), w;
			},
			finish: function(e) {
				for (var p = this.tryEntries.length - 1; p >= 0; --p) {
					var m = this.tryEntries[p];
					if (m.finallyLoc === e) return this.complete(m.completion, m.afterLoc), R(m), w;
				}
			},
			catch: function(e) {
				for (var p = this.tryEntries.length - 1; p >= 0; --p) {
					var m = this.tryEntries[p];
					if (m.tryLoc === e) {
						var h = m.completion;
						if (h.type === "throw") {
							var g = h.arg;
							R(m);
						}
						return g;
					}
				}
				throw Error("illegal catch attempt");
			},
			delegateYield: function(e, p, m) {
				return this.delegate = {
					iterator: B(e),
					resultName: p,
					nextLoc: m
				}, this.method === "next" && (this.arg = void 0), w;
			}
		}, e;
	}
	function E(e, p, m, h, g, _, v) {
		try {
			var y = e[_](v), b = y.value;
		} catch (e) {
			m(e);
			return;
		}
		y.done ? p(b) : Promise.resolve(b).then(h, g);
	}
	function D(e) {
		return function() {
			var p = this, m = arguments;
			return new Promise(function(h, g) {
				var _ = e.apply(p, m);
				function v(e) {
					E(_, h, g, v, y, "next", e);
				}
				function y(e) {
					E(_, h, g, v, y, "throw", e);
				}
				v(void 0);
			});
		};
	}
	function O(e, p) {
		var m = Object.keys(e);
		if (Object.getOwnPropertySymbols) {
			var h = Object.getOwnPropertySymbols(e);
			p && (h = h.filter(function(p) {
				return Object.getOwnPropertyDescriptor(e, p).enumerable;
			})), m.push.apply(m, h);
		}
		return m;
	}
	function k(e) {
		for (var p = 1; p < arguments.length; p++) {
			var m = arguments[p] == null ? {} : arguments[p];
			p % 2 ? O(Object(m), !0).forEach(function(p) {
				N(e, p, m[p]);
			}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(m)) : O(Object(m)).forEach(function(p) {
				Object.defineProperty(e, p, Object.getOwnPropertyDescriptor(m, p));
			});
		}
		return e;
	}
	function A(e, p) {
		var m = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
		if (!m) {
			if (Array.isArray(e) || (m = j(e)) || p && e && typeof e.length == "number") {
				m && (e = m);
				var h = 0, g = function() {};
				return {
					s: g,
					n: function() {
						return h >= e.length ? { done: !0 } : {
							done: !1,
							value: e[h++]
						};
					},
					e: function(e) {
						throw e;
					},
					f: g
				};
			}
			throw TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
		}
		var _ = !0, v = !1, y;
		return {
			s: function() {
				m = m.call(e);
			},
			n: function() {
				var e = m.next();
				return _ = e.done, e;
			},
			e: function(e) {
				v = !0, y = e;
			},
			f: function() {
				try {
					!_ && m.return != null && m.return();
				} finally {
					if (v) throw y;
				}
			}
		};
	}
	function j(e, p) {
		if (e) {
			if (typeof e == "string") return M(e, p);
			var m = Object.prototype.toString.call(e).slice(8, -1);
			if (m === "Object" && e.constructor && (m = e.constructor.name), m === "Map" || m === "Set") return Array.from(e);
			if (m === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(m)) return M(e, p);
		}
	}
	function M(e, p) {
		(p == null || p > e.length) && (p = e.length);
		for (var m = 0, h = Array(p); m < p; m++) h[m] = e[m];
		return h;
	}
	function N(e, p, m) {
		return p = I(p), p in e ? Object.defineProperty(e, p, {
			value: m,
			enumerable: !0,
			configurable: !0,
			writable: !0
		}) : e[p] = m, e;
	}
	function P(e, p) {
		for (var m = 0; m < p.length; m++) {
			var h = p[m];
			h.enumerable = h.enumerable || !1, h.configurable = !0, "value" in h && (h.writable = !0), Object.defineProperty(e, I(h.key), h);
		}
	}
	function F(e, p, m) {
		return p && P(e.prototype, p), m && P(e, m), Object.defineProperty(e, "prototype", { writable: !1 }), e;
	}
	function I(e) {
		var m = L(e, "string");
		return p(m) === "symbol" ? m : String(m);
	}
	function L(e, m) {
		if (p(e) !== "object" || e === null) return e;
		var h = e[Symbol.toPrimitive];
		if (h !== void 0) {
			var g = h.call(e, m || "default");
			if (p(g) !== "object") return g;
			throw TypeError("@@toPrimitive must return a primitive value.");
		}
		return (m === "string" ? String : Number)(e);
	}
	function R(e, p) {
		if (!(e instanceof p)) throw TypeError("Cannot call a class as a function");
	}
	function z(e, p) {
		if (typeof p != "function" && p !== null) throw TypeError("Super expression must either be null or a function");
		e.prototype = Object.create(p && p.prototype, { constructor: {
			value: e,
			writable: !0,
			configurable: !0
		} }), Object.defineProperty(e, "prototype", { writable: !1 }), p && q(e, p);
	}
	function B(e) {
		var p = G();
		return function() {
			var m = J(e), h;
			if (p) {
				var g = J(this).constructor;
				h = Reflect.construct(m, arguments, g);
			} else h = m.apply(this, arguments);
			return V(this, h);
		};
	}
	function V(e, m) {
		if (m && (p(m) === "object" || typeof m == "function")) return m;
		if (m !== void 0) throw TypeError("Derived constructors may only return object or undefined");
		return H(e);
	}
	function H(e) {
		if (e === void 0) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
		return e;
	}
	function U(e) {
		var p = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
		return U = function(e) {
			if (e === null || !K(e)) return e;
			if (typeof e != "function") throw TypeError("Super expression must either be null or a function");
			if (p !== void 0) {
				if (p.has(e)) return p.get(e);
				p.set(e, m);
			}
			function m() {
				return W(e, arguments, J(this).constructor);
			}
			return m.prototype = Object.create(e.prototype, { constructor: {
				value: m,
				enumerable: !1,
				writable: !0,
				configurable: !0
			} }), q(m, e);
		}, U(e);
	}
	function W(e, p, m) {
		return W = G() ? Reflect.construct.bind() : function(e, p, m) {
			var h = [null];
			h.push.apply(h, p);
			var g = new (Function.bind.apply(e, h))();
			return m && q(g, m.prototype), g;
		}, W.apply(null, arguments);
	}
	function G() {
		if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
		if (typeof Proxy == "function") return !0;
		try {
			return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
		} catch {
			return !1;
		}
	}
	function K(e) {
		return Function.toString.call(e).indexOf("[native code]") !== -1;
	}
	function q(e, p) {
		return q = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, p) {
			return e.__proto__ = p, e;
		}, q(e, p);
	}
	function J(e) {
		return J = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
			return e.__proto__ || Object.getPrototypeOf(e);
		}, J(e);
	}
	function Y(e) {
		return new Q(e, 0);
	}
	function X(e) {
		return function() {
			return new Z(e.apply(this, arguments));
		};
	}
	function Z(e) {
		var p, m;
		function h(p, m) {
			try {
				var _ = e[p](m), v = _.value, y = v instanceof Q;
				Promise.resolve(y ? v.v : v).then(function(m) {
					if (y) {
						var b = p === "return" ? "return" : "next";
						if (!v.k || m.done) return h(b, m);
						m = e[b](m).value;
					}
					g(_.done ? "return" : "normal", m);
				}, function(e) {
					h("throw", e);
				});
			} catch (e) {
				g("throw", e);
			}
		}
		function g(e, g) {
			switch (e) {
				case "return":
					p.resolve({
						value: g,
						done: !0
					});
					break;
				case "throw":
					p.reject(g);
					break;
				default: p.resolve({
					value: g,
					done: !1
				});
			}
			(p = p.next) ? h(p.key, p.arg) : m = null;
		}
		this._invoke = function(e, g) {
			return new Promise(function(_, v) {
				var y = {
					key: e,
					arg: g,
					resolve: _,
					reject: v,
					next: null
				};
				m ? m = m.next = y : (p = m = y, h(e, g));
			});
		}, typeof e.return != "function" && (this.return = void 0);
	}
	Z.prototype[typeof Symbol == "function" && Symbol.asyncIterator || "@@asyncIterator"] = function() {
		return this;
	}, Z.prototype.next = function(e) {
		return this._invoke("next", e);
	}, Z.prototype.throw = function(e) {
		return this._invoke("throw", e);
	}, Z.prototype.return = function(e) {
		return this._invoke("return", e);
	};
	function Q(e, p) {
		this.v = e, this.k = p;
	}
	var $ = /* @__PURE__ */ function(e) {
		z(m, e);
		var p = B(m);
		function m(e, h) {
			var g;
			return R(this, m), g = p.call(this, e), g.data = h, g;
		}
		return F(m);
	}(/* @__PURE__ */ U(Error));
	e.WidgetApiResponseError = $, $.prototype.name = $.name, e.WidgetApi = /* @__PURE__ */ function(e) {
		z(m, e);
		var p = B(m);
		function m() {
			var e, g = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, v = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
			if (R(this, m), e = p.call(this), N(H(e), "transport", void 0), N(H(e), "capabilitiesFinished", !1), N(H(e), "supportsMSC2974Renegotiate", !1), N(H(e), "requestedCapabilities", []), N(H(e), "approvedCapabilities", void 0), N(H(e), "cachedClientVersions", void 0), N(H(e), "turnServerWatchers", 0), !globalThis.parent) throw Error("No parent window. This widget doesn't appear to be embedded properly.");
			return e.transport = new _.PostmessageTransport(h.WidgetApiDirection.FromWidget, g, globalThis.parent, globalThis), e.transport.targetOrigin = v, e.transport.on("message", e.handleMessage.bind(H(e))), e;
		}
		return F(m, [
			{
				key: "hasCapability",
				value: function(e) {
					return Array.isArray(this.approvedCapabilities) ? this.approvedCapabilities.includes(e) : this.requestedCapabilities.includes(e);
				}
			},
			{
				key: "requestCapability",
				value: function(e) {
					if (this.capabilitiesFinished && !this.supportsMSC2974Renegotiate) throw Error("Capabilities have already been negotiated");
					this.requestedCapabilities.push(e);
				}
			},
			{
				key: "requestCapabilities",
				value: function(e) {
					var p = A(e), m;
					try {
						for (p.s(); !(m = p.n()).done;) {
							var h = m.value;
							this.requestCapability(h);
						}
					} catch (e) {
						p.e(e);
					} finally {
						p.f();
					}
				}
			},
			{
				key: "requestCapabilityForRoomTimeline",
				value: function(e) {
					this.requestCapability(`org.matrix.msc2762.timeline:${e}`);
				}
			},
			{
				key: "requestCapabilityToSendState",
				value: function(e, p) {
					this.requestCapability(S.WidgetEventCapability.forStateEvent(S.EventDirection.Send, e, p).raw);
				}
			},
			{
				key: "requestCapabilityToReceiveState",
				value: function(e, p) {
					this.requestCapability(S.WidgetEventCapability.forStateEvent(S.EventDirection.Receive, e, p).raw);
				}
			},
			{
				key: "requestCapabilityToSendToDevice",
				value: function(e) {
					this.requestCapability(S.WidgetEventCapability.forToDeviceEvent(S.EventDirection.Send, e).raw);
				}
			},
			{
				key: "requestCapabilityToReceiveToDevice",
				value: function(e) {
					this.requestCapability(S.WidgetEventCapability.forToDeviceEvent(S.EventDirection.Receive, e).raw);
				}
			},
			{
				key: "requestCapabilityToSendEvent",
				value: function(e) {
					this.requestCapability(S.WidgetEventCapability.forRoomEvent(S.EventDirection.Send, e).raw);
				}
			},
			{
				key: "requestCapabilityToReceiveEvent",
				value: function(e) {
					this.requestCapability(S.WidgetEventCapability.forRoomEvent(S.EventDirection.Receive, e).raw);
				}
			},
			{
				key: "requestCapabilityToSendMessage",
				value: function(e) {
					this.requestCapability(S.WidgetEventCapability.forRoomMessageEvent(S.EventDirection.Send, e).raw);
				}
			},
			{
				key: "requestCapabilityToReceiveMessage",
				value: function(e) {
					this.requestCapability(S.WidgetEventCapability.forRoomMessageEvent(S.EventDirection.Receive, e).raw);
				}
			},
			{
				key: "requestCapabilityToReceiveRoomAccountData",
				value: function(e) {
					this.requestCapability(S.WidgetEventCapability.forRoomAccountData(S.EventDirection.Receive, e).raw);
				}
			},
			{
				key: "requestOpenIDConnectToken",
				value: function() {
					var e = this;
					return new Promise(function(p, m) {
						e.transport.sendComplete(v.WidgetApiFromWidgetAction.GetOpenIDCredentials, {}).then(function(h) {
							var g = h.response;
							g.state === y.OpenIDRequestState.Allowed ? p(g) : g.state === y.OpenIDRequestState.Blocked ? m(/* @__PURE__ */ Error("User declined to verify their identity")) : g.state === y.OpenIDRequestState.PendingUserConfirmation ? e.on(`action:${v.WidgetApiToWidgetAction.OpenIDCredentials}`, function _(b) {
								b.preventDefault();
								var x = b.detail;
								x.data.original_request_id === h.requestId && (x.data.state === y.OpenIDRequestState.Allowed ? (p(x.data), e.transport.reply(x, {})) : x.data.state === y.OpenIDRequestState.Blocked ? (m(/* @__PURE__ */ Error("User declined to verify their identity")), e.transport.reply(x, {})) : (m(/* @__PURE__ */ Error("Invalid state on reply: " + g.state)), e.transport.reply(x, { error: { message: "Invalid state" } })), e.off(`action:${v.WidgetApiToWidgetAction.OpenIDCredentials}`, _));
							}) : m(/* @__PURE__ */ Error("Invalid state: " + g.state));
						}).catch(m);
					});
				}
			},
			{
				key: "updateRequestedCapabilities",
				value: function() {
					return this.transport.send(v.WidgetApiFromWidgetAction.MSC2974RenegotiateCapabilities, { capabilities: this.requestedCapabilities }).then();
				}
			},
			{
				key: "sendContentLoaded",
				value: function() {
					return this.transport.send(v.WidgetApiFromWidgetAction.ContentLoaded, {}).then();
				}
			},
			{
				key: "sendSticker",
				value: function(e) {
					return this.transport.send(v.WidgetApiFromWidgetAction.SendSticker, e).then();
				}
			},
			{
				key: "setAlwaysOnScreen",
				value: function(e) {
					return this.transport.send(v.WidgetApiFromWidgetAction.UpdateAlwaysOnScreen, { value: e }).then(function(e) {
						return e.success;
					});
				}
			},
			{
				key: "openModalWidget",
				value: function(e, p) {
					var m = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], h = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, g = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : b.MatrixWidgetType.Custom;
					return this.transport.send(v.WidgetApiFromWidgetAction.OpenModalWidget, {
						type: g,
						url: e,
						name: p,
						buttons: m,
						data: h
					}).then();
				}
			},
			{
				key: "closeModalWidget",
				value: function() {
					var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
					return this.transport.send(v.WidgetApiFromWidgetAction.CloseModalWidget, e).then();
				}
			},
			{
				key: "sendRoomEvent",
				value: function(e, p, m, h, g, _) {
					return this.sendEvent(e, void 0, p, m, h, g, _);
				}
			},
			{
				key: "sendStateEvent",
				value: function(e, p, m, h, g, _) {
					return this.sendEvent(e, p, m, h, g, _);
				}
			},
			{
				key: "sendEvent",
				value: function(e, p, m, h, g, _, y) {
					return this.transport.send(v.WidgetApiFromWidgetAction.SendEvent, k(k(k(k(k({
						type: e,
						content: m
					}, p !== void 0 && { state_key: p }), h !== void 0 && { room_id: h }), g !== void 0 && { delay: g }), _ !== void 0 && { parent_delay_id: _ }), y !== void 0 && { sticky_duration_ms: y }));
				}
			},
			{
				key: "cancelScheduledDelayedEvent",
				value: function(e) {
					return this.transport.send(v.WidgetApiFromWidgetAction.MSC4157UpdateDelayedEvent, {
						delay_id: e,
						action: w.UpdateDelayedEventAction.Cancel
					});
				}
			},
			{
				key: "restartScheduledDelayedEvent",
				value: function(e) {
					return this.transport.send(v.WidgetApiFromWidgetAction.MSC4157UpdateDelayedEvent, {
						delay_id: e,
						action: w.UpdateDelayedEventAction.Restart
					});
				}
			},
			{
				key: "sendScheduledDelayedEvent",
				value: function(e) {
					return this.transport.send(v.WidgetApiFromWidgetAction.MSC4157UpdateDelayedEvent, {
						delay_id: e,
						action: w.UpdateDelayedEventAction.Send
					});
				}
			},
			{
				key: "sendToDevice",
				value: function(e, p, m) {
					return this.transport.send(v.WidgetApiFromWidgetAction.SendToDevice, {
						type: e,
						encrypted: p,
						messages: m
					});
				}
			},
			{
				key: "readRoomAccountData",
				value: function(e, p) {
					var m = { type: e };
					return p && (p.includes(C.Symbols.AnyRoom) ? m.room_ids = C.Symbols.AnyRoom : m.room_ids = p), this.transport.send(v.WidgetApiFromWidgetAction.BeeperReadRoomAccountData, m).then(function(e) {
						return e.events;
					});
				}
			},
			{
				key: "readRoomEvents",
				value: function(e, p, m, h, g) {
					var _ = {
						type: e,
						msgtype: m
					};
					return p !== void 0 && (_.limit = p), h && (h.includes(C.Symbols.AnyRoom) ? _.room_ids = C.Symbols.AnyRoom : _.room_ids = h), g && (_.since = g), this.transport.send(v.WidgetApiFromWidgetAction.MSC2876ReadEvents, _).then(function(e) {
						return e.events;
					});
				}
			},
			{
				key: "readEventRelations",
				value: function() {
					var e = D(/* @__PURE__ */ T().mark(function e(p, m, h, _, y, b, x, S) {
						var C, w;
						return T().wrap(function(e) {
							for (;;) switch (e.prev = e.next) {
								case 0: return e.next = 2, this.getClientVersions();
								case 2:
									if (C = e.sent, C.includes(g.UnstableApiVersion.MSC3869)) {
										e.next = 5;
										break;
									}
									throw Error("The read_relations action is not supported by the client.");
								case 5: return w = {
									event_id: p,
									rel_type: h,
									event_type: _,
									room_id: m,
									to: x,
									from: b,
									limit: y,
									direction: S
								}, e.abrupt("return", this.transport.send(v.WidgetApiFromWidgetAction.MSC3869ReadRelations, w));
								case 7:
								case "end": return e.stop();
							}
						}, e, this);
					}));
					function p(p, m, h, g, _, v, y, b) {
						return e.apply(this, arguments);
					}
					return p;
				}()
			},
			{
				key: "readStateEvents",
				value: function(e, p, m, h) {
					var g = {
						type: e,
						state_key: m === void 0 ? !0 : m
					};
					return p !== void 0 && (g.limit = p), h && (h.includes(C.Symbols.AnyRoom) ? g.room_ids = C.Symbols.AnyRoom : g.room_ids = h), this.transport.send(v.WidgetApiFromWidgetAction.MSC2876ReadEvents, g).then(function(e) {
						return e.events;
					});
				}
			},
			{
				key: "setModalButtonEnabled",
				value: function(e, p) {
					if (e === x.BuiltInModalButtonID.Close) throw Error("The close button cannot be disabled");
					return this.transport.send(v.WidgetApiFromWidgetAction.SetModalButtonEnabled, {
						button: e,
						enabled: p
					}).then();
				}
			},
			{
				key: "navigateTo",
				value: function(e) {
					if (!e || !e.startsWith("https://matrix.to/#")) throw Error("Invalid matrix.to URI");
					return this.transport.send(v.WidgetApiFromWidgetAction.MSC2931Navigate, { uri: e }).then();
				}
			},
			{
				key: "getTurnServers",
				value: function() {
					var e = this;
					return X(/* @__PURE__ */ T().mark(function p() {
						var m, h;
						return T().wrap(function(p) {
							for (;;) switch (p.prev = p.next) {
								case 0:
									if (h = /* @__PURE__ */ function() {
										var p = D(/* @__PURE__ */ T().mark(function p(h) {
											return T().wrap(function(p) {
												for (;;) switch (p.prev = p.next) {
													case 0: h.preventDefault(), m(h.detail.data), e.transport.reply(h.detail, {});
													case 3:
													case "end": return p.stop();
												}
											}, p);
										}));
										return function(e) {
											return p.apply(this, arguments);
										};
									}(), e.on(`action:${v.WidgetApiToWidgetAction.UpdateTurnServers}`, h), e.turnServerWatchers !== 0) {
										p.next = 12;
										break;
									}
									return p.prev = 3, p.next = 6, Y(e.transport.send(v.WidgetApiFromWidgetAction.WatchTurnServers, {}));
								case 6:
									p.next = 12;
									break;
								case 8: throw p.prev = 8, p.t0 = p.catch(3), e.off(`action:${v.WidgetApiToWidgetAction.UpdateTurnServers}`, h), p.t0;
								case 12: e.turnServerWatchers++, p.prev = 13;
								case 14: return p.next = 17, Y(new Promise(function(e) {
									return m = e;
								}));
								case 17: return p.next = 19, p.sent;
								case 19:
									p.next = 14;
									break;
								case 21:
									if (p.prev = 21, e.off(`action:${v.WidgetApiToWidgetAction.UpdateTurnServers}`, h), e.turnServerWatchers--, e.turnServerWatchers !== 0) {
										p.next = 27;
										break;
									}
									return p.next = 27, Y(e.transport.send(v.WidgetApiFromWidgetAction.UnwatchTurnServers, {}));
								case 27: return p.finish(21);
								case 28:
								case "end": return p.stop();
							}
						}, p, null, [[3, 8], [
							13,
							,
							21,
							28
						]]);
					}))();
				}
			},
			{
				key: "searchUserDirectory",
				value: function() {
					var e = D(/* @__PURE__ */ T().mark(function e(p, m) {
						var h, _;
						return T().wrap(function(e) {
							for (;;) switch (e.prev = e.next) {
								case 0: return e.next = 2, this.getClientVersions();
								case 2:
									if (h = e.sent, h.includes(g.UnstableApiVersion.MSC3973)) {
										e.next = 5;
										break;
									}
									throw Error("The user_directory_search action is not supported by the client.");
								case 5: return _ = {
									search_term: p,
									limit: m
								}, e.abrupt("return", this.transport.send(v.WidgetApiFromWidgetAction.MSC3973UserDirectorySearch, _));
								case 7:
								case "end": return e.stop();
							}
						}, e, this);
					}));
					function p(p, m) {
						return e.apply(this, arguments);
					}
					return p;
				}()
			},
			{
				key: "getMediaConfig",
				value: function() {
					var e = D(/* @__PURE__ */ T().mark(function e() {
						var p, m;
						return T().wrap(function(e) {
							for (;;) switch (e.prev = e.next) {
								case 0: return e.next = 2, this.getClientVersions();
								case 2:
									if (p = e.sent, p.includes(g.UnstableApiVersion.MSC4039)) {
										e.next = 5;
										break;
									}
									throw Error("The get_media_config action is not supported by the client.");
								case 5: return m = {}, e.abrupt("return", this.transport.send(v.WidgetApiFromWidgetAction.MSC4039GetMediaConfigAction, m));
								case 7:
								case "end": return e.stop();
							}
						}, e, this);
					}));
					function p() {
						return e.apply(this, arguments);
					}
					return p;
				}()
			},
			{
				key: "uploadFile",
				value: function() {
					var e = D(/* @__PURE__ */ T().mark(function e(p) {
						var m, h;
						return T().wrap(function(e) {
							for (;;) switch (e.prev = e.next) {
								case 0: return e.next = 2, this.getClientVersions();
								case 2:
									if (m = e.sent, m.includes(g.UnstableApiVersion.MSC4039)) {
										e.next = 5;
										break;
									}
									throw Error("The upload_file action is not supported by the client.");
								case 5: return h = { file: p }, e.abrupt("return", this.transport.send(v.WidgetApiFromWidgetAction.MSC4039UploadFileAction, h));
								case 7:
								case "end": return e.stop();
							}
						}, e, this);
					}));
					function p(p) {
						return e.apply(this, arguments);
					}
					return p;
				}()
			},
			{
				key: "downloadFile",
				value: function() {
					var e = D(/* @__PURE__ */ T().mark(function e(p) {
						var m, h;
						return T().wrap(function(e) {
							for (;;) switch (e.prev = e.next) {
								case 0: return e.next = 2, this.getClientVersions();
								case 2:
									if (m = e.sent, m.includes(g.UnstableApiVersion.MSC4039)) {
										e.next = 5;
										break;
									}
									throw Error("The download_file action is not supported by the client.");
								case 5: return h = { content_uri: p }, e.abrupt("return", this.transport.send(v.WidgetApiFromWidgetAction.MSC4039DownloadFileAction, h));
								case 7:
								case "end": return e.stop();
							}
						}, e, this);
					}));
					function p(p) {
						return e.apply(this, arguments);
					}
					return p;
				}()
			},
			{
				key: "start",
				value: function() {
					var e = this;
					this.transport.start(), this.getClientVersions().then(function(p) {
						p.includes(g.UnstableApiVersion.MSC2974) && (e.supportsMSC2974Renegotiate = !0);
					});
				}
			},
			{
				key: "handleMessage",
				value: function(e) {
					var p = new CustomEvent(`action:${e.detail.action}`, {
						detail: e.detail,
						cancelable: !0
					});
					if (this.emit(`action:${e.detail.action}`, p), !p.defaultPrevented) switch (e.detail.action) {
						case v.WidgetApiToWidgetAction.SupportedApiVersions: return this.replyVersions(e.detail);
						case v.WidgetApiToWidgetAction.Capabilities: return this.handleCapabilities(e.detail);
						case v.WidgetApiToWidgetAction.UpdateVisibility: return this.transport.reply(e.detail, {});
						case v.WidgetApiToWidgetAction.NotifyCapabilities: return this.transport.reply(e.detail, {});
						default: return this.transport.reply(e.detail, { error: { message: "Unknown or unsupported to-widget action: " + e.detail.action } });
					}
				}
			},
			{
				key: "replyVersions",
				value: function(e) {
					this.transport.reply(e, { supported_versions: g.CurrentApiVersions });
				}
			},
			{
				key: "getClientVersions",
				value: function() {
					var e = this;
					return Array.isArray(this.cachedClientVersions) ? Promise.resolve(this.cachedClientVersions) : this.transport.send(v.WidgetApiFromWidgetAction.SupportedApiVersions, {}).then(function(p) {
						return e.cachedClientVersions = p.supported_versions, p.supported_versions;
					}).catch(function(e) {
						return console.warn("non-fatal error getting supported client versions: ", e), [];
					});
				}
			},
			{
				key: "handleCapabilities",
				value: function(e) {
					var p = this;
					return this.capabilitiesFinished ? this.transport.reply(e, { error: { message: "Capability negotiation already completed" } }) : this.getClientVersions().then(function(m) {
						return m.includes(g.UnstableApiVersion.MSC2871) ? p.once(`action:${v.WidgetApiToWidgetAction.NotifyCapabilities}`, function(e) {
							p.approvedCapabilities = e.detail.data.approved, p.emit("ready");
						}) : p.emit("ready"), p.capabilitiesFinished = !0, p.transport.reply(e, { capabilities: p.requestedCapabilities });
					});
				}
			}
		]), m;
	}(m.EventEmitter);
})), require_Capabilities = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.getTimelineRoomIDFromCapability = g, e.isTimelineCapability = m, e.isTimelineCapabilityFor = h;
	var p = /* @__PURE__ */ function(e) {
		return e.Screenshots = "m.capability.screenshot", e.StickerSending = "m.sticker", e.AlwaysOnScreen = "m.always_on_screen", e.RequiresClient = "io.element.requires_client", e.MSC2931Navigate = "org.matrix.msc2931.navigate", e.MSC3846TurnServers = "town.robin.msc3846.turn_servers", e.MSC3973UserDirectorySearch = "org.matrix.msc3973.user_directory_search", e.MSC4039UploadFile = "org.matrix.msc4039.upload_file", e.MSC4039DownloadFile = "org.matrix.msc4039.download_file", e.MSC4157SendDelayedEvent = "org.matrix.msc4157.send.delayed_event", e.MSC4157UpdateDelayedEvent = "org.matrix.msc4157.update_delayed_event", e.MSC4407SendStickyEvent = "org.matrix.msc4407.send.sticky_event", e.MSC4407ReceiveStickyEvent = "org.matrix.msc4407.receive.sticky_event", e;
	}({});
	e.MatrixCapabilities = p, e.StickerpickerCapabilities = [p.StickerSending], e.VideoConferenceCapabilities = [p.AlwaysOnScreen];
	function m(e) {
		return e?.startsWith("org.matrix.msc2762.timeline:");
	}
	function h(e, p) {
		return e === `org.matrix.msc2762.timeline:${p}`;
	}
	function g(e) {
		return e.substring(e.indexOf(":") + 1);
	}
})), require_SimpleObservable = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	function p(e) {
		"@babel/helpers - typeof";
		return p = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
			return typeof e;
		} : function(e) {
			return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
		}, p(e);
	}
	function m(e, p) {
		var m = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
		if (!m) {
			if (Array.isArray(e) || (m = h(e)) || p && e && typeof e.length == "number") {
				m && (e = m);
				var g = 0, _ = function() {};
				return {
					s: _,
					n: function() {
						return g >= e.length ? { done: !0 } : {
							done: !1,
							value: e[g++]
						};
					},
					e: function(e) {
						throw e;
					},
					f: _
				};
			}
			throw TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
		}
		var v = !0, y = !1, b;
		return {
			s: function() {
				m = m.call(e);
			},
			n: function() {
				var e = m.next();
				return v = e.done, e;
			},
			e: function(e) {
				y = !0, b = e;
			},
			f: function() {
				try {
					!v && m.return != null && m.return();
				} finally {
					if (y) throw b;
				}
			}
		};
	}
	function h(e, p) {
		if (e) {
			if (typeof e == "string") return g(e, p);
			var m = Object.prototype.toString.call(e).slice(8, -1);
			if (m === "Object" && e.constructor && (m = e.constructor.name), m === "Map" || m === "Set") return Array.from(e);
			if (m === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(m)) return g(e, p);
		}
	}
	function g(e, p) {
		(p == null || p > e.length) && (p = e.length);
		for (var m = 0, h = Array(p); m < p; m++) h[m] = e[m];
		return h;
	}
	function _(e, p) {
		if (!(e instanceof p)) throw TypeError("Cannot call a class as a function");
	}
	function v(e, p) {
		for (var m = 0; m < p.length; m++) {
			var h = p[m];
			h.enumerable = h.enumerable || !1, h.configurable = !0, "value" in h && (h.writable = !0), Object.defineProperty(e, x(h.key), h);
		}
	}
	function y(e, p, m) {
		return p && v(e.prototype, p), m && v(e, m), Object.defineProperty(e, "prototype", { writable: !1 }), e;
	}
	function b(e, p, m) {
		return p = x(p), p in e ? Object.defineProperty(e, p, {
			value: m,
			enumerable: !0,
			configurable: !0,
			writable: !0
		}) : e[p] = m, e;
	}
	function x(e) {
		var m = S(e, "string");
		return p(m) === "symbol" ? m : String(m);
	}
	function S(e, m) {
		if (p(e) !== "object" || e === null) return e;
		var h = e[Symbol.toPrimitive];
		if (h !== void 0) {
			var g = h.call(e, m || "default");
			if (p(g) !== "object") return g;
			throw TypeError("@@toPrimitive must return a primitive value.");
		}
		return (m === "string" ? String : Number)(e);
	}
	e.SimpleObservable = /* @__PURE__ */ function() {
		function e(p) {
			_(this, e), b(this, "listeners", []), p && this.listeners.push(p);
		}
		return y(e, [
			{
				key: "onUpdate",
				value: function(e) {
					this.listeners.push(e);
				}
			},
			{
				key: "update",
				value: function(e) {
					var p = m(this.listeners), h;
					try {
						for (p.s(); !(h = p.n()).done;) {
							var g = h.value;
							g(e);
						}
					} catch (e) {
						p.e(e);
					} finally {
						p.f();
					}
				}
			},
			{
				key: "close",
				value: function() {
					this.listeners = [];
				}
			}
		]), e;
	}();
})), require_ClientWidgetApi = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var p = require_events(), m = require_PostmessageTransport(), h = require_WidgetApiDirection(), g = require_WidgetApiAction(), _ = require_Capabilities(), v = require_ApiVersion(), y = require_WidgetEventCapability(), b = require_GetOpenIDAction(), x = require_SimpleObservable(), S = require_Symbols(), C = require_UpdateDelayedEventAction();
	function w(e) {
		"@babel/helpers - typeof";
		return w = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
			return typeof e;
		} : function(e) {
			return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
		}, w(e);
	}
	function T(e, p) {
		var m = Object.keys(e);
		if (Object.getOwnPropertySymbols) {
			var h = Object.getOwnPropertySymbols(e);
			p && (h = h.filter(function(p) {
				return Object.getOwnPropertyDescriptor(e, p).enumerable;
			})), m.push.apply(m, h);
		}
		return m;
	}
	function E(e) {
		for (var p = 1; p < arguments.length; p++) {
			var m = arguments[p] == null ? {} : arguments[p];
			p % 2 ? T(Object(m), !0).forEach(function(p) {
				q(e, p, m[p]);
			}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(m)) : T(Object(m)).forEach(function(p) {
				Object.defineProperty(e, p, Object.getOwnPropertyDescriptor(m, p));
			});
		}
		return e;
	}
	function D(e, p) {
		var m = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
		if (!m) {
			if (Array.isArray(e) || (m = A(e)) || p && e && typeof e.length == "number") {
				m && (e = m);
				var h = 0, g = function() {};
				return {
					s: g,
					n: function() {
						return h >= e.length ? { done: !0 } : {
							done: !1,
							value: e[h++]
						};
					},
					e: function(e) {
						throw e;
					},
					f: g
				};
			}
			throw TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
		}
		var _ = !0, v = !1, y;
		return {
			s: function() {
				m = m.call(e);
			},
			n: function() {
				var e = m.next();
				return _ = e.done, e;
			},
			e: function(e) {
				v = !0, y = e;
			},
			f: function() {
				try {
					!_ && m.return != null && m.return();
				} finally {
					if (v) throw y;
				}
			}
		};
	}
	function O(e) {
		return M(e) || j(e) || A(e) || k();
	}
	function k() {
		throw TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	function A(e, p) {
		if (e) {
			if (typeof e == "string") return N(e, p);
			var m = Object.prototype.toString.call(e).slice(8, -1);
			if (m === "Object" && e.constructor && (m = e.constructor.name), m === "Map" || m === "Set") return Array.from(e);
			if (m === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(m)) return N(e, p);
		}
	}
	function j(e) {
		if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
	}
	function M(e) {
		if (Array.isArray(e)) return N(e);
	}
	function N(e, p) {
		(p == null || p > e.length) && (p = e.length);
		for (var m = 0, h = Array(p); m < p; m++) h[m] = e[m];
		return h;
	}
	function P() {
		/*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ P = function() {
			return e;
		};
		var e = {}, p = Object.prototype, m = p.hasOwnProperty, h = Object.defineProperty || function(e, p, m) {
			e[p] = m.value;
		}, g = typeof Symbol == "function" ? Symbol : {}, _ = g.iterator || "@@iterator", v = g.asyncIterator || "@@asyncIterator", y = g.toStringTag || "@@toStringTag";
		function b(e, p, m) {
			return Object.defineProperty(e, p, {
				value: m,
				enumerable: !0,
				configurable: !0,
				writable: !0
			}), e[p];
		}
		try {
			b({}, "");
		} catch {
			b = function(e, p, m) {
				return e[p] = m;
			};
		}
		function x(e, p, m, g) {
			var _ = p && p.prototype instanceof T ? p : T, v = Object.create(_.prototype), y = new z(g || []);
			return h(v, "_invoke", { value: F(e, m, y) }), v;
		}
		function S(e, p, m) {
			try {
				return {
					type: "normal",
					arg: e.call(p, m)
				};
			} catch (e) {
				return {
					type: "throw",
					arg: e
				};
			}
		}
		e.wrap = x;
		var C = {};
		function T() {}
		function E() {}
		function D() {}
		var O = {};
		b(O, _, function() {
			return this;
		});
		var k = Object.getPrototypeOf, A = k && k(k(B([])));
		A && A !== p && m.call(A, _) && (O = A);
		var j = D.prototype = T.prototype = Object.create(O);
		function M(e) {
			[
				"next",
				"throw",
				"return"
			].forEach(function(p) {
				b(e, p, function(e) {
					return this._invoke(p, e);
				});
			});
		}
		function N(e, p) {
			function g(h, _, v, y) {
				var b = S(e[h], e, _);
				if (b.type !== "throw") {
					var x = b.arg, C = x.value;
					return C && w(C) == "object" && m.call(C, "__await") ? p.resolve(C.__await).then(function(e) {
						g("next", e, v, y);
					}, function(e) {
						g("throw", e, v, y);
					}) : p.resolve(C).then(function(e) {
						x.value = e, v(x);
					}, function(e) {
						return g("throw", e, v, y);
					});
				}
				y(b.arg);
			}
			var _;
			h(this, "_invoke", { value: function(e, m) {
				function h() {
					return new p(function(p, h) {
						g(e, m, p, h);
					});
				}
				return _ = _ ? _.then(h, h) : h();
			} });
		}
		function F(e, p, m) {
			var h = "suspendedStart";
			return function(g, _) {
				if (h === "executing") throw Error("Generator is already running");
				if (h === "completed") {
					if (g === "throw") throw _;
					return V();
				}
				for (m.method = g, m.arg = _;;) {
					var v = m.delegate;
					if (v) {
						var y = I(v, m);
						if (y) {
							if (y === C) continue;
							return y;
						}
					}
					if (m.method === "next") m.sent = m._sent = m.arg;
					else if (m.method === "throw") {
						if (h === "suspendedStart") throw h = "completed", m.arg;
						m.dispatchException(m.arg);
					} else m.method === "return" && m.abrupt("return", m.arg);
					h = "executing";
					var b = S(e, p, m);
					if (b.type === "normal") {
						if (h = m.done ? "completed" : "suspendedYield", b.arg === C) continue;
						return {
							value: b.arg,
							done: m.done
						};
					}
					b.type === "throw" && (h = "completed", m.method = "throw", m.arg = b.arg);
				}
			};
		}
		function I(e, p) {
			var m = p.method, h = e.iterator[m];
			if (h === void 0) return p.delegate = null, m === "throw" && e.iterator.return && (p.method = "return", p.arg = void 0, I(e, p), p.method === "throw") || m !== "return" && (p.method = "throw", p.arg = /* @__PURE__ */ TypeError("The iterator does not provide a '" + m + "' method")), C;
			var g = S(h, e.iterator, p.arg);
			if (g.type === "throw") return p.method = "throw", p.arg = g.arg, p.delegate = null, C;
			var _ = g.arg;
			return _ ? _.done ? (p[e.resultName] = _.value, p.next = e.nextLoc, p.method !== "return" && (p.method = "next", p.arg = void 0), p.delegate = null, C) : _ : (p.method = "throw", p.arg = /* @__PURE__ */ TypeError("iterator result is not an object"), p.delegate = null, C);
		}
		function L(e) {
			var p = { tryLoc: e[0] };
			1 in e && (p.catchLoc = e[1]), 2 in e && (p.finallyLoc = e[2], p.afterLoc = e[3]), this.tryEntries.push(p);
		}
		function R(e) {
			var p = e.completion || {};
			p.type = "normal", delete p.arg, e.completion = p;
		}
		function z(e) {
			this.tryEntries = [{ tryLoc: "root" }], e.forEach(L, this), this.reset(!0);
		}
		function B(e) {
			if (e) {
				var p = e[_];
				if (p) return p.call(e);
				if (typeof e.next == "function") return e;
				if (!isNaN(e.length)) {
					var h = -1, g = function p() {
						for (; ++h < e.length;) if (m.call(e, h)) return p.value = e[h], p.done = !1, p;
						return p.value = void 0, p.done = !0, p;
					};
					return g.next = g;
				}
			}
			return { next: V };
		}
		function V() {
			return {
				value: void 0,
				done: !0
			};
		}
		return E.prototype = D, h(j, "constructor", {
			value: D,
			configurable: !0
		}), h(D, "constructor", {
			value: E,
			configurable: !0
		}), E.displayName = b(D, y, "GeneratorFunction"), e.isGeneratorFunction = function(e) {
			var p = typeof e == "function" && e.constructor;
			return !!p && (p === E || (p.displayName || p.name) === "GeneratorFunction");
		}, e.mark = function(e) {
			return Object.setPrototypeOf ? Object.setPrototypeOf(e, D) : (e.__proto__ = D, b(e, y, "GeneratorFunction")), e.prototype = Object.create(j), e;
		}, e.awrap = function(e) {
			return { __await: e };
		}, M(N.prototype), b(N.prototype, v, function() {
			return this;
		}), e.AsyncIterator = N, e.async = function(p, m, h, g, _) {
			_ === void 0 && (_ = Promise);
			var v = new N(x(p, m, h, g), _);
			return e.isGeneratorFunction(m) ? v : v.next().then(function(e) {
				return e.done ? e.value : v.next();
			});
		}, M(j), b(j, y, "Generator"), b(j, _, function() {
			return this;
		}), b(j, "toString", function() {
			return "[object Generator]";
		}), e.keys = function(e) {
			var p = Object(e), m = [];
			for (var h in p) m.push(h);
			return m.reverse(), function e() {
				for (; m.length;) {
					var h = m.pop();
					if (h in p) return e.value = h, e.done = !1, e;
				}
				return e.done = !0, e;
			};
		}, e.values = B, z.prototype = {
			constructor: z,
			reset: function(e) {
				if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(R), !e) for (var p in this) p.charAt(0) === "t" && m.call(this, p) && !isNaN(+p.slice(1)) && (this[p] = void 0);
			},
			stop: function() {
				this.done = !0;
				var e = this.tryEntries[0].completion;
				if (e.type === "throw") throw e.arg;
				return this.rval;
			},
			dispatchException: function(e) {
				if (this.done) throw e;
				var p = this;
				function h(m, h) {
					return v.type = "throw", v.arg = e, p.next = m, h && (p.method = "next", p.arg = void 0), !!h;
				}
				for (var g = this.tryEntries.length - 1; g >= 0; --g) {
					var _ = this.tryEntries[g], v = _.completion;
					if (_.tryLoc === "root") return h("end");
					if (_.tryLoc <= this.prev) {
						var y = m.call(_, "catchLoc"), b = m.call(_, "finallyLoc");
						if (y && b) {
							if (this.prev < _.catchLoc) return h(_.catchLoc, !0);
							if (this.prev < _.finallyLoc) return h(_.finallyLoc);
						} else if (y) {
							if (this.prev < _.catchLoc) return h(_.catchLoc, !0);
						} else {
							if (!b) throw Error("try statement without catch or finally");
							if (this.prev < _.finallyLoc) return h(_.finallyLoc);
						}
					}
				}
			},
			abrupt: function(e, p) {
				for (var h = this.tryEntries.length - 1; h >= 0; --h) {
					var g = this.tryEntries[h];
					if (g.tryLoc <= this.prev && m.call(g, "finallyLoc") && this.prev < g.finallyLoc) {
						var _ = g;
						break;
					}
				}
				_ && (e === "break" || e === "continue") && _.tryLoc <= p && p <= _.finallyLoc && (_ = null);
				var v = _ ? _.completion : {};
				return v.type = e, v.arg = p, _ ? (this.method = "next", this.next = _.finallyLoc, C) : this.complete(v);
			},
			complete: function(e, p) {
				if (e.type === "throw") throw e.arg;
				return e.type === "break" || e.type === "continue" ? this.next = e.arg : e.type === "return" ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : e.type === "normal" && p && (this.next = p), C;
			},
			finish: function(e) {
				for (var p = this.tryEntries.length - 1; p >= 0; --p) {
					var m = this.tryEntries[p];
					if (m.finallyLoc === e) return this.complete(m.completion, m.afterLoc), R(m), C;
				}
			},
			catch: function(e) {
				for (var p = this.tryEntries.length - 1; p >= 0; --p) {
					var m = this.tryEntries[p];
					if (m.tryLoc === e) {
						var h = m.completion;
						if (h.type === "throw") {
							var g = h.arg;
							R(m);
						}
						return g;
					}
				}
				throw Error("illegal catch attempt");
			},
			delegateYield: function(e, p, m) {
				return this.delegate = {
					iterator: B(e),
					resultName: p,
					nextLoc: m
				}, this.method === "next" && (this.arg = void 0), C;
			}
		}, e;
	}
	function F(e, p, m, h, g, _, v) {
		try {
			var y = e[_](v), b = y.value;
		} catch (e) {
			m(e);
			return;
		}
		y.done ? p(b) : Promise.resolve(b).then(h, g);
	}
	function I(e) {
		return function() {
			var p = this, m = arguments;
			return new Promise(function(h, g) {
				var _ = e.apply(p, m);
				function v(e) {
					F(_, h, g, v, y, "next", e);
				}
				function y(e) {
					F(_, h, g, v, y, "throw", e);
				}
				v(void 0);
			});
		};
	}
	function L(e, p) {
		if (!(e instanceof p)) throw TypeError("Cannot call a class as a function");
	}
	function R(e, p) {
		for (var m = 0; m < p.length; m++) {
			var h = p[m];
			h.enumerable = h.enumerable || !1, h.configurable = !0, "value" in h && (h.writable = !0), Object.defineProperty(e, J(h.key), h);
		}
	}
	function z(e, p, m) {
		return p && R(e.prototype, p), m && R(e, m), Object.defineProperty(e, "prototype", { writable: !1 }), e;
	}
	function B(e, p) {
		if (typeof p != "function" && p !== null) throw TypeError("Super expression must either be null or a function");
		e.prototype = Object.create(p && p.prototype, { constructor: {
			value: e,
			writable: !0,
			configurable: !0
		} }), Object.defineProperty(e, "prototype", { writable: !1 }), p && V(e, p);
	}
	function V(e, p) {
		return V = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, p) {
			return e.__proto__ = p, e;
		}, V(e, p);
	}
	function H(e) {
		var p = G();
		return function() {
			var m = K(e), h;
			if (p) {
				var g = K(this).constructor;
				h = Reflect.construct(m, arguments, g);
			} else h = m.apply(this, arguments);
			return U(this, h);
		};
	}
	function U(e, p) {
		if (p && (w(p) === "object" || typeof p == "function")) return p;
		if (p !== void 0) throw TypeError("Derived constructors may only return object or undefined");
		return W(e);
	}
	function W(e) {
		if (e === void 0) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
		return e;
	}
	function G() {
		if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
		if (typeof Proxy == "function") return !0;
		try {
			return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
		} catch {
			return !1;
		}
	}
	function K(e) {
		return K = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
			return e.__proto__ || Object.getPrototypeOf(e);
		}, K(e);
	}
	function q(e, p, m) {
		return p = J(p), p in e ? Object.defineProperty(e, p, {
			value: m,
			enumerable: !0,
			configurable: !0,
			writable: !0
		}) : e[p] = m, e;
	}
	function J(e) {
		var p = Y(e, "string");
		return w(p) === "symbol" ? p : String(p);
	}
	function Y(e, p) {
		if (w(e) !== "object" || e === null) return e;
		var m = e[Symbol.toPrimitive];
		if (m !== void 0) {
			var h = m.call(e, p || "default");
			if (w(h) !== "object") return h;
			throw TypeError("@@toPrimitive must return a primitive value.");
		}
		return (p === "string" ? String : Number)(e);
	}
	function X(e) {
		var p, m, h, g = 2;
		for (typeof Symbol < "u" && (m = Symbol.asyncIterator, h = Symbol.iterator); g--;) {
			if (m && (p = e[m]) != null) return p.call(e);
			if (h && (p = e[h]) != null) return new Z(p.call(e));
			m = "@@asyncIterator", h = "@@iterator";
		}
		throw TypeError("Object is not async iterable");
	}
	function Z(e) {
		function p(e) {
			if (Object(e) !== e) return Promise.reject(/* @__PURE__ */ TypeError(e + " is not an object."));
			var p = e.done;
			return Promise.resolve(e.value).then(function(e) {
				return {
					value: e,
					done: p
				};
			});
		}
		return Z = function(e) {
			this.s = e, this.n = e.next;
		}, Z.prototype = {
			s: null,
			n: null,
			next: function() {
				return p(this.n.apply(this.s, arguments));
			},
			return: function(e) {
				var m = this.s.return;
				return m === void 0 ? Promise.resolve({
					value: e,
					done: !0
				}) : p(m.apply(this.s, arguments));
			},
			throw: function(e) {
				var m = this.s.return;
				return m === void 0 ? Promise.reject(e) : p(m.apply(this.s, arguments));
			}
		}, new Z(e);
	}
	e.ClientWidgetApi = /* @__PURE__ */ function(e) {
		B(w, e);
		var p = H(w);
		function w(e, g, _) {
			var v;
			if (L(this, w), v = p.call(this), v.widget = e, v.driver = _, q(W(v), "transport", void 0), q(W(v), "cachedWidgetVersions", null), q(W(v), "contentLoadedActionSent", !1), q(W(v), "allowedCapabilities", /* @__PURE__ */ new Set()), q(W(v), "allowedEvents", []), q(W(v), "isStopped", !1), q(W(v), "turnServers", null), q(W(v), "contentLoadedWaitTimer", void 0), q(W(v), "pushRoomStateTasks", /* @__PURE__ */ new Set()), q(W(v), "pushRoomStateResult", /* @__PURE__ */ new Map()), q(W(v), "flushRoomStateTask", null), q(W(v), "viewedRoomId", null), !(g != null && g.contentWindow)) throw Error("No iframe supplied");
			if (!e) throw Error("Invalid widget");
			if (!_) throw Error("Invalid driver");
			return v.transport = new m.PostmessageTransport(h.WidgetApiDirection.ToWidget, e.id, g.contentWindow, globalThis), v.transport.targetOrigin = e.origin, v.transport.on("message", v.handleMessage.bind(W(v))), g.addEventListener("load", v.onIframeLoad.bind(W(v))), v.transport.start(), v;
		}
		return z(w, [
			{
				key: "hasCapability",
				value: function(e) {
					return this.allowedCapabilities.has(e);
				}
			},
			{
				key: "canUseRoomTimeline",
				value: function(e) {
					return this.hasCapability(`org.matrix.msc2762.timeline:${S.Symbols.AnyRoom}`) || this.hasCapability(`org.matrix.msc2762.timeline:${e}`);
				}
			},
			{
				key: "canSendRoomEvent",
				value: function(e) {
					var p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
					return this.allowedEvents.some(function(m) {
						return m.matchesAsRoomEvent(y.EventDirection.Send, e, p);
					});
				}
			},
			{
				key: "canSendStateEvent",
				value: function(e, p) {
					return this.allowedEvents.some(function(m) {
						return m.matchesAsStateEvent(y.EventDirection.Send, e, p);
					});
				}
			},
			{
				key: "canSendToDeviceEvent",
				value: function(e) {
					return this.allowedEvents.some(function(p) {
						return p.matchesAsToDeviceEvent(y.EventDirection.Send, e);
					});
				}
			},
			{
				key: "canReceiveRoomEvent",
				value: function(e) {
					var p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
					return this.allowedEvents.some(function(m) {
						return m.matchesAsRoomEvent(y.EventDirection.Receive, e, p);
					});
				}
			},
			{
				key: "canReceiveStateEvent",
				value: function(e, p) {
					return this.allowedEvents.some(function(m) {
						return m.matchesAsStateEvent(y.EventDirection.Receive, e, p);
					});
				}
			},
			{
				key: "canReceiveToDeviceEvent",
				value: function(e) {
					return this.allowedEvents.some(function(p) {
						return p.matchesAsToDeviceEvent(y.EventDirection.Receive, e);
					});
				}
			},
			{
				key: "canReceiveRoomAccountData",
				value: function(e) {
					return this.allowedEvents.some(function(p) {
						return p.matchesAsRoomAccountData(y.EventDirection.Receive, e);
					});
				}
			},
			{
				key: "stop",
				value: function() {
					this.isStopped = !0, this.transport.stop();
				}
			},
			{
				key: "getWidgetVersions",
				value: function() {
					var e = I(/* @__PURE__ */ P().mark(function e() {
						var p;
						return P().wrap(function(e) {
							for (;;) switch (e.prev = e.next) {
								case 0:
									if (!Array.isArray(this.cachedWidgetVersions)) {
										e.next = 2;
										break;
									}
									return e.abrupt("return", this.cachedWidgetVersions);
								case 2: return e.prev = 2, e.next = 5, this.transport.send(g.WidgetApiToWidgetAction.SupportedApiVersions, {});
								case 5: return p = e.sent, this.cachedWidgetVersions = p.supported_versions, e.abrupt("return", p.supported_versions);
								case 10: return e.prev = 10, e.t0 = e.catch(2), console.warn("non-fatal error getting supported widget versions: ", e.t0), e.abrupt("return", []);
								case 14:
								case "end": return e.stop();
							}
						}, e, this, [[2, 10]]);
					}));
					function p() {
						return e.apply(this, arguments);
					}
					return p;
				}()
			},
			{
				key: "beginCapabilities",
				value: function() {
					var e = this;
					this.emit("preparing");
					var p;
					this.transport.send(g.WidgetApiToWidgetAction.Capabilities, {}).then(function(m) {
						return p = m.capabilities, e.driver.validateCapabilities(new Set(m.capabilities));
					}).then(function(m) {
						e.allowCapabilities(O(m), p), e.emit("ready");
					}).catch(function(p) {
						e.emit("error:preparing", p);
					});
				}
			},
			{
				key: "allowCapabilities",
				value: function(e, p) {
					var m, h = this;
					console.log(`Widget ${this.widget.id} is allowed capabilities:`, e);
					var v = D(e), b;
					try {
						for (v.s(); !(b = v.n()).done;) {
							var x = b.value;
							this.allowedCapabilities.add(x);
						}
					} catch (e) {
						v.e(e);
					} finally {
						v.f();
					}
					var C = y.WidgetEventCapability.findEventCapabilities(e);
					(m = this.allowedEvents).push.apply(m, O(C)), this.transport.send(g.WidgetApiToWidgetAction.NotifyCapabilities, {
						requested: p,
						approved: Array.from(this.allowedCapabilities)
					}).catch(function(e) {
						console.warn("non-fatal error notifying widget of approved capabilities:", e);
					}).then(function() {
						h.emit("capabilitiesNotified");
					});
					var w = D(e), T;
					try {
						for (w.s(); !(T = w.n()).done;) {
							var E = T.value;
							if ((0, _.isTimelineCapability)(E)) {
								var k = (0, _.getTimelineRoomIDFromCapability)(E);
								if (k === S.Symbols.AnyRoom) {
									var A = D(this.driver.getKnownRooms()), j;
									try {
										for (A.s(); !(j = A.n()).done;) {
											var M = j.value;
											this.pushRoomState(M);
										}
									} catch (e) {
										A.e(e);
									} finally {
										A.f();
									}
								} else this.pushRoomState(k);
							}
						}
					} catch (e) {
						w.e(e);
					} finally {
						w.f();
					}
					if (e.includes(_.MatrixCapabilities.MSC4407ReceiveStickyEvent)) {
						console.debug(`Widget ${this.widget.id} is allowed to receive sticky events, check current sticky state.`);
						var N = e.filter(function(e) {
							return (0, _.isTimelineCapability)(e);
						}).map(function(e) {
							return (0, _.getTimelineRoomIDFromCapability)(e);
						}).flatMap(function(e) {
							return e === S.Symbols.AnyRoom ? h.driver.getKnownRooms() : e;
						});
						console.debug(`Widget ${this.widget.id} is allowed to receive sticky events in rooms:`, N);
						var P = D(N), F;
						try {
							var I = function() {
								var e = F.value;
								h.pushStickyState(e).catch(function(p) {
									console.error(`Failed to push sticky events to widget ${h.widget.id} for room ${e}:`, p);
								});
							};
							for (P.s(); !(F = P.n()).done;) I();
						} catch (e) {
							P.e(e);
						} finally {
							P.f();
						}
					}
					C.length > 0 && this.viewedRoomId !== null && !this.canUseRoomTimeline(this.viewedRoomId) && this.pushRoomState(this.viewedRoomId);
				}
			},
			{
				key: "onIframeLoad",
				value: function(e) {
					this.widget.waitForIframeLoad ? this.beginCapabilities() : (console.log("waitForIframeLoad is false: waiting for widget to send contentLoaded"), this.contentLoadedWaitTimer = setTimeout(function() {
						console.error("Widget specified waitForIframeLoad=false but timed out waiting for contentLoaded event!");
					}, 1e4), this.contentLoadedActionSent = !1);
				}
			},
			{
				key: "handleContentLoadedAction",
				value: function(e) {
					if (this.contentLoadedWaitTimer !== void 0 && (clearTimeout(this.contentLoadedWaitTimer), this.contentLoadedWaitTimer = void 0), this.contentLoadedActionSent) throw Error("Improper sequence: ContentLoaded Action can only be sent once after the widget loaded and should only be used if waitForIframeLoad is false (default=true)");
					this.widget.waitForIframeLoad ? this.transport.reply(e, { error: { message: "Improper sequence: not expecting ContentLoaded event if waitForIframeLoad is true (default=true)" } }) : (this.transport.reply(e, {}), this.beginCapabilities()), this.contentLoadedActionSent = !0;
				}
			},
			{
				key: "replyVersions",
				value: function(e) {
					this.transport.reply(e, { supported_versions: v.CurrentApiVersions });
				}
			},
			{
				key: "supportsUpdateState",
				value: function() {
					var e = I(/* @__PURE__ */ P().mark(function e() {
						return P().wrap(function(e) {
							for (;;) switch (e.prev = e.next) {
								case 0: return e.next = 2, this.getWidgetVersions();
								case 2: return e.abrupt("return", e.sent.includes(v.UnstableApiVersion.MSC2762_UPDATE_STATE));
								case 3:
								case "end": return e.stop();
							}
						}, e, this);
					}));
					function p() {
						return e.apply(this, arguments);
					}
					return p;
				}()
			},
			{
				key: "handleCapabilitiesRenegotiate",
				value: function(e) {
					var p = this;
					this.transport.reply(e, {});
					var m = e.data?.capabilities || [], h = new Set(m.filter(function(e) {
						return !p.hasCapability(e);
					}));
					h.size === 0 && this.allowCapabilities([], []), this.driver.validateCapabilities(h).then(function(e) {
						return p.allowCapabilities(O(e), O(h));
					});
				}
			},
			{
				key: "handleNavigate",
				value: function(e) {
					var p, m = this;
					if (!this.hasCapability(_.MatrixCapabilities.MSC2931Navigate)) return this.transport.reply(e, { error: { message: "Missing capability" } });
					if (!((p = e.data) != null && p.uri.startsWith("https://matrix.to/#"))) return this.transport.reply(e, { error: { message: "Invalid matrix.to URI" } });
					var h = function(p) {
						console.error("[ClientWidgetApi] Failed to handle navigation: ", p), m.handleDriverError(p, e, "Error handling navigation");
					};
					try {
						this.driver.navigate(e.data.uri.toString()).catch(function(e) {
							return h(e);
						}).then(function() {
							return m.transport.reply(e, {});
						});
					} catch (e) {
						return h(e);
					}
				}
			},
			{
				key: "handleOIDC",
				value: function(e) {
					var p = this, m = 1, h = function(h, _) {
						return _ ||= {}, m > 1 ? p.transport.send(g.WidgetApiToWidgetAction.OpenIDCredentials, E({
							state: h,
							original_request_id: e.requestId
						}, _)) : p.transport.reply(e, E({ state: h }, _));
					}, _ = function(g) {
						return console.error("[ClientWidgetApi] Failed to handle OIDC: ", g), m > 1 ? h(b.OpenIDRequestState.Blocked) : p.transport.reply(e, { error: { message: g } });
					}, v = new x.SimpleObservable(function(e) {
						if (e.state === b.OpenIDRequestState.PendingUserConfirmation && m > 1) return v.close(), _("client provided out-of-phase response to OIDC flow");
						if (e.state === b.OpenIDRequestState.PendingUserConfirmation) {
							h(e.state), m++;
							return;
						}
						return e.state === b.OpenIDRequestState.Allowed && !e.token ? _("client provided invalid OIDC token for an allowed request") : (e.state === b.OpenIDRequestState.Blocked && (e.token = void 0), v.close(), h(e.state, e.token));
					});
					this.driver.askOpenID(v);
				}
			},
			{
				key: "handleReadRoomAccountData",
				value: function(e) {
					var p = this, m = this.driver.readRoomAccountData(e.data.type);
					return this.canReceiveRoomAccountData(e.data.type) ? m.then(function(m) {
						p.transport.reply(e, { events: m });
					}) : this.transport.reply(e, { error: { message: "Cannot read room account data of this type" } });
				}
			},
			{
				key: "handleReadEvents",
				value: function() {
					var e = I(/* @__PURE__ */ P().mark(function e(p) {
						var m = this, h, g, _, v, y, b, x, C, w;
						return P().wrap(function(e) {
							for (;;) switch (e.prev = e.next) {
								case 0:
									if (p.data.type) {
										e.next = 2;
										break;
									}
									return e.abrupt("return", this.transport.reply(p, { error: { message: "Invalid request - missing event type" } }));
								case 2:
									if (!(p.data.limit !== void 0 && (!p.data.limit || p.data.limit < 0))) {
										e.next = 4;
										break;
									}
									return e.abrupt("return", this.transport.reply(p, { error: { message: "Invalid request - limit out of range" } }));
								case 4:
									if (p.data.room_ids !== void 0) {
										e.next = 8;
										break;
									}
									h = this.viewedRoomId === null ? [] : [this.viewedRoomId], e.next = 30;
									break;
								case 8:
									if (p.data.room_ids !== S.Symbols.AnyRoom) {
										e.next = 12;
										break;
									}
									h = this.driver.getKnownRooms().filter(function(e) {
										return m.canUseRoomTimeline(e);
									}), e.next = 30;
									break;
								case 12: h = p.data.room_ids, g = D(h), e.prev = 14, g.s();
								case 16:
									if ((_ = g.n()).done) {
										e.next = 22;
										break;
									}
									if (v = _.value, this.canUseRoomTimeline(v)) {
										e.next = 20;
										break;
									}
									return e.abrupt("return", this.transport.reply(p, { error: { message: `Unable to access room timeline: ${v}` } }));
								case 20:
									e.next = 16;
									break;
								case 22:
									e.next = 27;
									break;
								case 24: e.prev = 24, e.t0 = e.catch(14), g.e(e.t0);
								case 27: return e.prev = 27, g.f(), e.finish(27);
								case 30:
									if (y = p.data.limit || 0, b = p.data.since, x = void 0, C = void 0, p.data.state_key === void 0) {
										e.next = 40;
										break;
									}
									if (x = p.data.state_key === !0 ? void 0 : p.data.state_key.toString(), this.canReceiveStateEvent(p.data.type, x ?? null)) {
										e.next = 38;
										break;
									}
									return e.abrupt("return", this.transport.reply(p, { error: { message: "Cannot read state events of this type" } }));
								case 38:
									e.next = 43;
									break;
								case 40:
									if (C = p.data.msgtype, this.canReceiveRoomEvent(p.data.type, C)) {
										e.next = 43;
										break;
									}
									return e.abrupt("return", this.transport.reply(p, { error: { message: "Cannot read room events of this type" } }));
								case 43:
									if (!(p.data.room_ids === void 0 && h.length === 0)) {
										e.next = 50;
										break;
									}
									return console.warn("The widgetDriver uses deprecated behaviour:\n It does not set the viewedRoomId using `setViewedRoomId`"), e.next = 47, p.data.state_key === void 0 ? this.driver.readRoomEvents(p.data.type, C, y, null, b) : this.driver.readStateEvents(p.data.type, x, y, null);
								case 47:
									w = e.sent, e.next = 68;
									break;
								case 50: return e.next = 52, this.supportsUpdateState();
								case 52:
									if (!e.sent) {
										e.next = 58;
										break;
									}
									return e.next = 55, Promise.all(h.map(function(e) {
										return m.driver.readRoomTimeline(e, p.data.type, C, x, y, b);
									}));
								case 55:
									w = e.sent.flat(1), e.next = 68;
									break;
								case 58:
									if (p.data.state_key !== void 0) {
										e.next = 64;
										break;
									}
									return e.next = 61, Promise.all(h.map(function(e) {
										return m.driver.readRoomTimeline(e, p.data.type, C, x, y, b);
									}));
								case 61:
									e.t1 = e.sent, e.next = 67;
									break;
								case 64: return e.next = 66, Promise.all(h.map(function(e) {
									return m.driver.readRoomState(e, p.data.type, x);
								}));
								case 66: e.t1 = e.sent;
								case 67: w = e.t1.flat(1);
								case 68: this.transport.reply(p, { events: w });
								case 69:
								case "end": return e.stop();
							}
						}, e, this, [[
							14,
							24,
							27,
							30
						]]);
					}));
					function p(p) {
						return e.apply(this, arguments);
					}
					return p;
				}()
			},
			{
				key: "handleSendEvent",
				value: function(e) {
					var p = this;
					if (!e.data.type) return this.transport.reply(e, { error: { message: "Invalid request - missing event type" } });
					if (e.data.room_id && !this.canUseRoomTimeline(e.data.room_id)) return this.transport.reply(e, { error: { message: `Unable to access room timeline: ${e.data.room_id}` } });
					var m = e.data.delay !== void 0 || e.data.parent_delay_id !== void 0;
					if (m && !this.hasCapability(_.MatrixCapabilities.MSC4157SendDelayedEvent)) return this.transport.reply(e, { error: { message: `Missing capability for ${_.MatrixCapabilities.MSC4157SendDelayedEvent}` } });
					var h = e.data.sticky_duration_ms !== void 0;
					if (h && !this.hasCapability(_.MatrixCapabilities.MSC4407SendStickyEvent)) return this.transport.reply(e, { error: { message: `Missing capability for ${_.MatrixCapabilities.MSC4407SendStickyEvent}` } });
					var g;
					if (e.data.state_key !== void 0) {
						if (!this.canSendStateEvent(e.data.type, e.data.state_key)) return this.transport.reply(e, { error: { message: "Cannot send state events of this type" } });
						if (h) return this.transport.reply(e, { error: { message: "Cannot send a state event with a sticky duration" } });
						g = m ? this.driver.sendDelayedEvent(e.data.delay ?? null, e.data.parent_delay_id ?? null, e.data.type, e.data.content || {}, e.data.state_key, e.data.room_id) : this.driver.sendEvent(e.data.type, e.data.content || {}, e.data.state_key, e.data.room_id);
					} else {
						var v = e.data.content || {}, y = v.msgtype;
						if (!this.canSendRoomEvent(e.data.type, y)) return this.transport.reply(e, { error: { message: "Cannot send room events of this type" } });
						var b = [
							e.data.type,
							v,
							null,
							e.data.room_id
						];
						if (m && e.data.sticky_duration_ms) g = this.driver.sendDelayedStickyEvent(e.data.delay ?? null, e.data.parent_delay_id ?? null, e.data.sticky_duration_ms, e.data.type, v, e.data.room_id);
						else if (m) {
							var x;
							g = (x = this.driver).sendDelayedEvent.apply(x, [e.data.delay ?? null, e.data.parent_delay_id ?? null].concat(b));
						} else if (e.data.sticky_duration_ms) g = this.driver.sendStickyEvent(e.data.sticky_duration_ms, e.data.type, v, e.data.room_id);
						else {
							var S;
							g = (S = this.driver).sendEvent.apply(S, b);
						}
					}
					g.then(function(m) {
						return p.transport.reply(e, E({ room_id: m.roomId }, "eventId" in m ? { event_id: m.eventId } : { delay_id: m.delayId }));
					}).catch(function(m) {
						console.error("error sending event: ", m), p.handleDriverError(m, e, "Error sending event");
					});
				}
			},
			{
				key: "handleUpdateDelayedEvent",
				value: function(e) {
					var p = this;
					if (!e.data.delay_id) return this.transport.reply(e, { error: { message: "Invalid request - missing delay_id" } });
					if (!this.hasCapability(_.MatrixCapabilities.MSC4157UpdateDelayedEvent)) return this.transport.reply(e, { error: { message: "Missing capability" } });
					var m;
					switch (e.data.action) {
						case C.UpdateDelayedEventAction.Cancel:
							m = this.driver.cancelScheduledDelayedEvent;
							break;
						case C.UpdateDelayedEventAction.Restart:
							m = this.driver.restartScheduledDelayedEvent;
							break;
						case C.UpdateDelayedEventAction.Send:
							m = this.driver.sendScheduledDelayedEvent;
							break;
						default: return this.transport.reply(e, { error: { message: "Invalid request - unsupported action" } });
					}
					m.call(this.driver, e.data.delay_id).then(function() {
						return p.transport.reply(e, {});
					}).catch(function(m) {
						console.error("error updating delayed event: ", m), p.handleDriverError(m, e, "Error updating delayed event");
					});
				}
			},
			{
				key: "handleSendToDevice",
				value: function() {
					var e = I(/* @__PURE__ */ P().mark(function e(p) {
						return P().wrap(function(e) {
							for (;;) switch (e.prev = e.next) {
								case 0:
									if (p.data.type) {
										e.next = 4;
										break;
									}
									this.transport.reply(p, { error: { message: "Invalid request - missing event type" } }), e.next = 26;
									break;
								case 4:
									if (p.data.messages) {
										e.next = 8;
										break;
									}
									this.transport.reply(p, { error: { message: "Invalid request - missing event contents" } }), e.next = 26;
									break;
								case 8:
									if (typeof p.data.encrypted == "boolean") {
										e.next = 12;
										break;
									}
									this.transport.reply(p, { error: { message: "Invalid request - missing encryption flag" } }), e.next = 26;
									break;
								case 12:
									if (this.canSendToDeviceEvent(p.data.type)) {
										e.next = 16;
										break;
									}
									this.transport.reply(p, { error: { message: "Cannot send to-device events of this type" } }), e.next = 26;
									break;
								case 16: return e.prev = 16, e.next = 19, this.driver.sendToDevice(p.data.type, p.data.encrypted, p.data.messages);
								case 19:
									this.transport.reply(p, {}), e.next = 26;
									break;
								case 22: e.prev = 22, e.t0 = e.catch(16), console.error("error sending to-device event", e.t0), this.handleDriverError(e.t0, p, "Error sending event");
								case 26:
								case "end": return e.stop();
							}
						}, e, this, [[16, 22]]);
					}));
					function p(p) {
						return e.apply(this, arguments);
					}
					return p;
				}()
			},
			{
				key: "pollTurnServers",
				value: function() {
					var e = I(/* @__PURE__ */ P().mark(function e(p, m) {
						var h, _, v, y, b, x;
						return P().wrap(function(e) {
							for (;;) switch (e.prev = e.next) {
								case 0: return e.prev = 0, e.next = 3, this.transport.send(g.WidgetApiToWidgetAction.UpdateTurnServers, m);
								case 3: h = !1, _ = !1, e.prev = 5, y = X(p);
								case 7: return e.next = 9, y.next();
								case 9:
									if (!(h = !(b = e.sent).done)) {
										e.next = 16;
										break;
									}
									return x = b.value, e.next = 13, this.transport.send(g.WidgetApiToWidgetAction.UpdateTurnServers, x);
								case 13:
									h = !1, e.next = 7;
									break;
								case 16:
									e.next = 22;
									break;
								case 18: e.prev = 18, e.t0 = e.catch(5), _ = !0, v = e.t0;
								case 22:
									if (e.prev = 22, e.prev = 23, !(h && y.return != null)) {
										e.next = 27;
										break;
									}
									return e.next = 27, y.return();
								case 27:
									if (e.prev = 27, !_) {
										e.next = 30;
										break;
									}
									throw v;
								case 30: return e.finish(27);
								case 31: return e.finish(22);
								case 32:
									e.next = 37;
									break;
								case 34: e.prev = 34, e.t1 = e.catch(0), console.error("error polling for TURN servers", e.t1);
								case 37:
								case "end": return e.stop();
							}
						}, e, this, [
							[0, 34],
							[
								5,
								18,
								22,
								32
							],
							[
								23,
								,
								27,
								31
							]
						]);
					}));
					function p(p, m) {
						return e.apply(this, arguments);
					}
					return p;
				}()
			},
			{
				key: "handleWatchTurnServers",
				value: function() {
					var e = I(/* @__PURE__ */ P().mark(function e(p) {
						var m, h, g, v;
						return P().wrap(function(e) {
							for (;;) switch (e.prev = e.next) {
								case 0:
									if (this.hasCapability(_.MatrixCapabilities.MSC3846TurnServers)) {
										e.next = 4;
										break;
									}
									this.transport.reply(p, { error: { message: "Missing capability" } }), e.next = 26;
									break;
								case 4:
									if (!this.turnServers) {
										e.next = 8;
										break;
									}
									this.transport.reply(p, {}), e.next = 26;
									break;
								case 8: return e.prev = 8, m = this.driver.getTurnServers(), e.next = 12, m.next();
								case 12:
									if (h = e.sent, g = h.done, v = h.value, !g) {
										e.next = 17;
										break;
									}
									throw Error("Client refuses to provide any TURN servers");
								case 17:
									this.transport.reply(p, {}), this.pollTurnServers(m, v), this.turnServers = m, e.next = 26;
									break;
								case 22: e.prev = 22, e.t0 = e.catch(8), console.error("error getting first TURN server results", e.t0), this.transport.reply(p, { error: { message: "TURN servers not available" } });
								case 26:
								case "end": return e.stop();
							}
						}, e, this, [[8, 22]]);
					}));
					function p(p) {
						return e.apply(this, arguments);
					}
					return p;
				}()
			},
			{
				key: "handleUnwatchTurnServers",
				value: function() {
					var e = I(/* @__PURE__ */ P().mark(function e(p) {
						return P().wrap(function(e) {
							for (;;) switch (e.prev = e.next) {
								case 0:
									if (this.hasCapability(_.MatrixCapabilities.MSC3846TurnServers)) {
										e.next = 4;
										break;
									}
									this.transport.reply(p, { error: { message: "Missing capability" } }), e.next = 12;
									break;
								case 4:
									if (this.turnServers) {
										e.next = 8;
										break;
									}
									this.transport.reply(p, {}), e.next = 12;
									break;
								case 8: return e.next = 10, this.turnServers.return(void 0);
								case 10: this.turnServers = null, this.transport.reply(p, {});
								case 12:
								case "end": return e.stop();
							}
						}, e, this);
					}));
					function p(p) {
						return e.apply(this, arguments);
					}
					return p;
				}()
			},
			{
				key: "handleReadRelations",
				value: function() {
					var e = I(/* @__PURE__ */ P().mark(function e(p) {
						var m = this, h, g;
						return P().wrap(function(e) {
							for (;;) switch (e.prev = e.next) {
								case 0:
									if (p.data.event_id) {
										e.next = 2;
										break;
									}
									return e.abrupt("return", this.transport.reply(p, { error: { message: "Invalid request - missing event ID" } }));
								case 2:
									if (!(p.data.limit !== void 0 && p.data.limit < 0)) {
										e.next = 4;
										break;
									}
									return e.abrupt("return", this.transport.reply(p, { error: { message: "Invalid request - limit out of range" } }));
								case 4:
									if (!(p.data.room_id !== void 0 && !this.canUseRoomTimeline(p.data.room_id))) {
										e.next = 6;
										break;
									}
									return e.abrupt("return", this.transport.reply(p, { error: { message: `Unable to access room timeline: ${p.data.room_id}` } }));
								case 6: return e.prev = 6, e.next = 9, this.driver.readEventRelations(p.data.event_id, p.data.room_id, p.data.rel_type, p.data.event_type, p.data.from, p.data.to, p.data.limit, p.data.direction);
								case 9: return h = e.sent, g = h.chunk.filter(function(e) {
									return e.state_key === void 0 ? m.canReceiveRoomEvent(e.type, e.content.msgtype) : m.canReceiveStateEvent(e.type, e.state_key);
								}), e.abrupt("return", this.transport.reply(p, {
									chunk: g,
									prev_batch: h.prevBatch,
									next_batch: h.nextBatch
								}));
								case 14: e.prev = 14, e.t0 = e.catch(6), console.error("error getting the relations", e.t0), this.handleDriverError(e.t0, p, "Unexpected error while reading relations");
								case 18:
								case "end": return e.stop();
							}
						}, e, this, [[6, 14]]);
					}));
					function p(p) {
						return e.apply(this, arguments);
					}
					return p;
				}()
			},
			{
				key: "handleUserDirectorySearch",
				value: function() {
					var e = I(/* @__PURE__ */ P().mark(function e(p) {
						var m;
						return P().wrap(function(e) {
							for (;;) switch (e.prev = e.next) {
								case 0:
									if (this.hasCapability(_.MatrixCapabilities.MSC3973UserDirectorySearch)) {
										e.next = 2;
										break;
									}
									return e.abrupt("return", this.transport.reply(p, { error: { message: "Missing capability" } }));
								case 2:
									if (typeof p.data.search_term == "string") {
										e.next = 4;
										break;
									}
									return e.abrupt("return", this.transport.reply(p, { error: { message: "Invalid request - missing search term" } }));
								case 4:
									if (!(p.data.limit !== void 0 && p.data.limit < 0)) {
										e.next = 6;
										break;
									}
									return e.abrupt("return", this.transport.reply(p, { error: { message: "Invalid request - limit out of range" } }));
								case 6: return e.prev = 6, e.next = 9, this.driver.searchUserDirectory(p.data.search_term, p.data.limit);
								case 9: return m = e.sent, e.abrupt("return", this.transport.reply(p, {
									limited: m.limited,
									results: m.results.map(function(e) {
										return {
											user_id: e.userId,
											display_name: e.displayName,
											avatar_url: e.avatarUrl
										};
									})
								}));
								case 13: e.prev = 13, e.t0 = e.catch(6), console.error("error searching in the user directory", e.t0), this.handleDriverError(e.t0, p, "Unexpected error while searching in the user directory");
								case 17:
								case "end": return e.stop();
							}
						}, e, this, [[6, 13]]);
					}));
					function p(p) {
						return e.apply(this, arguments);
					}
					return p;
				}()
			},
			{
				key: "handleGetMediaConfig",
				value: function() {
					var e = I(/* @__PURE__ */ P().mark(function e(p) {
						var m;
						return P().wrap(function(e) {
							for (;;) switch (e.prev = e.next) {
								case 0:
									if (this.hasCapability(_.MatrixCapabilities.MSC4039UploadFile)) {
										e.next = 2;
										break;
									}
									return e.abrupt("return", this.transport.reply(p, { error: { message: "Missing capability" } }));
								case 2: return e.prev = 2, e.next = 5, this.driver.getMediaConfig();
								case 5: return m = e.sent, e.abrupt("return", this.transport.reply(p, m));
								case 9: e.prev = 9, e.t0 = e.catch(2), console.error("error while getting the media configuration", e.t0), this.handleDriverError(e.t0, p, "Unexpected error while getting the media configuration");
								case 13:
								case "end": return e.stop();
							}
						}, e, this, [[2, 9]]);
					}));
					function p(p) {
						return e.apply(this, arguments);
					}
					return p;
				}()
			},
			{
				key: "handleUploadFile",
				value: function() {
					var e = I(/* @__PURE__ */ P().mark(function e(p) {
						var m;
						return P().wrap(function(e) {
							for (;;) switch (e.prev = e.next) {
								case 0:
									if (this.hasCapability(_.MatrixCapabilities.MSC4039UploadFile)) {
										e.next = 2;
										break;
									}
									return e.abrupt("return", this.transport.reply(p, { error: { message: "Missing capability" } }));
								case 2: return e.prev = 2, e.next = 5, this.driver.uploadFile(p.data.file);
								case 5: return m = e.sent, e.abrupt("return", this.transport.reply(p, { content_uri: m.contentUri }));
								case 9: e.prev = 9, e.t0 = e.catch(2), console.error("error while uploading a file", e.t0), this.handleDriverError(e.t0, p, "Unexpected error while uploading a file");
								case 13:
								case "end": return e.stop();
							}
						}, e, this, [[2, 9]]);
					}));
					function p(p) {
						return e.apply(this, arguments);
					}
					return p;
				}()
			},
			{
				key: "handleDownloadFile",
				value: function() {
					var e = I(/* @__PURE__ */ P().mark(function e(p) {
						var m;
						return P().wrap(function(e) {
							for (;;) switch (e.prev = e.next) {
								case 0:
									if (this.hasCapability(_.MatrixCapabilities.MSC4039DownloadFile)) {
										e.next = 2;
										break;
									}
									return e.abrupt("return", this.transport.reply(p, { error: { message: "Missing capability" } }));
								case 2: return e.prev = 2, e.next = 5, this.driver.downloadFile(p.data.content_uri);
								case 5: return m = e.sent, e.abrupt("return", this.transport.reply(p, { file: m.file }));
								case 9: e.prev = 9, e.t0 = e.catch(2), console.error("error while downloading a file", e.t0), this.handleDriverError(e.t0, p, "Unexpected error while downloading a file");
								case 13:
								case "end": return e.stop();
							}
						}, e, this, [[2, 9]]);
					}));
					function p(p) {
						return e.apply(this, arguments);
					}
					return p;
				}()
			},
			{
				key: "handleDriverError",
				value: function(e, p, m) {
					var h = this.driver.processError(e);
					this.transport.reply(p, { error: E({ message: m }, h) });
				}
			},
			{
				key: "handleMessage",
				value: function(e) {
					if (!this.isStopped) {
						var p = new CustomEvent(`action:${e.detail.action}`, {
							detail: e.detail,
							cancelable: !0
						});
						if (this.emit(`action:${e.detail.action}`, p), !p.defaultPrevented) switch (e.detail.action) {
							case g.WidgetApiFromWidgetAction.ContentLoaded: return this.handleContentLoadedAction(e.detail);
							case g.WidgetApiFromWidgetAction.SupportedApiVersions: return this.replyVersions(e.detail);
							case g.WidgetApiFromWidgetAction.SendEvent: return this.handleSendEvent(e.detail);
							case g.WidgetApiFromWidgetAction.SendToDevice: return this.handleSendToDevice(e.detail);
							case g.WidgetApiFromWidgetAction.GetOpenIDCredentials: return this.handleOIDC(e.detail);
							case g.WidgetApiFromWidgetAction.MSC2931Navigate: return this.handleNavigate(e.detail);
							case g.WidgetApiFromWidgetAction.MSC2974RenegotiateCapabilities: return this.handleCapabilitiesRenegotiate(e.detail);
							case g.WidgetApiFromWidgetAction.MSC2876ReadEvents: return this.handleReadEvents(e.detail);
							case g.WidgetApiFromWidgetAction.WatchTurnServers: return this.handleWatchTurnServers(e.detail);
							case g.WidgetApiFromWidgetAction.UnwatchTurnServers: return this.handleUnwatchTurnServers(e.detail);
							case g.WidgetApiFromWidgetAction.MSC3869ReadRelations: return this.handleReadRelations(e.detail);
							case g.WidgetApiFromWidgetAction.MSC3973UserDirectorySearch: return this.handleUserDirectorySearch(e.detail);
							case g.WidgetApiFromWidgetAction.BeeperReadRoomAccountData: return this.handleReadRoomAccountData(e.detail);
							case g.WidgetApiFromWidgetAction.MSC4039GetMediaConfigAction: return this.handleGetMediaConfig(e.detail);
							case g.WidgetApiFromWidgetAction.MSC4039UploadFileAction: return this.handleUploadFile(e.detail);
							case g.WidgetApiFromWidgetAction.MSC4039DownloadFileAction: return this.handleDownloadFile(e.detail);
							case g.WidgetApiFromWidgetAction.MSC4157UpdateDelayedEvent: return this.handleUpdateDelayedEvent(e.detail);
							default: return this.transport.reply(e.detail, { error: { message: "Unknown or unsupported from-widget action: " + e.detail.action } });
						}
					}
				}
			},
			{
				key: "updateTheme",
				value: function(e) {
					return this.transport.send(g.WidgetApiToWidgetAction.ThemeChange, e);
				}
			},
			{
				key: "updateLanguage",
				value: function(e) {
					return this.transport.send(g.WidgetApiToWidgetAction.LanguageChange, { lang: e });
				}
			},
			{
				key: "takeScreenshot",
				value: function() {
					return this.transport.send(g.WidgetApiToWidgetAction.TakeScreenshot, {});
				}
			},
			{
				key: "updateVisibility",
				value: function(e) {
					return this.transport.send(g.WidgetApiToWidgetAction.UpdateVisibility, { visible: e });
				}
			},
			{
				key: "sendWidgetConfig",
				value: function(e) {
					return this.transport.send(g.WidgetApiToWidgetAction.WidgetConfig, e).then();
				}
			},
			{
				key: "notifyModalWidgetButtonClicked",
				value: function(e) {
					return this.transport.send(g.WidgetApiToWidgetAction.ButtonClicked, { id: e }).then();
				}
			},
			{
				key: "notifyModalWidgetClose",
				value: function(e) {
					return this.transport.send(g.WidgetApiToWidgetAction.CloseModalWidget, e).then();
				}
			},
			{
				key: "feedEvent",
				value: function() {
					var e = I(/* @__PURE__ */ P().mark(function e(p, m) {
						return P().wrap(function(e) {
							for (;;) switch (e.prev = e.next) {
								case 0:
									if (m !== void 0 && this.setViewedRoomId(m), !(p.room_id !== this.viewedRoomId && !this.canUseRoomTimeline(p.room_id))) {
										e.next = 3;
										break;
									}
									return e.abrupt("return");
								case 3:
									if (!(p.state_key !== void 0 && p.state_key !== null)) {
										e.next = 8;
										break;
									}
									if (this.canReceiveStateEvent(p.type, p.state_key)) {
										e.next = 6;
										break;
									}
									return e.abrupt("return");
								case 6:
									e.next = 10;
									break;
								case 8:
									if (this.canReceiveRoomEvent(p.type, p.content?.msgtype)) {
										e.next = 10;
										break;
									}
									return e.abrupt("return");
								case 10: return e.next = 12, this.transport.send(g.WidgetApiToWidgetAction.SendEvent, p);
								case 12:
								case "end": return e.stop();
							}
						}, e, this);
					}));
					function p(p, m) {
						return e.apply(this, arguments);
					}
					return p;
				}()
			},
			{
				key: "feedToDevice",
				value: function() {
					var e = I(/* @__PURE__ */ P().mark(function e(p, m) {
						return P().wrap(function(e) {
							for (;;) switch (e.prev = e.next) {
								case 0:
									if (!this.canReceiveToDeviceEvent(p.type)) {
										e.next = 3;
										break;
									}
									return e.next = 3, this.transport.send(g.WidgetApiToWidgetAction.SendToDevice, E(E({}, p), {}, { encrypted: m }));
								case 3:
								case "end": return e.stop();
							}
						}, e, this);
					}));
					function p(p, m) {
						return e.apply(this, arguments);
					}
					return p;
				}()
			},
			{
				key: "setViewedRoomId",
				value: function(e) {
					this.viewedRoomId = e, e !== null && !this.canUseRoomTimeline(e) && this.pushRoomState(e);
				}
			},
			{
				key: "flushRoomState",
				value: function() {
					var e = I(/* @__PURE__ */ P().mark(function e() {
						var p, m, h, _, y, b, x;
						return P().wrap(function(e) {
							for (;;) switch (e.prev = e.next) {
								case 0: e.prev = 0;
								case 1: return e.next = 3, Promise.all(this.pushRoomStateTasks);
								case 3: if (this.pushRoomStateTasks.size > 0) {
									e.next = 1;
									break;
								}
								case 4:
									p = [], m = D(this.pushRoomStateResult.values());
									try {
										for (m.s(); !(h = m.n()).done;) {
											_ = h.value, y = D(_.values());
											try {
												for (y.s(); !(b = y.n()).done;) x = b.value, p.push.apply(p, O(x.values()));
											} catch (e) {
												y.e(e);
											} finally {
												y.f();
											}
										}
									} catch (e) {
										m.e(e);
									} finally {
										m.f();
									}
									return e.next = 9, this.getWidgetVersions();
								case 9:
									if (!e.sent.includes(v.UnstableApiVersion.MSC2762_UPDATE_STATE)) {
										e.next = 12;
										break;
									}
									return e.next = 12, this.transport.send(g.WidgetApiToWidgetAction.UpdateState, { state: p });
								case 12: return e.prev = 12, this.flushRoomStateTask = null, e.finish(12);
								case 15:
								case "end": return e.stop();
							}
						}, e, this, [[
							0,
							,
							12,
							15
						]]);
					}));
					function p() {
						return e.apply(this, arguments);
					}
					return p;
				}()
			},
			{
				key: "pushStickyState",
				value: function() {
					var e = I(/* @__PURE__ */ P().mark(function e(p) {
						var m = this;
						return P().wrap(function(e) {
							for (;;) switch (e.prev = e.next) {
								case 0: return console.debug("Pushing sticky state to widget for room", p), e.abrupt("return", this.driver.readStickyEvents(p).then(function(e) {
									var h = e.filter(function(e) {
										return m.canReceiveRoomEvent(e.type, typeof e.content?.msgtype == "string" ? e.content.msgtype : null);
									});
									return {
										roomId: p,
										stickyEvents: h
									};
								}).then(/* @__PURE__ */ function() {
									var e = I(/* @__PURE__ */ P().mark(function e(p) {
										var h, _, v;
										return P().wrap(function(e) {
											for (;;) switch (e.prev = e.next) {
												case 0: return h = p.roomId, _ = p.stickyEvents, console.debug("Pushing", _.length, "sticky events to widget for room", h), v = _.map(function(e) {
													return m.transport.send(g.WidgetApiToWidgetAction.SendEvent, e);
												}), e.next = 5, Promise.all(v);
												case 5:
												case "end": return e.stop();
											}
										}, e);
									}));
									return function(p) {
										return e.apply(this, arguments);
									};
								}()));
								case 2:
								case "end": return e.stop();
							}
						}, e, this);
					}));
					function p(p) {
						return e.apply(this, arguments);
					}
					return p;
				}()
			},
			{
				key: "pushRoomState",
				value: function(e) {
					var p = this, m = D(this.allowedEvents), h;
					try {
						var g = function() {
							var m = h.value;
							if (m.kind === y.EventKind.State && m.direction === y.EventDirection.Receive) {
								var g = p.driver.readRoomState(e, m.eventType, m.keyStr ?? void 0).then(function(h) {
									var g = D(h), _;
									try {
										for (g.s(); !(_ = g.n()).done;) {
											var v = _.value, y = p.pushRoomStateResult.get(e);
											y === void 0 && (y = /* @__PURE__ */ new Map(), p.pushRoomStateResult.set(e, y));
											var b = y.get(m.eventType);
											b === void 0 && (b = /* @__PURE__ */ new Map(), y.set(m.eventType, b)), b.has(v.state_key) || b.set(v.state_key, v);
										}
									} catch (e) {
										g.e(e);
									} finally {
										g.f();
									}
								}, function(p) {
									return console.error(`Failed to read room state for ${e} (${m.eventType}, ${m.keyStr})`, p);
								}).then(function() {
									p.pushRoomStateTasks.delete(g);
								});
								p.pushRoomStateTasks.add(g), p.flushRoomStateTask ??= p.flushRoomState(), p.flushRoomStateTask.catch(function(e) {
									return console.error("Failed to push room state", e);
								});
							}
						};
						for (m.s(); !(h = m.n()).done;) g();
					} catch (e) {
						m.e(e);
					} finally {
						m.f();
					}
				}
			},
			{
				key: "feedStateUpdate",
				value: function() {
					var e = I(/* @__PURE__ */ P().mark(function e(p) {
						var m, h;
						return P().wrap(function(e) {
							for (;;) switch (e.prev = e.next) {
								case 0:
									if (p.state_key !== void 0) {
										e.next = 2;
										break;
									}
									throw Error("Not a state event");
								case 2:
									if (!((p.room_id === this.viewedRoomId || this.canUseRoomTimeline(p.room_id)) && this.canReceiveStateEvent(p.type, p.state_key))) {
										e.next = 21;
										break;
									}
									if (this.pushRoomStateTasks.size !== 0) {
										e.next = 11;
										break;
									}
									return e.next = 6, this.getWidgetVersions();
								case 6:
									if (!e.sent.includes(v.UnstableApiVersion.MSC2762_UPDATE_STATE)) {
										e.next = 9;
										break;
									}
									return e.next = 9, this.transport.send(g.WidgetApiToWidgetAction.UpdateState, { state: [p] });
								case 9:
									e.next = 21;
									break;
								case 11: m = this.pushRoomStateResult.get(p.room_id), m === void 0 && (m = /* @__PURE__ */ new Map(), this.pushRoomStateResult.set(p.room_id, m)), h = m.get(p.type), h === void 0 && (h = /* @__PURE__ */ new Map(), m.set(p.type, h)), h.has(p.type) || h.set(p.state_key, p);
								case 16: return e.next = 18, Promise.all(this.pushRoomStateTasks);
								case 18: if (this.pushRoomStateTasks.size > 0) {
									e.next = 16;
									break;
								}
								case 19: return e.next = 21, this.flushRoomStateTask;
								case 21:
								case "end": return e.stop();
							}
						}, e, this);
					}));
					function p(p) {
						return e.apply(this, arguments);
					}
					return p;
				}()
			}
		]), w;
	}(p.EventEmitter);
})), require_IWidgetApiErrorResponse = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.isErrorResponse = m;
	function p(e) {
		"@babel/helpers - typeof";
		return p = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
			return typeof e;
		} : function(e) {
			return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
		}, p(e);
	}
	function m(e) {
		var m = e.error;
		return p(m) === "object" && m !== null && "message" in m && typeof m.message == "string";
	}
})), require_WidgetKind = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.WidgetKind = /* @__PURE__ */ function(e) {
		return e.Room = "room", e.Account = "account", e.Modal = "modal", e;
	}({});
})), require_ModalButtonKind = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.ModalButtonKind = /* @__PURE__ */ function(e) {
		return e.Primary = "m.primary", e.Secondary = "m.secondary", e.Warning = "m.warning", e.Danger = "m.danger", e.Link = "m.link", e;
	}({});
})), require_url = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.isValidUrl = p;
	function p(e) {
		if (!e) return !1;
		try {
			var p = new URL(e);
			return !(p.protocol !== "http" && p.protocol !== "https");
		} catch (e) {
			if (e instanceof TypeError) return !1;
			throw e;
		}
	}
})), require_utils = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.assertPresent = p;
	function p(e, p) {
		if (!e[p]) throw Error(`${String(p)} is required`);
	}
})), require_Widget = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var p = require_lib(), m = require_utils();
	function h(e) {
		"@babel/helpers - typeof";
		return h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
			return typeof e;
		} : function(e) {
			return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
		}, h(e);
	}
	function g(e, p) {
		if (!(e instanceof p)) throw TypeError("Cannot call a class as a function");
	}
	function _(e, p) {
		for (var m = 0; m < p.length; m++) {
			var h = p[m];
			h.enumerable = h.enumerable || !1, h.configurable = !0, "value" in h && (h.writable = !0), Object.defineProperty(e, y(h.key), h);
		}
	}
	function v(e, p, m) {
		return p && _(e.prototype, p), m && _(e, m), Object.defineProperty(e, "prototype", { writable: !1 }), e;
	}
	function y(e) {
		var p = b(e, "string");
		return h(p) === "symbol" ? p : String(p);
	}
	function b(e, p) {
		if (h(e) !== "object" || e === null) return e;
		var m = e[Symbol.toPrimitive];
		if (m !== void 0) {
			var g = m.call(e, p || "default");
			if (h(g) !== "object") return g;
			throw TypeError("@@toPrimitive must return a primitive value.");
		}
		return (p === "string" ? String : Number)(e);
	}
	e.Widget = /* @__PURE__ */ function() {
		function e(p) {
			if (g(this, e), this.definition = p, !this.definition) throw Error("Definition is required");
			(0, m.assertPresent)(p, "id"), (0, m.assertPresent)(p, "creatorUserId"), (0, m.assertPresent)(p, "type"), (0, m.assertPresent)(p, "url");
		}
		return v(e, [
			{
				key: "creatorUserId",
				get: function() {
					return this.definition.creatorUserId;
				}
			},
			{
				key: "type",
				get: function() {
					return this.definition.type;
				}
			},
			{
				key: "id",
				get: function() {
					return this.definition.id;
				}
			},
			{
				key: "name",
				get: function() {
					return this.definition.name || null;
				}
			},
			{
				key: "title",
				get: function() {
					return this.rawData.title || null;
				}
			},
			{
				key: "templateUrl",
				get: function() {
					return this.definition.url;
				}
			},
			{
				key: "origin",
				get: function() {
					return new URL(this.templateUrl).origin;
				}
			},
			{
				key: "waitForIframeLoad",
				get: function() {
					return this.definition.waitForIframeLoad === !1 ? !1 : (this.definition.waitForIframeLoad, !0);
				}
			},
			{
				key: "rawData",
				get: function() {
					return this.definition.data || {};
				}
			},
			{
				key: "getCompleteUrl",
				value: function(e) {
					return (0, p.runTemplate)(this.templateUrl, this.definition, e);
				}
			}
		]), e;
	}();
})), require_WidgetParser = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var p = require_Widget(), m = require_url();
	function h(e) {
		"@babel/helpers - typeof";
		return h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
			return typeof e;
		} : function(e) {
			return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
		}, h(e);
	}
	function g(e, p) {
		var m = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
		if (!m) {
			if (Array.isArray(e) || (m = _(e)) || p && e && typeof e.length == "number") {
				m && (e = m);
				var h = 0, g = function() {};
				return {
					s: g,
					n: function() {
						return h >= e.length ? { done: !0 } : {
							done: !1,
							value: e[h++]
						};
					},
					e: function(e) {
						throw e;
					},
					f: g
				};
			}
			throw TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
		}
		var v = !0, y = !1, b;
		return {
			s: function() {
				m = m.call(e);
			},
			n: function() {
				var e = m.next();
				return v = e.done, e;
			},
			e: function(e) {
				y = !0, b = e;
			},
			f: function() {
				try {
					!v && m.return != null && m.return();
				} finally {
					if (y) throw b;
				}
			}
		};
	}
	function _(e, p) {
		if (e) {
			if (typeof e == "string") return v(e, p);
			var m = Object.prototype.toString.call(e).slice(8, -1);
			if (m === "Object" && e.constructor && (m = e.constructor.name), m === "Map" || m === "Set") return Array.from(e);
			if (m === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(m)) return v(e, p);
		}
	}
	function v(e, p) {
		(p == null || p > e.length) && (p = e.length);
		for (var m = 0, h = Array(p); m < p; m++) h[m] = e[m];
		return h;
	}
	function y(e, p) {
		if (!(e instanceof p)) throw TypeError("Cannot call a class as a function");
	}
	function b(e, p) {
		for (var m = 0; m < p.length; m++) {
			var h = p[m];
			h.enumerable = h.enumerable || !1, h.configurable = !0, "value" in h && (h.writable = !0), Object.defineProperty(e, S(h.key), h);
		}
	}
	function x(e, p, m) {
		return p && b(e.prototype, p), m && b(e, m), Object.defineProperty(e, "prototype", { writable: !1 }), e;
	}
	function S(e) {
		var p = C(e, "string");
		return h(p) === "symbol" ? p : String(p);
	}
	function C(e, p) {
		if (h(e) !== "object" || e === null) return e;
		var m = e[Symbol.toPrimitive];
		if (m !== void 0) {
			var g = m.call(e, p || "default");
			if (h(g) !== "object") return g;
			throw TypeError("@@toPrimitive must return a primitive value.");
		}
		return (p === "string" ? String : Number)(e);
	}
	e.WidgetParser = /* @__PURE__ */ function() {
		function e() {
			y(this, e);
		}
		return x(e, null, [
			{
				key: "parseAccountData",
				value: function(p) {
					if (!p) return [];
					for (var m = [], h = 0, g = Object.keys(p); h < g.length; h++) {
						var _ = g[h], v = p[_];
						if (v && !(v.type !== "m.widget" && v.type !== "im.vector.modular.widgets") && v.sender && (v.state_key || v.id) === _) {
							var y = {
								content: v.content,
								sender: v.sender,
								type: "m.widget",
								state_key: _,
								event_id: "$example",
								room_id: "!example",
								origin_server_ts: 1
							}, b = e.parseRoomWidget(y);
							b && m.push(b);
						}
					}
					return m;
				}
			},
			{
				key: "parseWidgetsFromRoomState",
				value: function(p) {
					if (!p) return [];
					var m = [], h = g(p), _;
					try {
						for (h.s(); !(_ = h.n()).done;) {
							var v = _.value, y = e.parseRoomWidget(v);
							y && m.push(y);
						}
					} catch (e) {
						h.e(e);
					} finally {
						h.f();
					}
					return m;
				}
			},
			{
				key: "parseRoomWidget",
				value: function(p) {
					if (!p || p.type !== "m.widget" && p.type !== "im.vector.modular.widgets") return null;
					var m = p.content || {}, h = {
						id: p.state_key,
						creatorUserId: m.creatorUserId || p.sender,
						name: m.name,
						type: m.type,
						url: m.url,
						waitForIframeLoad: m.waitForIframeLoad,
						data: m.data
					};
					return e.processEstimatedWidget(h);
				}
			},
			{
				key: "processEstimatedWidget",
				value: function(e) {
					return !e.id || !e.creatorUserId || !e.type || !(0, m.isValidUrl)(e.url) ? null : new p.Widget(e);
				}
			}
		]), e;
	}();
})), require_url_template = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.runTemplate = p, e.toString = m;
	function p(e, p, h) {
		for (var g = Object.assign({}, p.data, {
			matrix_room_id: h.widgetRoomId || "",
			matrix_user_id: h.currentUserId,
			matrix_display_name: h.userDisplayName || h.currentUserId,
			matrix_avatar_url: h.userHttpAvatarUrl || "",
			matrix_widget_id: p.id,
			"org.matrix.msc2873.client_id": h.clientId || "",
			"org.matrix.msc2873.client_theme": h.clientTheme || "",
			"org.matrix.msc2873.client_language": h.clientLanguage || "",
			"org.matrix.msc3819.matrix_device_id": h.deviceId || "",
			"org.matrix.msc4039.matrix_base_url": h.baseUrl || ""
		}), _ = e, v = 0, y = Object.keys(g); v < y.length; v++) {
			var b = y[v], x = `\$${b}`.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), S = new RegExp(x, "g");
			_ = _.replace(S, encodeURIComponent(m(g[b])));
		}
		return _;
	}
	function m(e) {
		return e == null ? `${e}` : String(e);
	}
})), require_WidgetDriver = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var p = require_lib();
	function m(e) {
		"@babel/helpers - typeof";
		return m = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
			return typeof e;
		} : function(e) {
			return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
		}, m(e);
	}
	function h(e, p) {
		if (!(e instanceof p)) throw TypeError("Cannot call a class as a function");
	}
	function g(e, p) {
		for (var m = 0; m < p.length; m++) {
			var h = p[m];
			h.enumerable = h.enumerable || !1, h.configurable = !0, "value" in h && (h.writable = !0), Object.defineProperty(e, v(h.key), h);
		}
	}
	function _(e, p, m) {
		return p && g(e.prototype, p), m && g(e, m), Object.defineProperty(e, "prototype", { writable: !1 }), e;
	}
	function v(e) {
		var p = y(e, "string");
		return m(p) === "symbol" ? p : String(p);
	}
	function y(e, p) {
		if (m(e) !== "object" || e === null) return e;
		var h = e[Symbol.toPrimitive];
		if (h !== void 0) {
			var g = h.call(e, p || "default");
			if (m(g) !== "object") return g;
			throw TypeError("@@toPrimitive must return a primitive value.");
		}
		return (p === "string" ? String : Number)(e);
	}
	e.WidgetDriver = /* @__PURE__ */ function() {
		function e() {
			h(this, e);
		}
		return _(e, [
			{
				key: "validateCapabilities",
				value: function(e) {
					return Promise.resolve(/* @__PURE__ */ new Set());
				}
			},
			{
				key: "sendEvent",
				value: function(e, p) {
					return arguments.length > 2 && arguments[2] !== void 0 && arguments[2], arguments.length > 3 && arguments[3] !== void 0 && arguments[3], Promise.reject(/* @__PURE__ */ Error("Failed to override function"));
				}
			},
			{
				key: "sendStickyEvent",
				value: function(e, p, m) {
					throw arguments.length > 3 && arguments[3] !== void 0 && arguments[3], Error("Method not implemented.");
				}
			},
			{
				key: "sendDelayedEvent",
				value: function(e, p, m, h) {
					return arguments.length > 4 && arguments[4] !== void 0 && arguments[4], arguments.length > 5 && arguments[5] !== void 0 && arguments[5], Promise.reject(/* @__PURE__ */ Error("Failed to override function"));
				}
			},
			{
				key: "sendDelayedStickyEvent",
				value: function(e, p, m, h, g) {
					throw arguments.length > 5 && arguments[5] !== void 0 && arguments[5], Error("Method not implemented.");
				}
			},
			{
				key: "cancelScheduledDelayedEvent",
				value: function(e) {
					return Promise.reject(/* @__PURE__ */ Error("Failed to override function"));
				}
			},
			{
				key: "restartScheduledDelayedEvent",
				value: function(e) {
					return Promise.reject(/* @__PURE__ */ Error("Failed to override function"));
				}
			},
			{
				key: "sendScheduledDelayedEvent",
				value: function(e) {
					return Promise.reject(/* @__PURE__ */ Error("Failed to override function"));
				}
			},
			{
				key: "sendToDevice",
				value: function(e, p, m) {
					return Promise.reject(/* @__PURE__ */ Error("Failed to override function"));
				}
			},
			{
				key: "readRoomAccountData",
				value: function(e) {
					return arguments.length > 1 && arguments[1] !== void 0 && arguments[1], Promise.resolve([]);
				}
			},
			{
				key: "readRoomEvents",
				value: function(e, p, m) {
					return arguments.length > 3 && arguments[3] !== void 0 && arguments[3], arguments.length > 4 && arguments[4], Promise.resolve([]);
				}
			},
			{
				key: "readStateEvents",
				value: function(e, p, m) {
					return arguments.length > 3 && arguments[3] !== void 0 && arguments[3], Promise.resolve([]);
				}
			},
			{
				key: "readStickyEvents",
				value: function(e) {
					throw Error("readStickyEvents is not implemented");
				}
			},
			{
				key: "readRoomTimeline",
				value: function(e, p, m, h, g, _) {
					return h === void 0 ? this.readRoomEvents(p, m, g, [e], _) : this.readStateEvents(p, h, g, [e]);
				}
			},
			{
				key: "readRoomState",
				value: function(e, p, m) {
					return this.readStateEvents(p, m, 2 ** 53 - 1, [e]);
				}
			},
			{
				key: "readEventRelations",
				value: function(e, p, m, h, g, _, v, y) {
					return Promise.resolve({ chunk: [] });
				}
			},
			{
				key: "askOpenID",
				value: function(e) {
					e.update({ state: p.OpenIDRequestState.Blocked });
				}
			},
			{
				key: "navigate",
				value: function(e) {
					throw Error("Navigation is not implemented");
				}
			},
			{
				key: "getTurnServers",
				value: function() {
					throw Error("TURN server support is not implemented");
				}
			},
			{
				key: "searchUserDirectory",
				value: function(e, p) {
					return Promise.resolve({
						limited: !1,
						results: []
					});
				}
			},
			{
				key: "getMediaConfig",
				value: function() {
					throw Error("Get media config is not implemented");
				}
			},
			{
				key: "uploadFile",
				value: function(e) {
					throw Error("Upload file is not implemented");
				}
			},
			{
				key: "downloadFile",
				value: function(e) {
					throw Error("Download file is not implemented");
				}
			},
			{
				key: "getKnownRooms",
				value: function() {
					throw Error("Querying known rooms is not implemented");
				}
			},
			{
				key: "processError",
				value: function(e) {}
			}
		]), e;
	}();
})), require_lib = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var p = require_WidgetApi();
	Object.keys(p).forEach(function(m) {
		m === "default" || m === "__esModule" || m in e && e[m] === p[m] || Object.defineProperty(e, m, {
			enumerable: !0,
			get: function() {
				return p[m];
			}
		});
	});
	var m = require_ClientWidgetApi();
	Object.keys(m).forEach(function(p) {
		p === "default" || p === "__esModule" || p in e && e[p] === m[p] || Object.defineProperty(e, p, {
			enumerable: !0,
			get: function() {
				return m[p];
			}
		});
	});
	var h = require_Symbols();
	Object.keys(h).forEach(function(p) {
		p === "default" || p === "__esModule" || p in e && e[p] === h[p] || Object.defineProperty(e, p, {
			enumerable: !0,
			get: function() {
				return h[p];
			}
		});
	});
	var g = require_PostmessageTransport();
	Object.keys(g).forEach(function(p) {
		p === "default" || p === "__esModule" || p in e && e[p] === g[p] || Object.defineProperty(e, p, {
			enumerable: !0,
			get: function() {
				return g[p];
			}
		});
	});
	var _ = require_WidgetType();
	Object.keys(_).forEach(function(p) {
		p === "default" || p === "__esModule" || p in e && e[p] === _[p] || Object.defineProperty(e, p, {
			enumerable: !0,
			get: function() {
				return _[p];
			}
		});
	});
	var v = require_IWidgetApiErrorResponse();
	Object.keys(v).forEach(function(p) {
		p === "default" || p === "__esModule" || p in e && e[p] === v[p] || Object.defineProperty(e, p, {
			enumerable: !0,
			get: function() {
				return v[p];
			}
		});
	});
	var y = require_WidgetApiAction();
	Object.keys(y).forEach(function(p) {
		p === "default" || p === "__esModule" || p in e && e[p] === y[p] || Object.defineProperty(e, p, {
			enumerable: !0,
			get: function() {
				return y[p];
			}
		});
	});
	var b = require_WidgetApiDirection();
	Object.keys(b).forEach(function(p) {
		p === "default" || p === "__esModule" || p in e && e[p] === b[p] || Object.defineProperty(e, p, {
			enumerable: !0,
			get: function() {
				return b[p];
			}
		});
	});
	var x = require_ApiVersion();
	Object.keys(x).forEach(function(p) {
		p === "default" || p === "__esModule" || p in e && e[p] === x[p] || Object.defineProperty(e, p, {
			enumerable: !0,
			get: function() {
				return x[p];
			}
		});
	});
	var S = require_Capabilities();
	Object.keys(S).forEach(function(p) {
		p === "default" || p === "__esModule" || p in e && e[p] === S[p] || Object.defineProperty(e, p, {
			enumerable: !0,
			get: function() {
				return S[p];
			}
		});
	});
	var C = require_GetOpenIDAction();
	Object.keys(C).forEach(function(p) {
		p === "default" || p === "__esModule" || p in e && e[p] === C[p] || Object.defineProperty(e, p, {
			enumerable: !0,
			get: function() {
				return C[p];
			}
		});
	});
	var w = require_WidgetKind();
	Object.keys(w).forEach(function(p) {
		p === "default" || p === "__esModule" || p in e && e[p] === w[p] || Object.defineProperty(e, p, {
			enumerable: !0,
			get: function() {
				return w[p];
			}
		});
	});
	var T = require_ModalButtonKind();
	Object.keys(T).forEach(function(p) {
		p === "default" || p === "__esModule" || p in e && e[p] === T[p] || Object.defineProperty(e, p, {
			enumerable: !0,
			get: function() {
				return T[p];
			}
		});
	});
	var E = require_ModalWidgetActions();
	Object.keys(E).forEach(function(p) {
		p === "default" || p === "__esModule" || p in e && e[p] === E[p] || Object.defineProperty(e, p, {
			enumerable: !0,
			get: function() {
				return E[p];
			}
		});
	});
	var D = require_UpdateDelayedEventAction();
	Object.keys(D).forEach(function(p) {
		p === "default" || p === "__esModule" || p in e && e[p] === D[p] || Object.defineProperty(e, p, {
			enumerable: !0,
			get: function() {
				return D[p];
			}
		});
	});
	var O = require_WidgetEventCapability();
	Object.keys(O).forEach(function(p) {
		p === "default" || p === "__esModule" || p in e && e[p] === O[p] || Object.defineProperty(e, p, {
			enumerable: !0,
			get: function() {
				return O[p];
			}
		});
	});
	var k = require_url();
	Object.keys(k).forEach(function(p) {
		p === "default" || p === "__esModule" || p in e && e[p] === k[p] || Object.defineProperty(e, p, {
			enumerable: !0,
			get: function() {
				return k[p];
			}
		});
	});
	var A = require_utils();
	Object.keys(A).forEach(function(p) {
		p === "default" || p === "__esModule" || p in e && e[p] === A[p] || Object.defineProperty(e, p, {
			enumerable: !0,
			get: function() {
				return A[p];
			}
		});
	});
	var j = require_Widget();
	Object.keys(j).forEach(function(p) {
		p === "default" || p === "__esModule" || p in e && e[p] === j[p] || Object.defineProperty(e, p, {
			enumerable: !0,
			get: function() {
				return j[p];
			}
		});
	});
	var M = require_WidgetParser();
	Object.keys(M).forEach(function(p) {
		p === "default" || p === "__esModule" || p in e && e[p] === M[p] || Object.defineProperty(e, p, {
			enumerable: !0,
			get: function() {
				return M[p];
			}
		});
	});
	var N = require_url_template();
	Object.keys(N).forEach(function(p) {
		p === "default" || p === "__esModule" || p in e && e[p] === N[p] || Object.defineProperty(e, p, {
			enumerable: !0,
			get: function() {
				return N[p];
			}
		});
	});
	var P = require_SimpleObservable();
	Object.keys(P).forEach(function(p) {
		p === "default" || p === "__esModule" || p in e && e[p] === P[p] || Object.defineProperty(e, p, {
			enumerable: !0,
			get: function() {
				return P[p];
			}
		});
	});
	var F = require_WidgetDriver();
	Object.keys(F).forEach(function(p) {
		p === "default" || p === "__esModule" || p in e && e[p] === F[p] || Object.defineProperty(e, p, {
			enumerable: !0,
			get: function() {
				return F[p];
			}
		});
	});
})), import_lib = /* @__PURE__ */ __toESM(require_lib());
function ownKeys(e, p) {
	var m = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var h = Object.getOwnPropertySymbols(e);
		p && (h = h.filter(function(p) {
			return Object.getOwnPropertyDescriptor(e, p).enumerable;
		})), m.push.apply(m, h);
	}
	return m;
}
function _objectSpread(e) {
	for (var p = 1; p < arguments.length; p++) {
		var m = arguments[p] == null ? {} : arguments[p];
		p % 2 ? ownKeys(Object(m), !0).forEach(function(p) {
			_defineProperty(e, p, m[p]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(m)) : ownKeys(Object(m)).forEach(function(p) {
			Object.defineProperty(e, p, Object.getOwnPropertyDescriptor(m, p));
		});
	}
	return e;
}
function _asyncIterator(e) {
	var p, m, h, g = 2;
	for (typeof Symbol < "u" && (m = Symbol.asyncIterator, h = Symbol.iterator); g--;) {
		if (m && (p = e[m]) != null) return p.call(e);
		if (h && (p = e[h]) != null) return new AsyncFromSyncIterator(p.call(e));
		m = "@@asyncIterator", h = "@@iterator";
	}
	throw TypeError("Object is not async iterable");
}
function AsyncFromSyncIterator(e) {
	function p(e) {
		if (Object(e) !== e) return Promise.reject(/* @__PURE__ */ TypeError(e + " is not an object."));
		var p = e.done;
		return Promise.resolve(e.value).then(function(e) {
			return {
				value: e,
				done: p
			};
		});
	}
	return AsyncFromSyncIterator = function(e) {
		this.s = e, this.n = e.next;
	}, AsyncFromSyncIterator.prototype = {
		s: null,
		n: null,
		next: function() {
			return p(this.n.apply(this.s, arguments));
		},
		return: function(e) {
			var m = this.s.return;
			return m === void 0 ? Promise.resolve({
				value: e,
				done: !0
			}) : p(m.apply(this.s, arguments));
		},
		throw: function(e) {
			var m = this.s.return;
			return m === void 0 ? Promise.reject(e) : p(m.apply(this.s, arguments));
		}
	}, new AsyncFromSyncIterator(e);
}
var RoomWidgetClientEvent = /* @__PURE__ */ function(e) {
	return e.PendingEventsChanged = "PendingEvent.pendingEventsChanged", e;
}({}), RoomWidgetClient = class extends MatrixClient {
	constructor(e, p, m, h, g) {
		var _, v, y, b, x, S, C, w, T, E, D, O, k, A;
		super(h), _ = this, this.widgetApi = e, this.capabilities = p, this.roomId = m, _defineProperty(this, "room", void 0), _defineProperty(this, "widgetApiReady", void 0), _defineProperty(this, "roomStateSynced", void 0), _defineProperty(this, "lifecycle", void 0), _defineProperty(this, "syncState", null), _defineProperty(this, "pendingSendingEventsTxId", []), _defineProperty(this, "eventEmitter", new TypedEventEmitter()), _defineProperty(this, "updateTxId", /* @__PURE__ */ function() {
			var e = _asyncToGenerator(function* (e) {
				if (e.getSender() === _.getUserId() && _.pendingSendingEventsTxId.some((p) => e.getType() === p.type)) {
					for (var p = _.pendingSendingEventsTxId.find((p) => p.id === e.getId())?.txId; !p && _.pendingSendingEventsTxId.length > 0;) yield new Promise((e) => _.eventEmitter.once(RoomWidgetClientEvent.PendingEventsChanged, () => e())), p = _.pendingSendingEventsTxId.find((p) => p.id === e.getId())?.txId;
					p && (e.setTxnId(p), e.setUnsigned(_objectSpread(_objectSpread({}, e.getUnsigned()), {}, { transaction_id: p }))), _.pendingSendingEventsTxId = _.pendingSendingEventsTxId.filter((p) => p.id !== e.getId()), _.pendingSendingEventsTxId.length === 0 && _.eventEmitter.emit(RoomWidgetClientEvent.PendingEventsChanged);
				}
			});
			return function(p) {
				return e.apply(this, arguments);
			};
		}()), _defineProperty(this, "onEvent", /* @__PURE__ */ function() {
			var e = _asyncToGenerator(function* (e) {
				if (e.preventDefault(), e.detail.data.room_id === _.roomId) {
					var p = new MatrixEvent(e.detail.data);
					yield _.updateTxId(p), _.syncApi instanceof SyncApi ? (yield _.supportUpdateState()) ? yield _.syncApi.injectRoomEvents(_.room, void 0, [], [p]) : yield _.syncApi.injectRoomEvents(_.room, [], void 0, [p]) : (yield _.supportUpdateState()) ? yield _.syncApi.injectRoomEvents(_.room, [], [p]) : logger.error("slididng sync cannot be used in widget mode if the client widget driver does not support the version: 'org.matrix.msc2762_update_state'"), _.emit(ClientEvent.Event, p), _.setSyncState(SyncState.Syncing), logger.info(`Received event ${p.getId()} ${p.getType()}`);
				} else {
					var { event_id: m, room_id: h } = e.detail.data;
					logger.info(`Received event ${m} for a different room ${h}; discarding`);
				}
				yield _.ack(e);
			});
			return function(p) {
				return e.apply(this, arguments);
			};
		}()), _defineProperty(this, "onToDevice", /* @__PURE__ */ function() {
			var e = _asyncToGenerator(function* (e) {
				e.preventDefault();
				var p = new MatrixEvent({
					type: e.detail.data.type,
					sender: e.detail.data.sender,
					content: e.detail.data.content
				});
				e.detail.data.encrypted && p.makeEncrypted(EventType.RoomMessageEncrypted, {}, "", ""), _.emit(ClientEvent.ToDeviceEvent, p), _.setSyncState(SyncState.Syncing), yield _.ack(e);
			});
			return function(p) {
				return e.apply(this, arguments);
			};
		}()), _defineProperty(this, "onStateUpdate", /* @__PURE__ */ function() {
			var e = _asyncToGenerator(function* (e) {
				e.preventDefault(), (yield _.supportUpdateState()) || logger.warn("received update_state widget action but the widget driver did not claim to support 'org.matrix.msc2762_update_state'");
				for (var p of e.detail.data.state) if (p.room_id === _.roomId) {
					var m = new MatrixEvent(p);
					_.syncApi instanceof SyncApi ? yield _.syncApi.injectRoomEvents(_.room, void 0, [m]) : yield _.syncApi.injectRoomEvents(_.room, [m]), logger.info(`Updated state entry ${m.getType()} ${m.getStateKey()} to ${m.getId()}`);
				} else {
					var { event_id: h, room_id: g } = e.detail.data;
					logger.info(`Received state entry ${h} for a different room ${g}; discarding`);
				}
				yield _.ack(e);
			});
			return function(p) {
				return e.apply(this, arguments);
			};
		}());
		var j = this.widgetApi.transport.send.bind(this.widgetApi.transport);
		this.widgetApi.transport.send = /* @__PURE__ */ function() {
			var e = _asyncToGenerator(function* (e, p) {
				try {
					return yield j(e, p);
				} catch (e) {
					processAndThrow(e);
				}
			});
			return function(p, m) {
				return e.apply(this, arguments);
			};
		}();
		var M = this.widgetApi.transport.sendComplete.bind(this.widgetApi.transport);
		this.widgetApi.transport.sendComplete = /* @__PURE__ */ function() {
			var e = _asyncToGenerator(function* (e, p) {
				try {
					return yield M(e, p);
				} catch (e) {
					processAndThrow(e);
				}
			});
			return function(p, m) {
				return e.apply(this, arguments);
			};
		}(), this.widgetApiReady = new Promise((e) => this.widgetApi.once("ready", e)), this.roomStateSynced = (v = p.receiveState) != null && v.length ? new Promise((e) => this.widgetApi.once(`action:${import_lib.WidgetApiToWidgetAction.UpdateState}`, e)) : Promise.resolve(), ((y = p.sendEvent) != null && y.length || (b = p.receiveEvent) != null && b.length || p.sendMessage === !0 || Array.isArray(p.sendMessage) && p.sendMessage.length || p.receiveMessage === !0 || Array.isArray(p.receiveMessage) && p.receiveMessage.length || (x = p.sendState) != null && x.length || (S = p.receiveState) != null && S.length) && e.requestCapabilityForRoomTimeline(m), (C = p.sendEvent) == null || C.forEach((p) => e.requestCapabilityToSendEvent(p)), (w = p.receiveEvent) == null || w.forEach((p) => e.requestCapabilityToReceiveEvent(p)), p.sendMessage === !0 ? e.requestCapabilityToSendMessage() : Array.isArray(p.sendMessage) && p.sendMessage.forEach((p) => e.requestCapabilityToSendMessage(p)), p.receiveMessage === !0 ? e.requestCapabilityToReceiveMessage() : Array.isArray(p.receiveMessage) && p.receiveMessage.forEach((p) => e.requestCapabilityToReceiveMessage(p)), (T = p.sendState) == null || T.forEach((p) => {
			var { eventType: m, stateKey: h } = p;
			return e.requestCapabilityToSendState(m, h);
		}), (E = p.receiveState) == null || E.forEach((p) => {
			var { eventType: m, stateKey: h } = p;
			return e.requestCapabilityToReceiveState(m, h);
		}), (D = p.sendToDevice) == null || D.forEach((p) => e.requestCapabilityToSendToDevice(p)), (O = p.receiveToDevice) == null || O.forEach((p) => e.requestCapabilityToReceiveToDevice(p)), p.sendDelayedEvents && ((k = p.sendEvent) != null && k.length || p.sendMessage === !0 || Array.isArray(p.sendMessage) && p.sendMessage.length || (A = p.sendState) != null && A.length) && e.requestCapability(import_lib.MatrixCapabilities.MSC4157SendDelayedEvent), p.updateDelayedEvents && e.requestCapability(import_lib.MatrixCapabilities.MSC4157UpdateDelayedEvent), p.turnServers && e.requestCapability(import_lib.MatrixCapabilities.MSC3846TurnServers), e.on(`action:${import_lib.WidgetApiToWidgetAction.SendEvent}`, this.onEvent), e.on(`action:${import_lib.WidgetApiToWidgetAction.SendToDevice}`, this.onToDevice), e.on(`action:${import_lib.WidgetApiToWidgetAction.UpdateState}`, this.onStateUpdate), e.start(), g && e.sendContentLoaded();
	}
	supportUpdateState() {
		var e = this;
		return _asyncToGenerator(function* () {
			return (yield e.widgetApi.getClientVersions()).includes(import_lib.UnstableApiVersion.MSC2762_UPDATE_STATE);
		})();
	}
	startClient() {
		var e = arguments, p = this;
		return _asyncToGenerator(function* () {
			var m = e.length > 0 && e[0] !== void 0 ? e[0] : {};
			p.lifecycle = new AbortController();
			var h = p.getUserId();
			h && p.store.storeUser(new User(h)), m.slidingSync ? p.syncApi = new SlidingSyncSdk(m.slidingSync, p, m, p.buildSyncApiOptions()) : p.syncApi = new SyncApi(p, m, p.buildSyncApiOptions()), p.room = p.syncApi.createRoom(p.roomId), p.store.storeRoom(p.room), yield p.widgetApiReady, (yield p.supportUpdateState()) ? yield p.roomStateSynced : yield Promise.all(p.capabilities.receiveState?.map(/* @__PURE__ */ function() {
				var e = _asyncToGenerator(function* (e) {
					var { eventType: m, stateKey: h } = e, g = (yield p.widgetApi.readStateEvents(m, void 0, h, [p.roomId])).map((e) => new MatrixEvent(e));
					p.syncApi instanceof SyncApi ? yield p.syncApi.injectRoomEvents(p.room, void 0, g) : yield p.syncApi.injectRoomEvents(p.room, g), g.forEach((e) => {
						p.emit(ClientEvent.Event, e), logger.info(`Backfilled event ${e.getId()} ${e.getType()} ${e.getStateKey()}`);
					});
				});
				return function(p) {
					return e.apply(this, arguments);
				};
			}()) ?? []), m.clientWellKnownPollPeriod !== void 0 && (p.clientWellKnownIntervalID = setInterval(() => {
				p.fetchClientWellKnown();
			}, 1e3 * m.clientWellKnownPollPeriod), p.fetchClientWellKnown()), p.setSyncState(SyncState.Syncing), logger.info("Finished initial sync"), p.matrixRTC.start(), p.capabilities.turnServers && p.watchTurnServers();
		})();
	}
	stopClient() {
		this.widgetApi.off(`action:${import_lib.WidgetApiToWidgetAction.SendEvent}`, this.onEvent), this.widgetApi.off(`action:${import_lib.WidgetApiToWidgetAction.SendToDevice}`, this.onToDevice), this.widgetApi.off(`action:${import_lib.WidgetApiToWidgetAction.UpdateState}`, this.onStateUpdate), super.stopClient(), this.lifecycle.abort();
	}
	joinRoom(e) {
		var p = this;
		return _asyncToGenerator(function* () {
			if (e === p.roomId) return p.room;
			throw Error(`Unknown room: ${e}`);
		})();
	}
	encryptAndSendEvent(e, p, m) {
		var h = this;
		return _asyncToGenerator(function* () {
			var g = p.event.redacts ? _objectSpread(_objectSpread({}, p.getContent()), {}, { redacts: p.event.redacts }) : p.getContent();
			if (m) {
				var _ = yield h.widgetApi.sendRoomEvent(p.getType(), g, e.roomId, "delay" in m ? m.delay : void 0, "parent_delay_id" in m ? m.parent_delay_id : void 0).catch(timeoutToConnectionError);
				return h.validateSendDelayedEventResponse(_);
			}
			var v = p.getTxnId();
			v && h.pendingSendingEventsTxId.push({
				type: p.getType(),
				id: void 0,
				txId: v
			});
			var y;
			try {
				y = yield h.widgetApi.sendRoomEvent(p.getType(), g, e.roomId).catch(timeoutToConnectionError);
			} catch (m) {
				throw h.updatePendingEventStatus(e, p, EventStatus.NOT_SENT), m;
			}
			return e.updatePendingEvent(p, EventStatus.SENT, y.event_id), h.pendingSendingEventsTxId.forEach((e) => {
				e.txId === v && (e.id = y.event_id);
			}), h.eventEmitter.emit(RoomWidgetClientEvent.PendingEventsChanged), { event_id: y.event_id };
		})();
	}
	sendStateEvent(e, p, m) {
		var h = arguments, g = this;
		return _asyncToGenerator(function* () {
			var _ = h.length > 3 && h[3] !== void 0 ? h[3] : "", v = yield g.widgetApi.sendStateEvent(p, _, m, e).catch(timeoutToConnectionError);
			if (v.event_id === void 0) throw Error("'event_id' absent from response to an event request");
			return { event_id: v.event_id };
		})();
	}
	_unstable_sendDelayedStateEvent(e, p, m, h) {
		var g = arguments, _ = this;
		return _asyncToGenerator(function* () {
			var v = g.length > 4 && g[4] !== void 0 ? g[4] : "";
			if (!(yield _.doesServerSupportUnstableFeature("org.matrix.msc4140"))) throw new UnsupportedDelayedEventsEndpointError("Server does not support the delayed events API", "sendDelayedStateEvent");
			var y = yield _.widgetApi.sendStateEvent(m, v, h, e, "delay" in p ? p.delay : void 0, "parent_delay_id" in p ? p.parent_delay_id : void 0).catch(timeoutToConnectionError);
			return _.validateSendDelayedEventResponse(y);
		})();
	}
	validateSendDelayedEventResponse(e) {
		if (e.delay_id === void 0) throw Error("'delay_id' absent from response to a delayed event request");
		return { delay_id: e.delay_id };
	}
	_unstable_updateDelayedEvent(e, p) {
		var m = this;
		return _asyncToGenerator(function* () {
			if (!(yield m.doesServerSupportUnstableFeature("org.matrix.msc4140"))) throw new UnsupportedDelayedEventsEndpointError("Server does not support the delayed events API", "updateDelayedEvent");
			var h;
			switch (p) {
				case UpdateDelayedEventAction.Cancel:
					h = m.widgetApi.cancelScheduledDelayedEvent;
					break;
				case UpdateDelayedEventAction.Restart:
					h = m.widgetApi.cancelScheduledDelayedEvent;
					break;
				case UpdateDelayedEventAction.Send:
					h = m.widgetApi.sendScheduledDelayedEvent;
					break;
			}
			return yield h.call(m.widgetApi, e).catch(timeoutToConnectionError), {};
		})();
	}
	_unstable_cancelScheduledDelayedEvent(e) {
		var p = this;
		return _asyncToGenerator(function* () {
			if (!(yield p.doesServerSupportUnstableFeature("org.matrix.msc4140"))) throw new UnsupportedDelayedEventsEndpointError("Server does not support the delayed events API", "cancelScheduledDelayedEvent");
			return yield p.widgetApi.cancelScheduledDelayedEvent(e).catch(timeoutToConnectionError), {};
		})();
	}
	_unstable_restartScheduledDelayedEvent(e) {
		var p = this;
		return _asyncToGenerator(function* () {
			if (!(yield p.doesServerSupportUnstableFeature("org.matrix.msc4140"))) throw new UnsupportedDelayedEventsEndpointError("Server does not support the delayed events API", "restartScheduledDelayedEvent");
			return yield p.widgetApi.restartScheduledDelayedEvent(e).catch(timeoutToConnectionError), {};
		})();
	}
	_unstable_sendScheduledDelayedEvent(e) {
		var p = this;
		return _asyncToGenerator(function* () {
			if (!(yield p.doesServerSupportUnstableFeature("org.matrix.msc4140"))) throw new UnsupportedDelayedEventsEndpointError("Server does not support the delayed events API", "sendScheduledDelayedEvent");
			return yield p.widgetApi.sendScheduledDelayedEvent(e).catch(timeoutToConnectionError), {};
		})();
	}
	encryptAndSendToDevice(e, p, m) {
		var h = this;
		return _asyncToGenerator(function* () {
			var g = new MapWithDefault(() => /* @__PURE__ */ new Map());
			for (var { userId: _, deviceId: v } of p) g.getOrCreate(_).set(v, m);
			yield h.widgetApi.sendToDevice(e, !0, recursiveMapToObject(g)).catch(timeoutToConnectionError);
		})();
	}
	sendToDevice(e, p) {
		var m = this;
		return _asyncToGenerator(function* () {
			return yield m.widgetApi.sendToDevice(e, !1, recursiveMapToObject(p)).catch(timeoutToConnectionError), {};
		})();
	}
	getOpenIdToken() {
		var e = this;
		return _asyncToGenerator(function* () {
			var p = yield e.widgetApi.requestOpenIDConnectToken().catch(timeoutToConnectionError);
			return {
				access_token: p.access_token,
				expires_in: p.expires_in,
				matrix_server_name: p.matrix_server_name,
				token_type: p.token_type
			};
		})();
	}
	queueToDevice(e) {
		var p = this;
		return _asyncToGenerator(function* () {
			var { eventType: m, batch: h } = e, g = new MapWithDefault(() => /* @__PURE__ */ new Map());
			for (var { userId: _, deviceId: v, payload: y } of h) g.getOrCreate(_).set(v, y);
			yield p.widgetApi.sendToDevice(m, !1, recursiveMapToObject(g)).catch(timeoutToConnectionError);
		})();
	}
	sendToDeviceViaWidgetApi(e, p, m) {
		var h = this;
		return _asyncToGenerator(function* () {
			yield h.widgetApi.sendToDevice(e, p, recursiveMapToObject(m)).catch(timeoutToConnectionError);
		})();
	}
	checkTurnServers() {
		var e = this;
		return _asyncToGenerator(function* () {
			return e.turnServers.length > 0;
		})();
	}
	getSyncState() {
		return this.syncState;
	}
	setSyncState(e) {
		var p = this.syncState;
		this.syncState = e, this.emit(ClientEvent.Sync, e, p);
	}
	ack(e) {
		var p = this;
		return _asyncToGenerator(function* () {
			yield p.widgetApi.transport.reply(e.detail, {});
		})();
	}
	watchTurnServers() {
		var e = this;
		return _asyncToGenerator(function* () {
			var p = e.widgetApi.getTurnServers(), m = () => {
				p.return(void 0);
			};
			e.lifecycle.signal.addEventListener("abort", m);
			try {
				var h = !1, g = !1, _;
				try {
					for (var v = _asyncIterator(p), y; h = !(y = yield v.next()).done; h = !1) {
						var b = y.value;
						e.turnServers = [{
							urls: b.uris,
							username: b.username,
							credential: b.password
						}], e.emit(ClientEvent.TurnServers, e.turnServers), logger.log(`Received TURN server: ${b.uris}`);
					}
				} catch (e) {
					g = !0, _ = e;
				} finally {
					try {
						h && v.return != null && (yield v.return());
					} finally {
						if (g) throw _;
					}
				}
			} catch (e) {
				logger.warn("Error watching TURN servers", e);
			} finally {
				e.lifecycle.signal.removeEventListener("abort", m);
			}
		})();
	}
};
function processAndThrow(e) {
	throw e instanceof import_lib.WidgetApiResponseError && e.data.matrix_api_error ? MatrixError.fromWidgetApiErrorData(e.data.matrix_api_error) : e;
}
function timeoutToConnectionError(e) {
	throw e instanceof Error && e.message === "Request timed out" ? new ConnectionError("widget api timeout") : e;
}
var ReceiptAccumulator = class {
	constructor() {
		_defineProperty(this, "unthreadedReadReceipts", /* @__PURE__ */ new Map()), _defineProperty(this, "threadedReadReceipts", new MapWithDefault(() => /* @__PURE__ */ new Map()));
	}
	setUnthreaded(e, p) {
		this.unthreadedReadReceipts.set(e, p);
	}
	setThreaded(e, p, m) {
		this.threadedReadReceipts.getOrCreate(e).set(p, m);
	}
	allUnthreaded() {
		return this.unthreadedReadReceipts.entries();
	}
	*allThreaded() {
		for (var e of this.threadedReadReceipts.values()) for (var p of e.entries()) yield p;
	}
	consumeEphemeralEvents(e) {
		e?.forEach((e) => {
			e.type !== EventType.Receipt || !e.content || Object.keys(e.content).forEach((p) => {
				Object.entries(e.content[p]).forEach((m) => {
					var [h, g] = m;
					if (isSupportedReceiptType(h)) for (var _ of Object.keys(g)) {
						var v = e.content[p][h][_], y = {
							data: e.content[p][h][_],
							type: h,
							eventId: p
						};
						v.thread_id ? this.setThreaded(v.thread_id, _, y) : this.setUnthreaded(_, y);
					}
				});
			});
		});
	}
	buildAccumulatedReceiptEvent(e) {
		var p = {
			type: EventType.Receipt,
			room_id: e,
			content: {}
		}, m = new MapWithDefault(() => new MapWithDefault(() => /* @__PURE__ */ new Map()));
		for (var [h, g] of this.allUnthreaded()) m.getOrCreate(g.eventId).getOrCreate(g.type).set(h, g.data);
		for (var [_, v] of this.allThreaded()) m.getOrCreate(v.eventId).getOrCreate(v.type).set(_, v.data);
		return p.content = recursiveMapToObject(m), m.size > 0 ? p : null;
	}
}, Category = /* @__PURE__ */ function(e) {
	return e.Invite = "invite", e.Leave = "leave", e.Join = "join", e.Knock = "knock", e;
}({});
function isTaggedEvent(e) {
	return "_localTs" in e && e._localTs !== void 0;
}
var SyncAccumulator = class {
	constructor() {
		this.opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _defineProperty(this, "accountData", {}), _defineProperty(this, "inviteRooms", {}), _defineProperty(this, "knockRooms", {}), _defineProperty(this, "joinRooms", {}), _defineProperty(this, "nextBatch", null), this.opts.maxTimelineEntries = this.opts.maxTimelineEntries || 50;
	}
	accumulate(e) {
		var p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
		this.accumulateRooms(e, p), this.accumulateAccountData(e), this.nextBatch = e.next_batch;
	}
	accumulateAccountData(e) {
		!e.account_data || !e.account_data.events || e.account_data.events.forEach((e) => {
			this.accountData[e.type] = e;
		});
	}
	accumulateRooms(e) {
		var p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
		e.rooms && (e.rooms.invite && Object.keys(e.rooms.invite).forEach((m) => {
			this.accumulateRoom(m, Category.Invite, e.rooms.invite[m], p);
		}), e.rooms.join && Object.keys(e.rooms.join).forEach((m) => {
			this.accumulateRoom(m, Category.Join, e.rooms.join[m], p);
		}), e.rooms.leave && Object.keys(e.rooms.leave).forEach((m) => {
			this.accumulateRoom(m, Category.Leave, e.rooms.leave[m], p);
		}), e.rooms.knock && Object.keys(e.rooms.knock).forEach((m) => {
			this.accumulateRoom(m, Category.Knock, e.rooms.knock[m], p);
		}));
	}
	accumulateRoom(e, p, m) {
		var h = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
		switch (p) {
			case Category.Invite:
				this.knockRooms[e] && delete this.knockRooms[e], this.accumulateInviteState(e, m);
				break;
			case Category.Knock:
				this.accumulateKnockState(e, m);
				break;
			case Category.Join:
				this.knockRooms[e] ? delete this.knockRooms[e] : this.inviteRooms[e] && delete this.inviteRooms[e], this.accumulateJoinState(e, m, h);
				break;
			case Category.Leave:
				this.knockRooms[e] ? delete this.knockRooms[e] : this.inviteRooms[e] ? delete this.inviteRooms[e] : delete this.joinRooms[e];
				break;
			default: logger.error("Unknown cateogory: ", p);
		}
	}
	accumulateInviteState(e, p) {
		if (!(!p.invite_state || !p.invite_state.events)) {
			if (!this.inviteRooms[e]) {
				this.inviteRooms[e] = { invite_state: p.invite_state };
				return;
			}
			var m = this.inviteRooms[e];
			p.invite_state.events.forEach((e) => {
				for (var p = !1, h = 0; h < m.invite_state.events.length; h++) {
					var g = m.invite_state.events[h];
					g.type === e.type && g.state_key == e.state_key && (m.invite_state.events[h] = e, p = !0);
				}
				p || m.invite_state.events.push(e);
			});
		}
	}
	accumulateKnockState(e, p) {
		if (!(!p.knock_state || !p.knock_state.events)) {
			if (!this.knockRooms[e]) {
				this.knockRooms[e] = { knock_state: p.knock_state };
				return;
			}
			var m = this.knockRooms[e];
			p.knock_state.events.forEach((e) => {
				for (var p = !1, h = 0; h < m.knock_state.events.length; h++) {
					var g = m.knock_state.events[h];
					g.type === e.type && g.state_key == e.state_key && (m.knock_state.events[h] = e, p = !0);
				}
				p || m.knock_state.events.push(e);
			});
		}
	}
	accumulateJoinState(e, p) {
		var m, h, g, _, v = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, y = Date.now();
		this.joinRooms[e] || (this.joinRooms[e] = {
			_currentState: Object.create(null),
			_timeline: [],
			_accountData: Object.create(null),
			_unreadNotifications: {},
			_unreadThreadNotifications: {},
			_summary: {},
			_receipts: new ReceiptAccumulator(),
			_stickyEvents: []
		});
		var b = this.joinRooms[e];
		if (p.account_data && p.account_data.events && p.account_data.events.forEach((e) => {
			b._accountData[e.type] = e;
		}), p.unread_notifications && (b._unreadNotifications = p.unread_notifications), b._unreadThreadNotifications = p[UNREAD_THREAD_NOTIFICATIONS.stable] ?? p[UNREAD_THREAD_NOTIFICATIONS.unstable] ?? void 0, p.summary) {
			var x = "m.heroes", S = "m.invited_member_count", C = "m.joined_member_count", w = b._summary, T = p.summary;
			w[x] = T[x] ?? w[x], w[C] = T[C] ?? w[C], w[S] = T[S] ?? w[S];
		}
		if (b._receipts.consumeEphemeralEvents(p.ephemeral?.events), p.timeline && p.timeline.limited && (b._timeline = []), (m = p.state) == null || (m = m.events) == null || m.forEach((e) => {
			setState(b._currentState, e);
		}), (h = p["org.matrix.msc4222.state_after"]) == null || (h = h.events) == null || h.forEach((e) => {
			setState(b._currentState, e);
		}), (g = p.timeline) == null || (g = g.events) == null || g.forEach((e, m) => {
			p["org.matrix.msc4222.state_after"] || setState(b._currentState, e);
			var h;
			if (v) h = e;
			else {
				h = Object.assign({}, e), h.unsigned !== void 0 && (h.unsigned = Object.assign({}, h.unsigned));
				var g = e.unsigned?.age;
				g !== void 0 && (h._localTs = Date.now() - g);
			}
			b._timeline.push({
				event: h,
				token: m === 0 ? p.timeline.prev_batch ?? null : null
			});
		}), b._stickyEvents = b._stickyEvents.filter((e) => {
			var { expiresTs: p } = e;
			return p > y;
		}), (_ = p.msc4354_sticky) != null && _.events && (b._stickyEvents = b._stickyEvents.concat(p.msc4354_sticky.events.map((e) => {
			var p = Math.min(e.msc4354_sticky.duration_ms, MAX_STICKY_DURATION_MS), m = Math.min(e.origin_server_ts, y);
			return {
				event: e,
				expiresTs: p + m
			};
		}))), b._timeline.length > this.opts.maxTimelineEntries) {
			for (var E = b._timeline.length - this.opts.maxTimelineEntries; E < b._timeline.length; E++) if (b._timeline[E].token) {
				b._timeline = b._timeline.slice(E, b._timeline.length);
				break;
			}
		}
	}
	getJSON() {
		var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, p = {
			join: {},
			invite: {},
			knock: {},
			leave: {}
		};
		Object.keys(this.inviteRooms).forEach((e) => {
			p.invite[e] = this.inviteRooms[e];
		}), Object.keys(this.knockRooms).forEach((e) => {
			p.knock[e] = this.knockRooms[e];
		}), Object.keys(this.joinRooms).forEach((h) => {
			var g, _ = this.joinRooms[h], v = {
				ephemeral: { events: [] },
				account_data: { events: [] },
				state: { events: [] },
				"org.matrix.msc4222.state_after": { events: [] },
				timeline: {
					events: [],
					prev_batch: null
				},
				unread_notifications: _._unreadNotifications,
				unread_thread_notifications: _._unreadThreadNotifications,
				summary: _._summary,
				msc4354_sticky: (g = _._stickyEvents) != null && g.length ? { events: _._stickyEvents.map((e) => e.event) } : void 0
			};
			Object.keys(_._accountData).forEach((e) => {
				v.account_data.events.push(_._accountData[e]);
			});
			var y = _._receipts.buildAccumulatedReceiptEvent(h);
			y && v.ephemeral.events.push(y), _._timeline.forEach((p) => {
				if (!v.timeline.prev_batch) {
					if (!p.token) return;
					v.timeline.prev_batch = p.token;
				}
				var m;
				!e && isTaggedEvent(p.event) ? (m = Object.assign({}, p.event), m.unsigned !== void 0 && (m.unsigned = Object.assign({}, m.unsigned)), delete m._localTs, m.unsigned = m.unsigned || {}, m.unsigned.age = Date.now() - p.event._localTs) : m = p.event, v.timeline.events.push(m);
			});
			for (var b = Object.create(null), x = v.timeline.events.length - 1; x >= 0; x--) {
				var S = v.timeline.events[x];
				if (!(S.state_key === null || S.state_key === void 0)) {
					var C = deepCopy(S);
					C.unsigned && (C.unsigned.prev_content && (C.content = C.unsigned.prev_content), C.unsigned.prev_sender && (C.sender = C.unsigned.prev_sender)), setState(b, C);
				}
			}
			Object.keys(_._currentState).forEach((e) => {
				Object.keys(_._currentState[e]).forEach((p) => {
					var m = _._currentState[e][p];
					v["org.matrix.msc4222.state_after"].events.push(m), b[e] && b[e][p] && (m = b[e][p]), v.state.events.push(m);
				});
			}), p.join[h] = v;
		});
		var h = [];
		return Object.keys(this.accountData).forEach((e) => {
			h.push(this.accountData[e]);
		}), {
			nextBatch: this.nextBatch,
			roomsData: p,
			accountData: h
		};
	}
	getNextBatchToken() {
		return this.nextBatch;
	}
};
function setState(e, p) {
	p.state_key === null || p.state_key === void 0 || !p.type || (e[p.type] || (e[p.type] = Object.create(null)), e[p.type][p.state_key] = p);
}
/* istanbul ignore next */
var DEFAULT_PAGINATE_LOOP_LIMIT = 10, TimelineWindow = class {
	constructor(e, p) {
		var m, h = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
		this.client = e, this.timelineSet = p, _defineProperty(this, "windowLimit", void 0), _defineProperty(this, "start", void 0), _defineProperty(this, "end", void 0), _defineProperty(this, "eventCount", 0), this.windowLimit = h.windowLimit || 1e3, (m = p.room) == null || m.on(RoomEvent.Timeline, this.onTimelineEvent.bind(this));
	}
	load(e) {
		var p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 20, m = (m) => {
			if (!m) throw Error("No timeline given to initFields");
			var h, g = m.getEvents();
			if (!e) h = g.length;
			else if (h = g.findIndex((p) => p.getId() === e), h < 0) throw Error("getEventTimeline result didn't include requested event");
			var _ = Math.min(g.length, h + Math.ceil(p / 2)), v = Math.max(0, _ - p);
			this.start = new TimelineIndex(m, v - m.getBaseIndex()), this.end = new TimelineIndex(m, _ - m.getBaseIndex()), this.eventCount = _ - v;
		};
		return this.timelineSet.getTimelineForEvent(e) ? (m(this.timelineSet.getTimelineForEvent(e)), Promise.resolve()) : e ? this.client.getEventTimeline(this.timelineSet, e).then(m) : (m(this.timelineSet.getLiveTimeline()), Promise.resolve());
	}
	getTimelineIndex(e) {
		if (e == EventTimeline.BACKWARDS) return this.start ?? null;
		if (e == EventTimeline.FORWARDS) return this.end ?? null;
		throw Error("Invalid direction '" + e + "'");
	}
	extend(e, p) {
		var m = this.getTimelineIndex(e);
		if (!m) return !1;
		var h = e == EventTimeline.BACKWARDS ? m.retreat(p) : m.advance(p);
		if (h) {
			this.eventCount += h, "" + h + this.eventCount;
			var g = this.eventCount - this.windowLimit;
			return g > 0 && this.unpaginate(g, e != EventTimeline.BACKWARDS), !0;
		}
		return !1;
	}
	onTimelineEvent(e, p, m, h) {
		h && this.onEventRemoved();
	}
	onEventRemoved() {
		var e = this.getEvents();
		e.length > 0 && e[e.length - 1] === void 0 && this.end && this.end.index--;
	}
	canPaginate(e) {
		var p = this.getTimelineIndex(e);
		if (!p) return !1;
		if (e == EventTimeline.BACKWARDS) {
			if (p.index > p.minIndex()) return !0;
		} else if (p.index < p.maxIndex()) return !0;
		var m = p.timeline.getNeighbouringTimeline(e), h = p.timeline.getPaginationToken(e);
		return !!m || !!h;
	}
	paginate(e, p) {
		var m = arguments, h = this;
		return _asyncToGenerator(function* () {
			var g = m.length > 2 && m[2] !== void 0 ? m[2] : !0, _ = m.length > 3 && m[3] !== void 0 ? m[3] : DEFAULT_PAGINATE_LOOP_LIMIT, v = h.getTimelineIndex(e);
			if (!v) return !1;
			if (v.pendingPaginate) return v.pendingPaginate;
			if (h.extend(e, p)) return !0;
			if (!g || _ === 0 || !v.timeline.getPaginationToken(e)) return !1;
			var y = h.client.paginateEventTimeline(v.timeline, {
				backwards: e == EventTimeline.BACKWARDS,
				limit: p
			}).finally(function() {
				v.pendingPaginate = void 0;
			}).then((m) => ("" + m, m ? h.paginate(e, p, !0, _ - 1) : h.paginate(e, p, !1, 0)));
			return v.pendingPaginate = y, y;
		})();
	}
	unpaginate(e, p) {
		var m = p ? this.start : this.end;
		if (!m) throw Error(`Attempting to unpaginate startOfTimeline=${p} but don't have this direction`);
		if (e > this.eventCount || e < 0) throw Error(`Attemting to unpaginate ${e} events, but only have ${this.eventCount} in the timeline`);
		for (; e > 0;) {
			var h = p ? m.advance(e) : m.retreat(e);
			if (h <= 0) throw Error("Unable to unpaginate any further, but still have " + this.eventCount + " events");
			e -= h, this.eventCount -= h, "" + h + this.eventCount;
		}
	}
	getEvents() {
		if (!this.start) return [];
		for (var e = [], p = this.start.timeline; p;) {
			var m = p.getEvents(), h = 0, g = m.length;
			p === this.start.timeline && (h = this.start.index + p.getBaseIndex()), p === this.end?.timeline && (g = this.end.index + p.getBaseIndex());
			for (var _ = h; _ < g; _++) e.push(m[_]);
			if (p === this.end?.timeline) break;
			p = p.getNeighbouringTimeline(EventTimeline.FORWARDS);
		}
		return e;
	}
}, TimelineIndex = class {
	constructor(e, p) {
		this.timeline = e, this.index = p, _defineProperty(this, "pendingPaginate", void 0);
	}
	minIndex() {
		return this.timeline.getBaseIndex() * -1;
	}
	maxIndex() {
		return this.timeline.getEvents().length - this.timeline.getBaseIndex();
	}
	advance(e) {
		if (!e) return 0;
		var p;
		if (e < 0) {
			if (p = Math.max(e, this.minIndex() - this.index), p < 0) return this.index += p, p;
		} else if (p = Math.min(e, this.maxIndex() - this.index), p > 0) return this.index += p, p;
		var m = this.timeline.getNeighbouringTimeline(e < 0 ? EventTimeline.BACKWARDS : EventTimeline.FORWARDS);
		return m ? (this.timeline = m, e < 0 ? this.index = this.maxIndex() : this.index = this.minIndex(), this.advance(e)) : 0;
	}
	retreat(e) {
		return this.advance(e * -1) * -1;
	}
}, EMAIL_STAGE_TYPE = "m.login.email.identity", MSISDN_STAGE_TYPE = "m.login.msisdn", AuthType = /* @__PURE__ */ function(e) {
	return e.Password = "m.login.password", e.Recaptcha = "m.login.recaptcha", e.Terms = "m.login.terms", e.Email = "m.login.email.identity", e.Msisdn = "m.login.msisdn", e.Sso = "m.login.sso", e.SsoUnstable = "org.matrix.login.sso", e.Dummy = "m.login.dummy", e.RegistrationToken = "m.login.registration_token", e.UnstableRegistrationToken = "org.matrix.msc3231.login.registration_token", e;
}({}), NoAuthFlowFoundError = class extends Error {
	constructor(e, p, m) {
		super(e), this.required_stages = p, this.flows = m, _defineProperty(this, "name", "NoAuthFlowFoundError");
	}
}, InteractiveAuth = class {
	constructor(e) {
		var p = this;
		_defineProperty(this, "matrixClient", void 0), _defineProperty(this, "inputs", void 0), _defineProperty(this, "clientSecret", void 0), _defineProperty(this, "requestCallback", void 0), _defineProperty(this, "busyChangedCallback", void 0), _defineProperty(this, "stateUpdatedCallback", void 0), _defineProperty(this, "requestEmailTokenCallback", void 0), _defineProperty(this, "supportedStages", void 0), _defineProperty(this, "data", void 0), _defineProperty(this, "emailSid", void 0), _defineProperty(this, "requestingEmailToken", !1), _defineProperty(this, "attemptAuthDeferred", null), _defineProperty(this, "chosenFlow", null), _defineProperty(this, "currentStage", null), _defineProperty(this, "emailAttempt", 1), _defineProperty(this, "submitPromise", null), _defineProperty(this, "requestEmailToken", /* @__PURE__ */ _asyncToGenerator(function* () {
			if (p.requestingEmailToken) logger.warn("Could not request email token: Already requesting");
			else {
				logger.trace("Requesting email token. Attempt: " + p.emailAttempt), p.requestingEmailToken = !0;
				try {
					p.emailSid = (yield p.requestEmailTokenCallback(p.inputs.emailAddress, p.clientSecret, p.emailAttempt++, p.data.session)).sid, logger.trace("Email token request succeeded");
				} finally {
					p.requestingEmailToken = !1;
				}
			}
		})), this.matrixClient = e.matrixClient, this.data = e.authData || { flows: [] }, this.requestCallback = e.doRequest, this.busyChangedCallback = e.busyChanged, this.stateUpdatedCallback = e.stateUpdated || e.startAuthStage, this.requestEmailTokenCallback = e.requestEmailToken, this.inputs = e.inputs || {}, e.sessionId && (this.data.session = e.sessionId), this.clientSecret = e.clientSecret || this.matrixClient.generateClientSecret(), this.emailSid = e.emailSid, e.supportedStages !== void 0 && (this.supportedStages = new Set(e.supportedStages));
	}
	attemptAuth() {
		var e = this;
		return _asyncToGenerator(function* () {
			var p;
			e.attemptAuthDeferred = Promise.withResolvers();
			var m = e.attemptAuthDeferred.promise;
			if ((p = e.data) != null && (p = p.flows) != null && p.length) e.startNextAuthStage();
			else {
				var h;
				(h = e.busyChangedCallback) == null || h.call(e, !0);
				var g = e.data.session ? { session: e.data.session } : null;
				e.doRequest(g).finally(() => {
					var p;
					(p = e.busyChangedCallback) == null || p.call(e, !1);
				});
			}
			return m;
		})();
	}
	poll() {
		var e = this;
		return _asyncToGenerator(function* () {
			if (e.data.session && e.attemptAuthDeferred && !e.submitPromise) {
				var p = {};
				if (e.currentStage == EMAIL_STAGE_TYPE && e.emailSid) {
					var m = {
						sid: e.emailSid,
						client_secret: e.clientSecret
					}, h = e.matrixClient.getIdentityServerUrl();
					h && (m.id_server = new URL(h).host), p = {
						type: EMAIL_STAGE_TYPE,
						threepid_creds: m
					};
				}
				e.submitAuthDict(p, !0);
			}
		})();
	}
	getSessionId() {
		return this.data?.session;
	}
	getClientSecret() {
		return this.clientSecret;
	}
	getStageParams(e) {
		var p;
		return (p = this.data) == null || (p = p.params) == null ? void 0 : p[e];
	}
	getChosenFlow() {
		return this.chosenFlow;
	}
	submitAuthDict(e) {
		var p = arguments, m = this;
		return _asyncToGenerator(function* () {
			var h, g = p.length > 1 && p[1] !== void 0 ? p[1] : !1;
			if (!m.attemptAuthDeferred) throw Error("submitAuthDict() called before attemptAuth()");
			if (!g) {
				var _;
				(_ = m.busyChangedCallback) == null || _.call(m, !0);
			}
			for (; m.submitPromise;) try {
				yield m.submitPromise;
			} catch {}
			var v = (h = m.data) != null && h.session ? Object.assign({ session: m.data.session }, e) : e;
			try {
				m.submitPromise = m.doRequest(v, g), yield m.submitPromise;
			} finally {
				if (m.submitPromise = null, !g) {
					var y;
					(y = m.busyChangedCallback) == null || y.call(m, !1);
				}
			}
		})();
	}
	getEmailSid() {
		return this.emailSid;
	}
	setEmailSid(e) {
		this.emailSid = e;
	}
	doRequest(e) {
		var p = arguments, m = this;
		return _asyncToGenerator(function* () {
			var h = p.length > 1 && p[1] !== void 0 ? p[1] : !1;
			try {
				var g = yield m.requestCallback(e, h);
				m.attemptAuthDeferred.resolve(g), m.attemptAuthDeferred = null;
			} catch (e) {
				var _, v, y = e instanceof MatrixError ? e : null, b = (y == null || (_ = y.data) == null ? void 0 : _.flows) ?? null, x = m.data?.flows || !!b;
				if (!y || y.httpStatus !== 401 || !y.data || !x) if (h) logger.log("Background poll request failed doing UI auth: ignoring", e);
				else {
					var S;
					(S = m.attemptAuthDeferred) == null || S.reject(e);
				}
				y && !y.data && (y.data = {}), y && !y.data.flows && !y.data.completed && !y.data.session && (y.data.flows = m.data.flows, y.data.completed = m.data.completed, y.data.session = m.data.session), y && (m.data = y.data);
				try {
					m.startNextAuthStage();
				} catch (e) {
					m.attemptAuthDeferred.reject(e), m.attemptAuthDeferred = null;
					return;
				}
				if (!m.emailSid && (v = m.chosenFlow) != null && v.stages.includes(AuthType.Email)) try {
					yield m.requestEmailToken();
				} catch (e) {
					m.attemptAuthDeferred.reject(e), m.attemptAuthDeferred = null;
				}
			}
		})();
	}
	startNextAuthStage() {
		var e, p, m = this.chooseStage();
		if (!m) throw Error("No incomplete flows from the server");
		if (this.currentStage = m, m === AuthType.Dummy) {
			this.submitAuthDict({ type: "m.login.dummy" });
			return;
		}
		if ((e = this.data) != null && e.errcode || (p = this.data) != null && p.error) {
			this.stateUpdatedCallback(m, {
				errcode: this.data?.errcode || "",
				error: this.data?.error || ""
			});
			return;
		}
		this.stateUpdatedCallback(m, m === EMAIL_STAGE_TYPE ? { emailSid: this.emailSid } : {});
	}
	chooseStage() {
		this.chosenFlow === null && (this.chosenFlow = this.chooseFlow()), logger.log("Active flow => %s", JSON.stringify(this.chosenFlow));
		var e = this.firstUncompletedStage(this.chosenFlow);
		return logger.log("Next stage: %s", e), e;
	}
	scoreFlow(e) {
		var p = e.stages.length;
		return this.supportedStages !== void 0 && (p += e.stages.filter((e) => !this.supportedStages.has(e)).length * 10), p;
	}
	chooseFlow() {
		var e = this.data?.flows || [], p = !!this.inputs.emailAddress || !!this.emailSid, m = !!this.inputs.phoneCountry && !!this.inputs.phoneNumber;
		e.sort((e, p) => this.scoreFlow(e) - this.scoreFlow(p));
		for (var h of e) {
			var g = !1, _ = !1;
			for (var v of h.stages) v === EMAIL_STAGE_TYPE ? g = !0 : v == MSISDN_STAGE_TYPE && (_ = !0);
			if (g == p && _ == m) return h;
		}
		var y = [];
		throw p && y.push(EMAIL_STAGE_TYPE), m && y.push(MSISDN_STAGE_TYPE), new NoAuthFlowFoundError("No appropriate authentication flow found", y, e);
	}
	firstUncompletedStage(e) {
		var p = this.data?.completed || [];
		return e.stages.find((e) => !p.includes(e));
	}
}, DB_MIGRATIONS = [
	(e) => {
		e.createObjectStore("users", { keyPath: ["userId"] }), e.createObjectStore("accountData", { keyPath: ["type"] }), e.createObjectStore("sync", { keyPath: ["clobber"] });
	},
	(e) => {
		e.createObjectStore("oob_membership_events", { keyPath: ["room_id", "state_key"] }).createIndex("room", "room_id");
	},
	(e) => {
		e.createObjectStore("client_options", { keyPath: ["clobber"] });
	},
	(e) => {
		e.createObjectStore("to_device_queue", { autoIncrement: !0 });
	}
], VERSION = DB_MIGRATIONS.length;
function selectQuery(e, p, m) {
	var h = e.openCursor(p);
	return new Promise((e, p) => {
		var g = [];
		h.onerror = () => {
			p(/* @__PURE__ */ Error("Query failed: " + h.error?.name));
		}, h.onsuccess = () => {
			var p = h.result;
			if (!p) {
				e(g);
				return;
			}
			g.push(m(p)), p.continue();
		};
	});
}
function txnAsPromise(e) {
	return new Promise((p, m) => {
		e.oncomplete = function(e) {
			p(e);
		}, e.onerror = function() {
			m(e.error);
		};
	});
}
function reqAsEventPromise(e) {
	return new Promise((p, m) => {
		e.onsuccess = function(e) {
			p(e);
		}, e.onerror = function() {
			m(e.error);
		};
	});
}
function reqAsPromise(e) {
	return new Promise((p, m) => {
		e.onsuccess = () => p(e), e.onerror = (e) => m(e);
	});
}
function reqAsCursorPromise(e) {
	return reqAsEventPromise(e).then((p) => e.result);
}
var LocalIndexedDBStoreBackend = class {
	static exists(e, p) {
		return p = "matrix-js-sdk:" + (p || "default"), exists(e, p);
	}
	constructor(e) {
		var p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "default";
		this.indexedDB = e, _defineProperty(this, "dbName", void 0), _defineProperty(this, "syncAccumulator", void 0), _defineProperty(this, "db", void 0), _defineProperty(this, "disconnected", !0), _defineProperty(this, "_isNewlyCreated", !1), _defineProperty(this, "syncToDatabasePromise", void 0), _defineProperty(this, "pendingUserPresenceData", []), this.dbName = "matrix-js-sdk:" + p, this.syncAccumulator = new SyncAccumulator();
	}
	connect(e) {
		var p = this;
		if (!this.disconnected) return logger.log("LocalIndexedDBStoreBackend.connect: already connected or connecting"), Promise.resolve();
		this.disconnected = !1, logger.log("LocalIndexedDBStoreBackend.connect: connecting...");
		var m = this.indexedDB.open(this.dbName, VERSION);
		return m.onupgradeneeded = (e) => {
			var p = m.result, h = e.oldVersion;
			logger.log(`LocalIndexedDBStoreBackend.connect: upgrading from ${h}`), h < 1 && (this._isNewlyCreated = !0), DB_MIGRATIONS.forEach((e, m) => {
				h <= m && e(p);
			});
		}, m.onblocked = () => {
			logger.log("can't yet open LocalIndexedDBStoreBackend because it is open elsewhere");
		}, logger.log("LocalIndexedDBStoreBackend.connect: awaiting connection..."), reqAsEventPromise(m).then(/* @__PURE__ */ _asyncToGenerator(function* () {
			logger.log("LocalIndexedDBStoreBackend.connect: connected"), p.db = m.result, p.db.onversionchange = () => {
				var e;
				(e = p.db) == null || e.close(), p.disconnected = !0, p.db = void 0;
			}, p.db.onclose = () => {
				p.disconnected = !0, p.db = void 0, e?.();
			}, yield p.init();
		}));
	}
	isNewlyCreated() {
		return Promise.resolve(this._isNewlyCreated);
	}
	init() {
		return Promise.all([this.loadAccountData(), this.loadSyncData()]).then((e) => {
			var [p, m] = e;
			logger.log("LocalIndexedDBStoreBackend: loaded initial data"), this.syncAccumulator.accumulate({
				next_batch: m.nextBatch,
				rooms: m.roomsData,
				account_data: { events: p }
			}, !0);
		});
	}
	getOutOfBandMembers(e) {
		return new Promise((p, m) => {
			var h = this.db.transaction(["oob_membership_events"], "readonly").objectStore("oob_membership_events").index("room"), g = IDBKeyRange.only(e), _ = h.openCursor(g), v = [], y = !1;
			_.onsuccess = () => {
				var e = _.result;
				if (!e) return !v.length && !y ? p(null) : p(v);
				var m = e.value;
				m.oob_written ? y = !0 : v.push(m), e.continue();
			}, _.onerror = (e) => {
				m(e);
			};
		}).then((p) => (logger.log(`LL: got ${p?.length} membershipEvents from storage for room ${e} ...`), p));
	}
	setOutOfBandMembers(e, p) {
		var m = this;
		return _asyncToGenerator(function* () {
			logger.log(`LL: backend about to store ${p.length} members for ${e}`);
			var h = m.db.transaction(["oob_membership_events"], "readwrite"), g = h.objectStore("oob_membership_events");
			p.forEach((e) => {
				g.put(e);
			});
			var _ = {
				room_id: e,
				oob_written: !0,
				state_key: 0
			};
			g.put(_), yield txnAsPromise(h), logger.log(`LL: backend done storing for ${e}!`);
		})();
	}
	clearOutOfBandMembers(e) {
		var p = this;
		return _asyncToGenerator(function* () {
			var m = p.db.transaction(["oob_membership_events"], "readonly").objectStore("oob_membership_events").index("room"), h = IDBKeyRange.only(e), g = reqAsCursorPromise(m.openKeyCursor(h, "next")).then((e) => (e?.primaryKey)[1]), _ = reqAsCursorPromise(m.openKeyCursor(h, "prev")).then((e) => (e?.primaryKey)[1]), [v, y] = yield Promise.all([g, _]), b = p.db.transaction(["oob_membership_events"], "readwrite").objectStore("oob_membership_events"), x = IDBKeyRange.bound([e, v], [e, y]);
			logger.log(`LL: Deleting all users + marker in storage for room ${e}, with key range:`, [e, v], [e, y]), yield reqAsPromise(b.delete(x));
		})();
	}
	clearDatabase() {
		return new Promise((e) => {
			var p;
			logger.log(`Removing indexeddb instance: ${this.dbName}`), (p = this.db) == null || p.close();
			var m = this.indexedDB.deleteDatabase(this.dbName);
			m.onblocked = () => {
				logger.log(`can't yet delete indexeddb ${this.dbName} because it is open elsewhere`);
			}, m.onerror = () => {
				logger.warn(`unable to delete js-sdk store indexeddb: ${m.error?.name}`), e();
			}, m.onsuccess = () => {
				logger.log(`Removed indexeddb instance: ${this.dbName}`), e();
			};
		});
	}
	getSavedSync() {
		var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0, p = this.syncAccumulator.getJSON();
		return p.nextBatch ? e ? Promise.resolve(deepCopy(p)) : Promise.resolve(p) : Promise.resolve(null);
	}
	getNextBatchToken() {
		return Promise.resolve(this.syncAccumulator.getNextBatchToken());
	}
	setSyncData(e) {
		return Promise.resolve().then(() => {
			this.syncAccumulator.accumulate(e);
		});
	}
	syncToDatabase(e) {
		var p = this;
		return _asyncToGenerator(function* () {
			return p.syncToDatabasePromise ? (logger.warn("Skipping syncToDatabase() as persist already in flight"), p.pendingUserPresenceData.push(...e), p.syncToDatabasePromise) : (e.unshift(...p.pendingUserPresenceData), p.syncToDatabasePromise = p.doSyncToDatabase(e), p.syncToDatabasePromise);
		})();
	}
	doSyncToDatabase(e) {
		var p = this;
		return _asyncToGenerator(function* () {
			try {
				var m = p.syncAccumulator.getJSON(!0);
				yield Promise.all([
					p.persistUserPresenceEvents(e),
					p.persistAccountData(m.accountData),
					p.persistSyncData(m.nextBatch, m.roomsData)
				]);
			} finally {
				p.syncToDatabasePromise = void 0;
			}
		})();
	}
	persistSyncData(e, p) {
		return logger.log("Persisting sync data up to", e), promiseTry(() => {
			var m = this.db.transaction(["sync"], "readwrite");
			return m.objectStore("sync").put({
				clobber: "-",
				nextBatch: e,
				roomsData: p
			}), txnAsPromise(m).then(() => {
				logger.log("Persisted sync data up to", e);
			});
		});
	}
	persistAccountData(e) {
		return promiseTry(() => {
			var p = this.db.transaction(["accountData"], "readwrite"), m = p.objectStore("accountData");
			for (var h of e) m.put(h);
			return txnAsPromise(p).then();
		});
	}
	persistUserPresenceEvents(e) {
		return promiseTry(() => {
			var p = this.db.transaction(["users"], "readwrite"), m = p.objectStore("users");
			for (var h of e) m.put({
				userId: h[0],
				event: h[1]
			});
			return txnAsPromise(p).then();
		});
	}
	getUserPresenceEvents() {
		return promiseTry(() => {
			var e = this.db.transaction(["users"], "readonly").objectStore("users");
			return selectQuery(e, void 0, (e) => [e.value.userId, e.value.event]);
		});
	}
	loadAccountData() {
		return logger.log("LocalIndexedDBStoreBackend: loading account data..."), promiseTry(() => {
			var e = this.db.transaction(["accountData"], "readonly").objectStore("accountData");
			return selectQuery(e, void 0, (e) => e.value).then((e) => (logger.log("LocalIndexedDBStoreBackend: loaded account data"), e));
		});
	}
	loadSyncData() {
		return logger.log("LocalIndexedDBStoreBackend: loading sync data..."), promiseTry(() => {
			var e = this.db.transaction(["sync"], "readonly").objectStore("sync");
			return selectQuery(e, void 0, (e) => e.value).then((e) => (logger.log("LocalIndexedDBStoreBackend: loaded sync data"), e.length > 1 && logger.warn("loadSyncData: More than 1 sync row found."), e.length > 0 ? e[0] : {}));
		});
	}
	getClientOptions() {
		return Promise.resolve().then(() => {
			var e = this.db.transaction(["client_options"], "readonly").objectStore("client_options");
			return selectQuery(e, void 0, (e) => e.value?.options).then((e) => e[0]);
		});
	}
	storeClientOptions(e) {
		var p = this;
		return _asyncToGenerator(function* () {
			var m = p.db.transaction(["client_options"], "readwrite");
			m.objectStore("client_options").put({
				clobber: "-",
				options: e
			}), yield txnAsPromise(m);
		})();
	}
	saveToDeviceBatches(e) {
		var p = this;
		return _asyncToGenerator(function* () {
			var m = p.db.transaction(["to_device_queue"], "readwrite"), h = m.objectStore("to_device_queue");
			for (var g of e) h.add(g);
			yield txnAsPromise(m);
		})();
	}
	getOldestToDeviceBatch() {
		var e = this;
		return _asyncToGenerator(function* () {
			var p = e.db.transaction(["to_device_queue"], "readonly").objectStore("to_device_queue"), m = yield reqAsCursorPromise(p.openCursor());
			if (!m) return null;
			var h = m.value;
			return {
				id: m.key,
				txnId: h.txnId,
				eventType: h.eventType,
				batch: h.batch
			};
		})();
	}
	removeToDeviceBatch(e) {
		var p = this;
		return _asyncToGenerator(function* () {
			var m = p.db.transaction(["to_device_queue"], "readwrite");
			m.objectStore("to_device_queue").delete(e), yield txnAsPromise(m);
		})();
	}
	destroy() {
		var e = this;
		return _asyncToGenerator(function* () {
			var p;
			(p = e.db) == null || p.close();
		})();
	}
}, RemoteIndexedDBStoreBackend = class {
	constructor(e, p) {
		this.workerFactory = e, this.dbName = p, _defineProperty(this, "worker", void 0), _defineProperty(this, "nextSeq", 0), _defineProperty(this, "inFlight", {}), _defineProperty(this, "startPromise", void 0), _defineProperty(this, "onWorkerMessage", (e) => {
			var p = e.data;
			if (p.command == "closed") {
				var m;
				(m = this.onClose) == null || m.call(this);
			} else if (p.command == "cmd_success" || p.command == "cmd_fail") {
				if (p.seq === void 0) {
					logger.error("Got reply from worker with no seq");
					return;
				}
				var h = this.inFlight[p.seq];
				if (h === void 0) {
					logger.error("Got reply for unknown seq " + p.seq);
					return;
				}
				if (delete this.inFlight[p.seq], p.command == "cmd_success") h.resolve(p.result);
				else {
					var g = Error(p.error.message);
					g.name = p.error.name, h.reject(g);
				}
			} else logger.warn("Unrecognised message from worker: ", p);
		});
	}
	connect(e) {
		return this.onClose = e, this.ensureStarted().then(() => this.doCmd("connect"));
	}
	clearDatabase() {
		return this.ensureStarted().then(() => this.doCmd("clearDatabase"));
	}
	isNewlyCreated() {
		return this.doCmd("isNewlyCreated");
	}
	getSavedSync() {
		return this.doCmd("getSavedSync");
	}
	getNextBatchToken() {
		return this.doCmd("getNextBatchToken");
	}
	setSyncData(e) {
		return this.doCmd("setSyncData", [e]);
	}
	syncToDatabase(e) {
		return this.doCmd("syncToDatabase", [e]);
	}
	getOutOfBandMembers(e) {
		return this.doCmd("getOutOfBandMembers", [e]);
	}
	setOutOfBandMembers(e, p) {
		return this.doCmd("setOutOfBandMembers", [e, p]);
	}
	clearOutOfBandMembers(e) {
		return this.doCmd("clearOutOfBandMembers", [e]);
	}
	getClientOptions() {
		return this.doCmd("getClientOptions");
	}
	storeClientOptions(e) {
		return this.doCmd("storeClientOptions", [e]);
	}
	getUserPresenceEvents() {
		return this.doCmd("getUserPresenceEvents");
	}
	saveToDeviceBatches(e) {
		var p = this;
		return _asyncToGenerator(function* () {
			return p.doCmd("saveToDeviceBatches", [e]);
		})();
	}
	getOldestToDeviceBatch() {
		var e = this;
		return _asyncToGenerator(function* () {
			return e.doCmd("getOldestToDeviceBatch");
		})();
	}
	removeToDeviceBatch(e) {
		var p = this;
		return _asyncToGenerator(function* () {
			return p.doCmd("removeToDeviceBatch", [e]);
		})();
	}
	ensureStarted() {
		return this.startPromise ||= (this.worker = this.workerFactory(), this.worker.onmessage = this.onWorkerMessage, this.doCmd("setupWorker", [this.dbName]).then(() => {
			logger.log("IndexedDB worker is ready");
		})), this.startPromise;
	}
	doCmd(e, p) {
		return Promise.resolve().then(() => {
			var m, h = this.nextSeq++, g = Promise.withResolvers();
			return this.inFlight[h] = g, (m = this.worker) == null || m.postMessage({
				command: e,
				seq: h,
				args: p
			}), g.promise;
		});
	}
	destroy() {
		var e = this;
		return _asyncToGenerator(function* () {
			var p;
			(p = e.worker) == null || p.terminate();
		})();
	}
}, WRITE_DELAY_MS = 1e3 * 60 * 5, IndexedDBStore = class extends MemoryStore {
	static exists(e, p) {
		return LocalIndexedDBStoreBackend.exists(e, p);
	}
	constructor(e) {
		if (super(e), _defineProperty(this, "backend", void 0), _defineProperty(this, "startedUp", !1), _defineProperty(this, "syncTs", 0), _defineProperty(this, "userModifiedMap", {}), _defineProperty(this, "emitter", new TypedEventEmitter()), _defineProperty(this, "onClose", () => {
			this.emitter.emit("closed");
		}), _defineProperty(this, "getSavedSync", this.degradable(() => this.backend.getSavedSync(), "getSavedSync")), _defineProperty(this, "isNewlyCreated", this.degradable(() => this.backend.isNewlyCreated(), "isNewlyCreated")), _defineProperty(this, "getSavedSyncToken", this.degradable(() => this.backend.getNextBatchToken(), "getSavedSyncToken")), _defineProperty(this, "deleteAllData", this.degradable(() => (super.deleteAllData(), this.backend.clearDatabase().then(() => {
			logger.log("Deleted indexeddb data.");
		}, (e) => {
			throw logger.error(`Failed to delete indexeddb data: ${e}`), e;
		})), null)), _defineProperty(this, "reallySave", this.degradable(() => {
			this.syncTs = Date.now();
			var e = [];
			for (var p of this.getUsers()) this.userModifiedMap[p.userId] !== p.getLastModifiedTime() && p.events.presence && (e.push([p.userId, p.events.presence.event]), this.userModifiedMap[p.userId] = p.getLastModifiedTime());
			return this.backend.syncToDatabase(e);
		}, null)), _defineProperty(this, "setSyncData", this.degradable((e) => this.backend.setSyncData(e), "setSyncData")), _defineProperty(this, "getOutOfBandMembers", this.degradable((e) => this.backend.getOutOfBandMembers(e), "getOutOfBandMembers")), _defineProperty(this, "setOutOfBandMembers", this.degradable((e, p) => (super.setOutOfBandMembers(e, p), this.backend.setOutOfBandMembers(e, p)), "setOutOfBandMembers")), _defineProperty(this, "clearOutOfBandMembers", this.degradable((e) => (super.clearOutOfBandMembers(e), this.backend.clearOutOfBandMembers(e)), "clearOutOfBandMembers")), _defineProperty(this, "getClientOptions", this.degradable(() => this.backend.getClientOptions(), "getClientOptions")), _defineProperty(this, "storeClientOptions", this.degradable((e) => (super.storeClientOptions(e), this.backend.storeClientOptions(e)), "storeClientOptions")), !e.indexedDB) throw Error("Missing required option: indexedDB");
		e.workerFactory ? this.backend = new RemoteIndexedDBStoreBackend(e.workerFactory, e.dbName) : this.backend = new LocalIndexedDBStoreBackend(e.indexedDB, e.dbName);
	}
	on(e, p) {
		this.emitter.on(e, p);
	}
	startup() {
		return this.startedUp ? (logger.log("IndexedDBStore.startup: already started"), Promise.resolve()) : (logger.log("IndexedDBStore.startup: connecting to backend"), this.backend.connect(this.onClose).then(() => (logger.log("IndexedDBStore.startup: loading presence events"), this.backend.getUserPresenceEvents())).then((e) => {
			logger.log("IndexedDBStore.startup: processing presence events"), e.forEach((e) => {
				var [p, m] = e;
				if (!this.createUser) throw Error("`IndexedDBStore.startup` must be called after assigning it to the client, not before!");
				var h = this.createUser(p);
				m && h.setPresenceEvent(new MatrixEvent(m)), this.userModifiedMap[h.userId] = h.getLastModifiedTime(), this.storeUser(h);
			}), this.startedUp = !0;
		}));
	}
	destroy() {
		return this.backend.destroy();
	}
	wantsSave() {
		return Date.now() - this.syncTs > WRITE_DELAY_MS;
	}
	save() {
		return arguments.length > 0 && arguments[0] !== void 0 && arguments[0] || this.wantsSave() ? this.reallySave() : Promise.resolve();
	}
	degradable(e, p) {
		var m = this, h = p ? super[p] : null;
		return /* @__PURE__ */ _asyncToGenerator(function* () {
			var p = [...arguments];
			try {
				return yield e.call(m, ...p);
			} catch (e) {
				logger.error("IndexedDBStore failure, degrading to MemoryStore", e), m.emitter.emit("degraded", e);
				try {
					logger.log("IndexedDBStore trying to delete degraded data"), yield m.backend.clearDatabase(), logger.log("IndexedDBStore delete after degrading succeeded");
				} catch (e) {
					logger.warn("IndexedDBStore delete after degrading failed", e);
				}
				if (h) return h.call(m, ...p);
			}
		});
	}
	getPendingEvents(e) {
		var p = () => super.getPendingEvents, m = this;
		return _asyncToGenerator(function* () {
			if (!m.localStorage) return p().call(m, e);
			var h = m.localStorage.getItem(pendingEventsKey(e));
			if (h) try {
				return JSON.parse(h);
			} catch (e) {
				logger.error("Could not parse persisted pending events", e);
			}
			return [];
		})();
	}
	setPendingEvents(e, p) {
		var m = () => super.setPendingEvents, h = this;
		return _asyncToGenerator(function* () {
			if (!h.localStorage) return m().call(h, e, p);
			p.length > 0 ? h.localStorage.setItem(pendingEventsKey(e), JSON.stringify(p)) : h.localStorage.removeItem(pendingEventsKey(e));
		})();
	}
	saveToDeviceBatches(e) {
		return this.backend.saveToDeviceBatches(e);
	}
	getOldestToDeviceBatch() {
		return this.backend.getOldestToDeviceBatch();
	}
	removeToDeviceBatch(e) {
		return this.backend.removeToDeviceBatch(e);
	}
};
function pendingEventsKey(e) {
	return `mx_pending_events_${e}`;
}
var ThreepidMedium = /* @__PURE__ */ function(e) {
	return e.Email = "email", e.Phone = "msisdn", e;
}({}), DELEGATED_OIDC_COMPATIBILITY = new UnstableValue("delegated_oidc_compatibility", "org.matrix.msc3824.delegated_oidc_compatibility"), IdentityProviderBrand = /* @__PURE__ */ function(e) {
	return e.Gitlab = "gitlab", e.Github = "github", e.Apple = "apple", e.Google = "google", e.Facebook = "facebook", e.Twitter = "twitter", e;
}({}), SSOAction = /* @__PURE__ */ function(e) {
	return e.LOGIN = "login", e.REGISTER = "register", e;
}({}), ProfileKeyTimezone = "m.tz", ProfileKeyMSC4175Timezone = "us.cloke.msc4175.tz", RelatedRelations = class {
	constructor(e) {
		_defineProperty(this, "relations", void 0), this.relations = e.filter((e) => !!e);
	}
	getRelations() {
		return this.relations.reduce((e, p) => [...e, ...p.getRelations()], []);
	}
	on(e, p) {
		this.relations.forEach((m) => m.on(e, p));
	}
	off(e, p) {
		this.relations.forEach((m) => m.off(e, p));
	}
}, LocalStorageErrors = /* @__PURE__ */ function(e) {
	return e.Global = "Global", e.SetItemError = "setItem", e.GetItemError = "getItem", e.RemoveItemError = "removeItem", e.ClearError = "clear", e.QuotaExceededError = "QuotaExceededError", e;
}({}), localStorageErrorsEventsEmitter = new class extends TypedEventEmitter {}(), matrix_exports = /* @__PURE__ */ __export({
	AuthType: () => AuthType,
	AutoDiscovery: () => AutoDiscovery,
	AutoDiscoveryAction: () => AutoDiscoveryAction,
	AutoDiscoveryError: () => AutoDiscoveryError,
	Beacon: () => Beacon,
	BeaconEvent: () => BeaconEvent,
	CallEvent: () => CallEvent,
	CallFeedEvent: () => CallFeedEvent,
	Category: () => Category,
	ClientEvent: () => ClientEvent,
	ClientPrefix: () => ClientPrefix,
	ClientStoppedError: () => ClientStoppedError,
	ConditionKind: () => ConditionKind,
	ConditionOperator: () => ConditionOperator,
	ConnectionError: () => ConnectionError,
	ContentHelpers: () => content_helpers_exports,
	DELEGATED_OIDC_COMPATIBILITY: () => DELEGATED_OIDC_COMPATIBILITY,
	DEVICE_CODE_SCOPE: () => DEVICE_CODE_SCOPE,
	DMMemberCountCondition: () => "2",
	DebugLogger: () => DebugLogger,
	Device: () => Device,
	DeviceVerification: () => DeviceVerification,
	Direction: () => Direction,
	DuplicateStrategy: () => DuplicateStrategy,
	EVENT_VISIBILITY_CHANGE_TYPE: () => EVENT_VISIBILITY_CHANGE_TYPE,
	EventEmitterEvents: () => EventEmitterEvents,
	EventStatus: () => EventStatus,
	EventTimeline: () => EventTimeline,
	EventTimelineSet: () => EventTimelineSet,
	EventType: () => EventType,
	FILTER_RELATED_BY_REL_TYPES: () => FILTER_RELATED_BY_REL_TYPES,
	FILTER_RELATED_BY_SENDERS: () => FILTER_RELATED_BY_SENDERS,
	FeatureSupport: () => FeatureSupport,
	Filter: () => Filter,
	GET_LOGIN_TOKEN_CAPABILITY: () => GET_LOGIN_TOKEN_CAPABILITY,
	GroupCall: () => GroupCall,
	GroupCallEvent: () => GroupCallEvent,
	GroupCallIntent: () => GroupCallIntent,
	GroupCallState: () => GroupCallState,
	GroupCallStatsReportEvent: () => GroupCallStatsReportEvent,
	GroupCallType: () => GroupCallType,
	GuestAccess: () => GuestAccess,
	HTTPError: () => HTTPError,
	HistoryVisibility: () => HistoryVisibility,
	HttpApiEvent: () => HttpApiEvent,
	IdentityPrefix: () => IdentityPrefix,
	IdentityProviderBrand: () => IdentityProviderBrand,
	IndexedDBCryptoStore: () => IndexedDBCryptoStore,
	IndexedDBStore: () => IndexedDBStore,
	InteractiveAuth: () => InteractiveAuth,
	InvalidCryptoStoreError: () => InvalidCryptoStoreError,
	InvalidCryptoStoreState: () => InvalidCryptoStoreState,
	JoinRule: () => JoinRule,
	KNOWN_SAFE_ROOM_VERSION: () => "10",
	KeySignatureUploadError: () => KeySignatureUploadError,
	KnownMembership: () => KnownMembership,
	LOCAL_NOTIFICATION_SETTINGS_PREFIX: () => LOCAL_NOTIFICATION_SETTINGS_PREFIX,
	LocalStorageCryptoStore: () => LocalStorageCryptoStore,
	LocalStorageErrors: () => LocalStorageErrors,
	LocationAssetType: () => LocationAssetType,
	MAIN_ROOM_TIMELINE: () => MAIN_ROOM_TIMELINE,
	MAXIMUM_MATRIX_VERSION: () => MAXIMUM_MATRIX_VERSION,
	MAX_STICKY_DURATION_MS: () => MAX_STICKY_DURATION_MS,
	MINIMUM_MATRIX_VERSION: () => MINIMUM_MATRIX_VERSION,
	MSC3912_RELATION_BASED_REDACTIONS_PROP: () => MSC3912_RELATION_BASED_REDACTIONS_PROP,
	MXID_PATTERN: () => MXID_PATTERN,
	M_ASSET: () => M_ASSET,
	M_BEACON: () => M_BEACON,
	M_BEACON_INFO: () => M_BEACON_INFO,
	M_HTML: () => M_HTML,
	M_LOCATION: () => M_LOCATION,
	M_MESSAGE: () => M_MESSAGE,
	M_POLL_END: () => M_POLL_END,
	M_POLL_KIND_DISCLOSED: () => M_POLL_KIND_DISCLOSED,
	M_POLL_KIND_UNDISCLOSED: () => M_POLL_KIND_UNDISCLOSED,
	M_POLL_RESPONSE: () => M_POLL_RESPONSE,
	M_POLL_START: () => M_POLL_START,
	M_TEXT: () => M_TEXT,
	M_TIMESTAMP: () => M_TIMESTAMP,
	M_TOPIC: () => M_TOPIC,
	MatrixClient: () => MatrixClient,
	MatrixError: () => MatrixError,
	MatrixEvent: () => MatrixEvent,
	MatrixEventEvent: () => MatrixEventEvent,
	MatrixHttpApi: () => MatrixHttpApi,
	MatrixScheduler: () => MatrixScheduler,
	MediaHandlerEvent: () => MediaHandlerEvent,
	MediaPrefix: () => MediaPrefix,
	MemoryCryptoStore: () => MemoryCryptoStore,
	MemoryStore: () => MemoryStore,
	Method: () => Method,
	MsgType: () => MsgType,
	NoAuthFlowFoundError: () => NoAuthFlowFoundError,
	NotificationCountType: () => NotificationCountType,
	OidcError: () => OidcError,
	OidcTokenRefresher: () => OidcTokenRefresher,
	PUSHER_DEVICE_ID: () => PUSHER_DEVICE_ID,
	PUSHER_ENABLED: () => PUSHER_ENABLED,
	PendingEventOrdering: () => PendingEventOrdering,
	Poll: () => Poll,
	PollEvent: () => PollEvent,
	Preset: () => Preset,
	ProfileKeyMSC4175Timezone: () => ProfileKeyMSC4175Timezone,
	ProfileKeyTimezone: () => ProfileKeyTimezone,
	PushRuleActionName: () => PushRuleActionName,
	PushRuleKind: () => PushRuleKind,
	REFERENCE_RELATION: () => REFERENCE_RELATION,
	ReceiptType: () => ReceiptType,
	RelatedRelations: () => RelatedRelations,
	RelationType: () => RelationType,
	Relations: () => Relations,
	RelationsEvent: () => RelationsEvent,
	RestrictedAllowType: () => RestrictedAllowType,
	Room: () => Room,
	RoomCreateTypeField: () => RoomCreateTypeField,
	RoomEvent: () => RoomEvent,
	RoomMember: () => RoomMember,
	RoomMemberEvent: () => RoomMemberEvent,
	RoomNameType: () => RoomNameType,
	RoomState: () => RoomState,
	RoomStateEvent: () => RoomStateEvent,
	RoomSummary: () => RoomSummary,
	RoomType: () => RoomType,
	RoomVersionStability: () => RoomVersionStability,
	RoomWidgetClient: () => RoomWidgetClient,
	RoomWidgetClientEvent: () => RoomWidgetClientEvent,
	RuleId: () => RuleId,
	SERVICE_TYPES: () => SERVICE_TYPES,
	SSOAction: () => SSOAction,
	STABLE_MSC4133_EXTENDED_PROFILES: () => STABLE_MSC4133_EXTENDED_PROFILES,
	SUPPORTED_MATRIX_VERSIONS: () => SUPPORTED_MATRIX_VERSIONS,
	SearchOrderBy: () => SearchOrderBy,
	SearchResult: () => SearchResult,
	SecretStorage: () => secret_storage_exports,
	ServerCapabilities: () => ServerCapabilities,
	SetPresence: () => SetPresence,
	SlidingSyncEvent: () => SlidingSyncEvent,
	StatsReport: () => StatsReport,
	SyncAccumulator: () => SyncAccumulator,
	SyncState: () => SyncState,
	THREAD_RELATION_TYPE: () => THREAD_RELATION_TYPE,
	Thread: () => Thread,
	ThreadEvent: () => ThreadEvent,
	ThreadFilterType: () => ThreadFilterType,
	ThreepidMedium: () => ThreepidMedium,
	TimelineIndex: () => TimelineIndex,
	TimelineWindow: () => TimelineWindow,
	ToDeviceMessageId: () => ToDeviceMessageId,
	TokenRefreshError: () => TokenRefreshError,
	TokenRefreshLogoutError: () => TokenRefreshLogoutError,
	TweakName: () => TweakName,
	TypedEventEmitter: () => TypedEventEmitter,
	UNSIGNED_MEMBERSHIP_FIELD: () => UNSIGNED_MEMBERSHIP_FIELD,
	UNSIGNED_THREAD_ID_FIELD: () => UNSIGNED_THREAD_ID_FIELD,
	UNSTABLE_ELEMENT_FUNCTIONAL_USERS: () => UNSTABLE_ELEMENT_FUNCTIONAL_USERS,
	UNSTABLE_MSC2666_MUTUAL_ROOMS: () => UNSTABLE_MSC2666_MUTUAL_ROOMS,
	UNSTABLE_MSC2666_QUERY_MUTUAL_ROOMS: () => UNSTABLE_MSC2666_QUERY_MUTUAL_ROOMS,
	UNSTABLE_MSC2666_SHARED_ROOMS: () => UNSTABLE_MSC2666_SHARED_ROOMS,
	UNSTABLE_MSC2716_MARKER: () => UNSTABLE_MSC2716_MARKER,
	UNSTABLE_MSC3088_ENABLED: () => UNSTABLE_MSC3088_ENABLED,
	UNSTABLE_MSC3088_PURPOSE: () => UNSTABLE_MSC3088_PURPOSE,
	UNSTABLE_MSC3089_BRANCH: () => UNSTABLE_MSC3089_BRANCH,
	UNSTABLE_MSC3089_LEAF: () => UNSTABLE_MSC3089_LEAF,
	UNSTABLE_MSC3089_TREE_SUBTYPE: () => UNSTABLE_MSC3089_TREE_SUBTYPE,
	UNSTABLE_MSC3852_LAST_SEEN_UA: () => UNSTABLE_MSC3852_LAST_SEEN_UA,
	UNSTABLE_MSC4133_EXTENDED_PROFILES: () => UNSTABLE_MSC4133_EXTENDED_PROFILES,
	UNSTABLE_MSC4140_DELAYED_EVENTS: () => UNSTABLE_MSC4140_DELAYED_EVENTS,
	UNSTABLE_MSC4354_STICKY_EVENTS: () => UNSTABLE_MSC4354_STICKY_EVENTS,
	UnsupportedDelayedEventsEndpointError: () => UnsupportedDelayedEventsEndpointError,
	UnsupportedStickyEventsEndpointError: () => UnsupportedStickyEventsEndpointError,
	UpdateDelayedEventAction: () => UpdateDelayedEventAction,
	User: () => User,
	UserEvent: () => UserEvent,
	Visibility: () => Visibility,
	anySignal: () => anySignal,
	calculateRetryBackoff: () => calculateRetryBackoff,
	completeAuthorizationCodeGrant: () => completeAuthorizationCodeGrant,
	createClient: () => createClient,
	createNewMatrixCall: () => createNewMatrixCall,
	createRoomWidgetClient: () => createRoomWidgetClient,
	decodeBase64: () => decodeBase64,
	decodeIdToken: () => decodeIdToken,
	determineFeatureSupport: () => determineFeatureSupport,
	discoverAndValidateOIDCIssuerWellKnown: () => discoverAndValidateOIDCIssuerWellKnown,
	encodeBase64: () => encodeBase64,
	encodeUnpaddedBase64: () => encodeUnpaddedBase64,
	encodeUnpaddedBase64Url: () => encodeUnpaddedBase64Url,
	fixNotificationCountOnDecryption: () => fixNotificationCountOnDecryption,
	generateAuthorizationParams: () => generateAuthorizationParams,
	generateAuthorizationUrl: () => generateAuthorizationUrl,
	generateOidcAuthorizationUrl: () => generateOidcAuthorizationUrl,
	generateScope: () => generateScope,
	getBeaconInfoIdentifier: () => getBeaconInfoIdentifier,
	getHttpUriForMxc: () => getHttpUriForMxc,
	inMainTimelineForReceipt: () => inMainTimelineForReceipt,
	isDmMemberCountCondition: () => isDmMemberCountCondition,
	isEventTypeSame: () => isEventTypeSame,
	isPollEvent: () => isPollEvent,
	isSendDelayedEventRequestOpts: () => isSendDelayedEventRequestOpts,
	isTimestampInDuration: () => isTimestampInDuration,
	localStorageErrorsEventsEmitter: () => localStorageErrorsEventsEmitter,
	parseErrorResponse: () => parseErrorResponse,
	registerOidcClient: () => registerOidcClient,
	retryNetworkOperation: () => retryNetworkOperation,
	safeGetRetryAfterMs: () => safeGetRetryAfterMs,
	setCryptoStoreFactory: () => setCryptoStoreFactory,
	threadFilterTypeToFilter: () => threadFilterTypeToFilter,
	threadIdForReceipt: () => threadIdForReceipt,
	timeoutSignal: () => timeoutSignal,
	validateAuthMetadata: () => validateAuthMetadata,
	validateAuthMetadataAndKeys: () => validateAuthMetadataAndKeys,
	validateBearerTokenResponse: () => validateBearerTokenResponse,
	validateIdToken: () => validateIdToken,
	validateStoredUserState: () => validateStoredUserState
}), cryptoStoreFactory = () => new MemoryCryptoStore();
function setCryptoStoreFactory(e) {
	cryptoStoreFactory = e;
}
function amendClientOpts(e) {
	return e.store = e.store ?? new MemoryStore({ localStorage: globalThis.localStorage }), e.scheduler = e.scheduler ?? new MatrixScheduler(), e.cryptoStore = e.cryptoStore ?? cryptoStoreFactory(), e;
}
function createClient(e) {
	return new MatrixClient(amendClientOpts(e));
}
function createRoomWidgetClient(e, p, m, h) {
	var g = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0;
	return new RoomWidgetClient(e, p, m, amendClientOpts(h), g);
}
if (globalThis.__js_sdk_entrypoint) throw Error("Multiple matrix-js-sdk entrypoints detected!");
globalThis.__js_sdk_entrypoint = !0;
var indexedDB;
try {
	indexedDB = globalThis.indexedDB;
} catch {}
indexedDB && setCryptoStoreFactory(() => new IndexedDBCryptoStore(indexedDB, "matrix-js-sdk:crypto")), globalThis.matrixcs = matrix_exports;
var eventemitter3_default = (/* @__PURE__ */ __toESM((/* @__PURE__ */ __commonJSMin(((e, p) => {
	var m = Object.prototype.hasOwnProperty, h = "~";
	function g() {}
	Object.create && (g.prototype = Object.create(null), new g().__proto__ || (h = !1));
	function _(e, p, m) {
		this.fn = e, this.context = p, this.once = m || !1;
	}
	function v(e, p, m, g, v) {
		if (typeof m != "function") throw TypeError("The listener must be a function");
		var y = new _(m, g || e, v), b = h ? h + p : p;
		return e._events[b] ? e._events[b].fn ? e._events[b] = [e._events[b], y] : e._events[b].push(y) : (e._events[b] = y, e._eventsCount++), e;
	}
	function y(e, p) {
		--e._eventsCount === 0 ? e._events = new g() : delete e._events[p];
	}
	function b() {
		this._events = new g(), this._eventsCount = 0;
	}
	b.prototype.eventNames = function() {
		var e = [], p, g;
		if (this._eventsCount === 0) return e;
		for (g in p = this._events) m.call(p, g) && e.push(h ? g.slice(1) : g);
		return Object.getOwnPropertySymbols ? e.concat(Object.getOwnPropertySymbols(p)) : e;
	}, b.prototype.listeners = function(e) {
		var p = h ? h + e : e, m = this._events[p];
		if (!m) return [];
		if (m.fn) return [m.fn];
		for (var g = 0, _ = m.length, v = Array(_); g < _; g++) v[g] = m[g].fn;
		return v;
	}, b.prototype.listenerCount = function(e) {
		var p = h ? h + e : e, m = this._events[p];
		return m ? m.fn ? 1 : m.length : 0;
	}, b.prototype.emit = function(e, p, m, g, _, v) {
		var y = h ? h + e : e;
		if (!this._events[y]) return !1;
		var b = this._events[y], x = arguments.length, S, C;
		if (b.fn) {
			switch (b.once && this.removeListener(e, b.fn, void 0, !0), x) {
				case 1: return b.fn.call(b.context), !0;
				case 2: return b.fn.call(b.context, p), !0;
				case 3: return b.fn.call(b.context, p, m), !0;
				case 4: return b.fn.call(b.context, p, m, g), !0;
				case 5: return b.fn.call(b.context, p, m, g, _), !0;
				case 6: return b.fn.call(b.context, p, m, g, _, v), !0;
			}
			for (C = 1, S = Array(x - 1); C < x; C++) S[C - 1] = arguments[C];
			b.fn.apply(b.context, S);
		} else {
			var w = b.length, T;
			for (C = 0; C < w; C++) switch (b[C].once && this.removeListener(e, b[C].fn, void 0, !0), x) {
				case 1:
					b[C].fn.call(b[C].context);
					break;
				case 2:
					b[C].fn.call(b[C].context, p);
					break;
				case 3:
					b[C].fn.call(b[C].context, p, m);
					break;
				case 4:
					b[C].fn.call(b[C].context, p, m, g);
					break;
				default:
					if (!S) for (T = 1, S = Array(x - 1); T < x; T++) S[T - 1] = arguments[T];
					b[C].fn.apply(b[C].context, S);
			}
		}
		return !0;
	}, b.prototype.on = function(e, p, m) {
		return v(this, e, p, m, !1);
	}, b.prototype.once = function(e, p, m) {
		return v(this, e, p, m, !0);
	}, b.prototype.removeListener = function(e, p, m, g) {
		var _ = h ? h + e : e;
		if (!this._events[_]) return this;
		if (!p) return y(this, _), this;
		var v = this._events[_];
		if (v.fn) v.fn === p && (!g || v.once) && (!m || v.context === m) && y(this, _);
		else {
			for (var b = 0, x = [], S = v.length; b < S; b++) (v[b].fn !== p || g && !v[b].once || m && v[b].context !== m) && x.push(v[b]);
			x.length ? this._events[_] = x.length === 1 ? x[0] : x : y(this, _);
		}
		return this;
	}, b.prototype.removeAllListeners = function(e) {
		var p;
		return e ? (p = h ? h + e : e, this._events[p] && y(this, p)) : (this._events = new g(), this._eventsCount = 0), this;
	}, b.prototype.off = b.prototype.removeListener, b.prototype.addListener = b.prototype.on, b.prefixed = h, b.EventEmitter = b, p !== void 0 && (p.exports = b);
})))(), 1)).default, Storage = class e {
	static {
		this.LOCALSTORAGE_KEY = "mxclient";
	}
	constructor() {
		this.data = {}, this.load();
	}
	load() {
		let p = localStorage.getItem(e.LOCALSTORAGE_KEY);
		if (p) try {
			this.data = JSON.parse(p), console.log(`[MXClient] Loaded ${Object.keys(this.data).length} settings`);
		} catch (e) {
			console.warn("[MXClient] Failed to parse localStorage config", e);
		}
	}
	save() {
		localStorage.setItem(e.LOCALSTORAGE_KEY, JSON.stringify(this.data));
	}
	get(e) {
		return this.data[e];
	}
	set(e, p) {
		this.data[e] = p, this.save();
	}
	has(e) {
		return this.get(e) !== void 0;
	}
	delete(e) {
		this.data[e] = void 0, this.save();
	}
}, import_lodash = /* @__PURE__ */ __toESM((/* @__PURE__ */ __commonJSMin(((e, p) => {
	var m = "Expected a function", h = NaN, g = "[object Symbol]", _ = /^\s+|\s+$/g, v = /^[-+]0x[0-9a-f]+$/i, y = /^0b[01]+$/i, b = /^0o[0-7]+$/i, x = parseInt, S = typeof global == "object" && global && global.Object === Object && global, C = typeof self == "object" && self && self.Object === Object && self, w = S || C || Function("return this")(), T = Object.prototype.toString, E = Math.max, D = Math.min, O = function() {
		return w.Date.now();
	};
	function k(e, p, h) {
		var g, _, v, y, b, x, S = 0, C = !1, w = !1, T = !0;
		if (typeof e != "function") throw TypeError(m);
		p = P(p) || 0, j(h) && (C = !!h.leading, w = "maxWait" in h, v = w ? E(P(h.maxWait) || 0, p) : v, T = "trailing" in h ? !!h.trailing : T);
		function k(p) {
			var m = g, h = _;
			return g = _ = void 0, S = p, y = e.apply(h, m), y;
		}
		function A(e) {
			return S = e, b = setTimeout(F, p), C ? k(e) : y;
		}
		function M(e) {
			var m = e - x, h = e - S, g = p - m;
			return w ? D(g, v - h) : g;
		}
		function N(e) {
			var m = e - x, h = e - S;
			return x === void 0 || m >= p || m < 0 || w && h >= v;
		}
		function F() {
			var e = O();
			if (N(e)) return I(e);
			b = setTimeout(F, M(e));
		}
		function I(e) {
			return b = void 0, T && g ? k(e) : (g = _ = void 0, y);
		}
		function L() {
			b !== void 0 && clearTimeout(b), S = 0, g = x = _ = b = void 0;
		}
		function R() {
			return b === void 0 ? y : I(O());
		}
		function z() {
			var e = O(), m = N(e);
			if (g = arguments, _ = this, x = e, m) {
				if (b === void 0) return A(x);
				if (w) return b = setTimeout(F, p), k(x);
			}
			return b === void 0 && (b = setTimeout(F, p)), y;
		}
		return z.cancel = L, z.flush = R, z;
	}
	function A(e, p, h) {
		var g = !0, _ = !0;
		if (typeof e != "function") throw TypeError(m);
		return j(h) && (g = "leading" in h ? !!h.leading : g, _ = "trailing" in h ? !!h.trailing : _), k(e, p, {
			leading: g,
			maxWait: p,
			trailing: _
		});
	}
	function j(e) {
		var p = typeof e;
		return !!e && (p == "object" || p == "function");
	}
	function M(e) {
		return !!e && typeof e == "object";
	}
	function N(e) {
		return typeof e == "symbol" || M(e) && T.call(e) == g;
	}
	function P(e) {
		if (typeof e == "number") return e;
		if (N(e)) return h;
		if (j(e)) {
			var p = typeof e.valueOf == "function" ? e.valueOf() : e;
			e = j(p) ? p + "" : p;
		}
		if (typeof e != "string") return e === 0 ? e : +e;
		e = e.replace(_, "");
		var m = y.test(e);
		return m || b.test(e) ? x(e.slice(2), m ? 2 : 8) : v.test(e) ? h : +e;
	}
	p.exports = A;
})))()), Sort$lastEvent = (e, p) => (p.getLastLiveEvent()?.localTimestamp ?? 0) - (e.getLastLiveEvent()?.localTimestamp ?? 0), MXRooms = class extends eventemitter3_default {
	constructor(e) {
		super(), this.Subscriptions = new MXRooms$Filter(this, (e) => {
			let p = e.getMyMembership();
			return !e.isSpaceRoom() && (p === KnownMembership.Join || p === KnownMembership.Knock);
		}, Sort$lastEvent), this.Invites = new MXRooms$Filter(this, (e) => e.getMyMembership() === KnownMembership.Invite, Sort$lastEvent), this.MXClient = e;
	}
	setupListeners(e) {
		e.once(ClientEvent.Sync, (p) => {
			if (p !== SyncState.Prepared) return;
			let m = e.getRooms();
			for (let e of m);
		}), e.on(ClientEvent.Room, (e) => {
			this.emit("new", e);
		}), e.on(ClientEvent.DeleteRoom, (e) => {
			this.emit("gone", e);
		}), e.on(ClientEvent.Event, (p) => {
			p.getType() === EventType.RoomMember && this.handleRoomMember(e, p);
		});
	}
	getRoom(e) {
		return this.MXClient.client.getRoom(e);
	}
	joinRoom(e) {
		return this.MXClient.client.joinRoom(e, { acceptSharedHistory: !0 });
	}
	leaveRoom(e) {
		return this.MXClient.client.leave(e);
	}
	handleRoomMember(e, p) {
		if (p.getStateKey() === e.getUserId()) switch (this.emit("membership", p.getRoomId(), p.getContent().membership), p.getContent().membership) {
			case "invite":
				this.emit("invite", p.getRoomId(), p);
				break;
			case "join": break;
			case "knock": break;
			case "leave":
				this.emit("gone", p.getRoomId());
				break;
			case "ban": break;
		}
	}
}, MXRooms$Filter = class extends eventemitter3_default {
	constructor(e, p, m) {
		super(), this.rooms = [];
		let h = (0, import_lodash.default)(() => {
			this.rooms.sort(m), this.emit("sync", [...this.rooms]);
		}, 250);
		e.on("new", (e) => {
			if (p(e)) {
				if (this.rooms.find((p) => p.roomId === e.roomId)) return;
				this.rooms.push(e), h();
			}
		}), e.on("gone", (e) => {
			let p = this.rooms.find((p) => p.roomId === e);
			if (!p) return;
			let m = this.rooms.indexOf(p);
			m !== -1 && (this.rooms.splice(m, 1), h());
		}), e.on("membership", (m, g) => {
			let _ = e.getRoom(m);
			if (_ && p(_)) {
				if (this.rooms.find((e) => e.roomId === m)) return;
				this.rooms.push(_), h();
			}
		});
	}
	get() {
		return [...this.rooms];
	}
}, NullLogger = class e {
	trace(...e) {}
	debug(...e) {}
	info(...e) {}
	warn(...e) {}
	error(...e) {}
	getChild(p) {
		return new e();
	}
}, initClient = (e, p) => createClient({
	baseUrl: "https://aftermath.gg",
	accessToken: e,
	userId: p,
	logger: new NullLogger()
}), MXClient = class e extends eventemitter3_default {
	constructor() {
		if (super(), this.client = initClient(), this.storage = new Storage(), this.rooms = new MXRooms(this), e.instance) throw Error("MXClient constructed while already instanced");
		if (window.MXClient = this, e.instance = this, this.storage.has("auth")) {
			console.log("[MXClient] I have an access token on init");
			let e = this.storage.get("auth");
			this.client = initClient(e.accessToken, e.userId), this.setupListeners();
		}
	}
	static get() {
		return e.instance ? e.instance : e.instance = new e();
	}
	destroy() {
		this.client.stopClient(), this.removeAllListeners(), e.instance = void 0, console.warn("MXClient destroyed");
	}
	getLoginUrl(e) {
		return this.client.getSsoLoginUrl(e);
	}
	async login() {
		let e = new URLSearchParams(window.location.search);
		if (!e.has("loginToken")) return console.warn("MXClient#login called but no loginToken found"), !1;
		let p = e.get("loginToken");
		e.delete("loginToken");
		let m = new URL(window.location.href);
		m.search = e.toString(), window.history.replaceState({}, "", m);
		let h = await this.client.loginRequest({
			type: "m.login.token",
			token: p
		});
		return this.client = initClient(h.access_token, h.user_id), this.setupListeners(), this.storage.set("auth", {
			accessToken: h.access_token,
			userId: h.user_id
		}), !0;
	}
	async logout() {
		await this.client.logout(!0), this.storage.delete("auth");
	}
	setupListeners() {
		this.client.startClient().then(() => {
			console.log("client started"), this.emit("me", { userId: this.client.getUserId() });
		}).catch((e) => console.error("client error", e)), this.client.on(ClientEvent.Sync, (e, p, m) => {
			console.log("state set", e);
		}), this.client.on(RoomEvent.Timeline, (e, p, m, h, g) => {}), this.rooms.setupListeners(this.client);
	}
	sendMessage(e, p) {
		return this.client.sendTextMessage(e, p);
	}
};
const useYap = () => useContext(context), context = createContext(null);
var flattenRoom = (e) => ({
	...e[1],
	roomId: e[0]
});
const getOpenRooms = (e) => Object.entries(e.rooms).filter(([, e]) => e.open).map(flattenRoom);
export { TimelineWindow as a, MXClient as i, getOpenRooms as n, useYap as r, context as t };
